
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6330"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6330"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kQfpd", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f2c49d36ff853345$export$ffb0004e005737fa, (v) => $f2c49d36ff853345$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $f2c49d36ff853345$export$34b9dba7ce09269b, (v) => $f2c49d36ff853345$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $f2c49d36ff853345$export$25062201e9e25d76, (v) => $f2c49d36ff853345$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f2c49d36ff853345$export$ffb0004e005737fa;
var $f2c49d36ff853345$export$34b9dba7ce09269b;
var $f2c49d36ff853345$export$25062201e9e25d76;
"use strict";
var $f2c49d36ff853345$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f2c49d36ff853345$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $f2c49d36ff853345$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $f2c49d36ff853345$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$f2c49d36ff853345$export$ffb0004e005737fa = $f2c49d36ff853345$var$REACT_FRAGMENT_TYPE;
$f2c49d36ff853345$export$34b9dba7ce09269b = $f2c49d36ff853345$var$jsxProd;
$f2c49d36ff853345$export$25062201e9e25d76 = $f2c49d36ff853345$var$jsxProd;

});

parcelRegister("3WPYT", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $2dff1c3b98c2ac71$export$9c16c1426311996d, (v) => $2dff1c3b98c2ac71$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $2dff1c3b98c2ac71$export$dca3b0875bd9a954, (v) => $2dff1c3b98c2ac71$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $2dff1c3b98c2ac71$export$16fa2f45be04daa8, (v) => $2dff1c3b98c2ac71$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $2dff1c3b98c2ac71$export$ffb0004e005737fa, (v) => $2dff1c3b98c2ac71$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $2dff1c3b98c2ac71$export$e2c29f18771995cb, (v) => $2dff1c3b98c2ac71$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $2dff1c3b98c2ac71$export$221d75b3f55bb0bd, (v) => $2dff1c3b98c2ac71$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $2dff1c3b98c2ac71$export$5f8d39834fd61797, (v) => $2dff1c3b98c2ac71$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2dff1c3b98c2ac71$export$74bf444e3cd11ea5, (v) => $2dff1c3b98c2ac71$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $2dff1c3b98c2ac71$export$1ced07cd6b1985ce, (v) => $2dff1c3b98c2ac71$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $2dff1c3b98c2ac71$export$abd8e32b826d7ea7, (v) => $2dff1c3b98c2ac71$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $2dff1c3b98c2ac71$export$69a3209f1a06c04d, (v) => $2dff1c3b98c2ac71$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $2dff1c3b98c2ac71$export$8c538325882c7eec, (v) => $2dff1c3b98c2ac71$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $2dff1c3b98c2ac71$export$e530037191fcd5d7, (v) => $2dff1c3b98c2ac71$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $2dff1c3b98c2ac71$export$fd42f52fd3ae1109, (v) => $2dff1c3b98c2ac71$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $2dff1c3b98c2ac71$export$c8a8987d4410bf2d, (v) => $2dff1c3b98c2ac71$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $2dff1c3b98c2ac71$export$7d1e3a5e95ceca43, (v) => $2dff1c3b98c2ac71$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $2dff1c3b98c2ac71$export$257a8862b851cb5b, (v) => $2dff1c3b98c2ac71$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $2dff1c3b98c2ac71$export$a8257692ac88316c, (v) => $2dff1c3b98c2ac71$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $2dff1c3b98c2ac71$export$488013bae63b21da, (v) => $2dff1c3b98c2ac71$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $2dff1c3b98c2ac71$export$7c73462e0d25e514, (v) => $2dff1c3b98c2ac71$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $2dff1c3b98c2ac71$export$7568632d0d33d16d, (v) => $2dff1c3b98c2ac71$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $2dff1c3b98c2ac71$export$f93f40ac0ca7e3a8, (v) => $2dff1c3b98c2ac71$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $2dff1c3b98c2ac71$export$1f96ae73734a86cc, (v) => $2dff1c3b98c2ac71$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $2dff1c3b98c2ac71$export$9a47ced3238df325, (v) => $2dff1c3b98c2ac71$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $2dff1c3b98c2ac71$export$35808ee640e87ca7, (v) => $2dff1c3b98c2ac71$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $2dff1c3b98c2ac71$export$fae74005e78b1a27, (v) => $2dff1c3b98c2ac71$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $2dff1c3b98c2ac71$export$dc8fbce3eb94dc1e, (v) => $2dff1c3b98c2ac71$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $2dff1c3b98c2ac71$export$6a7bc4e911dc01cf, (v) => $2dff1c3b98c2ac71$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $2dff1c3b98c2ac71$export$6d9c69b0de29b591, (v) => $2dff1c3b98c2ac71$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $2dff1c3b98c2ac71$export$7f54fc3180508a52, (v) => $2dff1c3b98c2ac71$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $2dff1c3b98c2ac71$export$f680877a34711e37, (v) => $2dff1c3b98c2ac71$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $2dff1c3b98c2ac71$export$d5a552a76deda3c2, (v) => $2dff1c3b98c2ac71$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $2dff1c3b98c2ac71$export$aaabe4eda9ed9969, (v) => $2dff1c3b98c2ac71$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $2dff1c3b98c2ac71$export$e5c5a5f917a5871c, (v) => $2dff1c3b98c2ac71$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $2dff1c3b98c2ac71$export$1538c33de8887b59, (v) => $2dff1c3b98c2ac71$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $2dff1c3b98c2ac71$export$fca7f784ae7a249a, (v) => $2dff1c3b98c2ac71$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $2dff1c3b98c2ac71$export$13e3392192263954, (v) => $2dff1c3b98c2ac71$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $2dff1c3b98c2ac71$export$b8f5890fc79d6aca, (v) => $2dff1c3b98c2ac71$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $2dff1c3b98c2ac71$export$60241385465d0a34, (v) => $2dff1c3b98c2ac71$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $2dff1c3b98c2ac71$export$306c0aa65ff9ec16, (v) => $2dff1c3b98c2ac71$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $2dff1c3b98c2ac71$export$7b286972b8d8ccbf, (v) => $2dff1c3b98c2ac71$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $2dff1c3b98c2ac71$export$83d89fbfd8236492, (v) => $2dff1c3b98c2ac71$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2dff1c3b98c2ac71$export$9c16c1426311996d;
var $2dff1c3b98c2ac71$export$dca3b0875bd9a954;
var $2dff1c3b98c2ac71$export$16fa2f45be04daa8;
var $2dff1c3b98c2ac71$export$ffb0004e005737fa;
var $2dff1c3b98c2ac71$export$e2c29f18771995cb;
var $2dff1c3b98c2ac71$export$221d75b3f55bb0bd;
var $2dff1c3b98c2ac71$export$5f8d39834fd61797;
var $2dff1c3b98c2ac71$export$74bf444e3cd11ea5;
var $2dff1c3b98c2ac71$export$1ced07cd6b1985ce;
var $2dff1c3b98c2ac71$export$abd8e32b826d7ea7;
var $2dff1c3b98c2ac71$export$69a3209f1a06c04d;
var $2dff1c3b98c2ac71$export$8c538325882c7eec;
var $2dff1c3b98c2ac71$export$e530037191fcd5d7;
var $2dff1c3b98c2ac71$export$fd42f52fd3ae1109;
var $2dff1c3b98c2ac71$export$c8a8987d4410bf2d;
var $2dff1c3b98c2ac71$export$7d1e3a5e95ceca43;
var $2dff1c3b98c2ac71$export$257a8862b851cb5b;
var $2dff1c3b98c2ac71$export$a8257692ac88316c;
var $2dff1c3b98c2ac71$export$488013bae63b21da;
var $2dff1c3b98c2ac71$export$7c73462e0d25e514;
var $2dff1c3b98c2ac71$export$7568632d0d33d16d;
var $2dff1c3b98c2ac71$export$f93f40ac0ca7e3a8;
var $2dff1c3b98c2ac71$export$1f96ae73734a86cc;
var $2dff1c3b98c2ac71$export$9a47ced3238df325;
var $2dff1c3b98c2ac71$export$35808ee640e87ca7;
var $2dff1c3b98c2ac71$export$fae74005e78b1a27;
var $2dff1c3b98c2ac71$export$dc8fbce3eb94dc1e;
var $2dff1c3b98c2ac71$export$6a7bc4e911dc01cf;
var $2dff1c3b98c2ac71$export$6d9c69b0de29b591;
var $2dff1c3b98c2ac71$export$7f54fc3180508a52;
var $2dff1c3b98c2ac71$export$f680877a34711e37;
var $2dff1c3b98c2ac71$export$d5a552a76deda3c2;
var $2dff1c3b98c2ac71$export$aaabe4eda9ed9969;
var $2dff1c3b98c2ac71$export$e5c5a5f917a5871c;
var $2dff1c3b98c2ac71$export$1538c33de8887b59;
var $2dff1c3b98c2ac71$export$fca7f784ae7a249a;
var $2dff1c3b98c2ac71$export$13e3392192263954;
var $2dff1c3b98c2ac71$export$b8f5890fc79d6aca;
var $2dff1c3b98c2ac71$export$60241385465d0a34;
var $2dff1c3b98c2ac71$export$306c0aa65ff9ec16;
var $2dff1c3b98c2ac71$export$7b286972b8d8ccbf;
var $2dff1c3b98c2ac71$export$83d89fbfd8236492;
"use strict";
var $2dff1c3b98c2ac71$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2dff1c3b98c2ac71$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2dff1c3b98c2ac71$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2dff1c3b98c2ac71$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2dff1c3b98c2ac71$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2dff1c3b98c2ac71$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2dff1c3b98c2ac71$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2dff1c3b98c2ac71$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2dff1c3b98c2ac71$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2dff1c3b98c2ac71$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2dff1c3b98c2ac71$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $2dff1c3b98c2ac71$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $2dff1c3b98c2ac71$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $2dff1c3b98c2ac71$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $2dff1c3b98c2ac71$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$2dff1c3b98c2ac71$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $2dff1c3b98c2ac71$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $2dff1c3b98c2ac71$var$assign = Object.assign, $2dff1c3b98c2ac71$var$emptyObject = {};
function $2dff1c3b98c2ac71$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $2dff1c3b98c2ac71$var$emptyObject;
    this.updater = updater || $2dff1c3b98c2ac71$var$ReactNoopUpdateQueue;
}
$2dff1c3b98c2ac71$var$Component.prototype.isReactComponent = {};
$2dff1c3b98c2ac71$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$2dff1c3b98c2ac71$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $2dff1c3b98c2ac71$var$ComponentDummy() {}
$2dff1c3b98c2ac71$var$ComponentDummy.prototype = $2dff1c3b98c2ac71$var$Component.prototype;
function $2dff1c3b98c2ac71$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $2dff1c3b98c2ac71$var$emptyObject;
    this.updater = updater || $2dff1c3b98c2ac71$var$ReactNoopUpdateQueue;
}
var $2dff1c3b98c2ac71$var$pureComponentPrototype = $2dff1c3b98c2ac71$var$PureComponent.prototype = new $2dff1c3b98c2ac71$var$ComponentDummy();
$2dff1c3b98c2ac71$var$pureComponentPrototype.constructor = $2dff1c3b98c2ac71$var$PureComponent;
$2dff1c3b98c2ac71$var$assign($2dff1c3b98c2ac71$var$pureComponentPrototype, $2dff1c3b98c2ac71$var$Component.prototype);
$2dff1c3b98c2ac71$var$pureComponentPrototype.isPureReactComponent = !0;
var $2dff1c3b98c2ac71$var$isArrayImpl = Array.isArray;
function $2dff1c3b98c2ac71$var$noop() {}
var $2dff1c3b98c2ac71$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $2dff1c3b98c2ac71$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2dff1c3b98c2ac71$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $2dff1c3b98c2ac71$var$cloneAndReplaceKey(oldElement, newKey) {
    return $2dff1c3b98c2ac71$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $2dff1c3b98c2ac71$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $2dff1c3b98c2ac71$var$REACT_ELEMENT_TYPE;
}
function $2dff1c3b98c2ac71$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $2dff1c3b98c2ac71$var$userProvidedKeyEscapeRegex = /\/+/g;
function $2dff1c3b98c2ac71$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $2dff1c3b98c2ac71$var$escape("" + element.key) : index.toString(36);
}
function $2dff1c3b98c2ac71$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($2dff1c3b98c2ac71$var$noop, $2dff1c3b98c2ac71$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $2dff1c3b98c2ac71$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $2dff1c3b98c2ac71$var$REACT_ELEMENT_TYPE:
                case $2dff1c3b98c2ac71$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $2dff1c3b98c2ac71$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $2dff1c3b98c2ac71$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $2dff1c3b98c2ac71$var$getElementKey(children, 0) : nameSoFar, $2dff1c3b98c2ac71$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($2dff1c3b98c2ac71$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $2dff1c3b98c2ac71$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($2dff1c3b98c2ac71$var$isValidElement(callback) && (callback = $2dff1c3b98c2ac71$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($2dff1c3b98c2ac71$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($2dff1c3b98c2ac71$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $2dff1c3b98c2ac71$var$getElementKey(nameSoFar, i), invokeCallback += $2dff1c3b98c2ac71$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $2dff1c3b98c2ac71$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $2dff1c3b98c2ac71$var$getElementKey(nameSoFar, i++), invokeCallback += $2dff1c3b98c2ac71$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $2dff1c3b98c2ac71$var$mapIntoArray($2dff1c3b98c2ac71$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $2dff1c3b98c2ac71$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $2dff1c3b98c2ac71$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $2dff1c3b98c2ac71$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $2dff1c3b98c2ac71$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $2dff1c3b98c2ac71$var$Children = {
    map: $2dff1c3b98c2ac71$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $2dff1c3b98c2ac71$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $2dff1c3b98c2ac71$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $2dff1c3b98c2ac71$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$2dff1c3b98c2ac71$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$2dff1c3b98c2ac71$export$9c16c1426311996d = $2dff1c3b98c2ac71$var$REACT_ACTIVITY_TYPE;
$2dff1c3b98c2ac71$export$dca3b0875bd9a954 = $2dff1c3b98c2ac71$var$Children;
$2dff1c3b98c2ac71$export$16fa2f45be04daa8 = $2dff1c3b98c2ac71$var$Component;
$2dff1c3b98c2ac71$export$ffb0004e005737fa = $2dff1c3b98c2ac71$var$REACT_FRAGMENT_TYPE;
$2dff1c3b98c2ac71$export$e2c29f18771995cb = $2dff1c3b98c2ac71$var$REACT_PROFILER_TYPE;
$2dff1c3b98c2ac71$export$221d75b3f55bb0bd = $2dff1c3b98c2ac71$var$PureComponent;
$2dff1c3b98c2ac71$export$5f8d39834fd61797 = $2dff1c3b98c2ac71$var$REACT_STRICT_MODE_TYPE;
$2dff1c3b98c2ac71$export$74bf444e3cd11ea5 = $2dff1c3b98c2ac71$var$REACT_SUSPENSE_TYPE;
$2dff1c3b98c2ac71$export$1ced07cd6b1985ce = $2dff1c3b98c2ac71$var$ReactSharedInternals;
$2dff1c3b98c2ac71$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$2dff1c3b98c2ac71$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$2dff1c3b98c2ac71$export$8c538325882c7eec = function() {
    return null;
};
$2dff1c3b98c2ac71$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $2dff1c3b98c2ac71$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$2dff1c3b98c2ac71$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $2dff1c3b98c2ac71$var$ReactElement(element.type, key, props);
};
$2dff1c3b98c2ac71$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$2dff1c3b98c2ac71$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$2dff1c3b98c2ac71$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $2dff1c3b98c2ac71$var$ReactElement(type, key, props);
};
$2dff1c3b98c2ac71$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$2dff1c3b98c2ac71$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$2dff1c3b98c2ac71$export$a8257692ac88316c = $2dff1c3b98c2ac71$var$isValidElement;
$2dff1c3b98c2ac71$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $2dff1c3b98c2ac71$var$lazyInitializer
    };
};
$2dff1c3b98c2ac71$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$2dff1c3b98c2ac71$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $2dff1c3b98c2ac71$var$ReactSharedInternals.T, currentTransition = {};
    $2dff1c3b98c2ac71$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $2dff1c3b98c2ac71$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($2dff1c3b98c2ac71$var$noop, $2dff1c3b98c2ac71$var$reportGlobalError);
    } catch (error) {
        $2dff1c3b98c2ac71$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2dff1c3b98c2ac71$var$ReactSharedInternals.T = prevTransition;
    }
};
$2dff1c3b98c2ac71$export$f93f40ac0ca7e3a8 = function() {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useCacheRefresh();
};
$2dff1c3b98c2ac71$export$1f96ae73734a86cc = function(usable) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.use(usable);
};
$2dff1c3b98c2ac71$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$2dff1c3b98c2ac71$export$35808ee640e87ca7 = function(callback, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$2dff1c3b98c2ac71$export$fae74005e78b1a27 = function(Context) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useContext(Context);
};
$2dff1c3b98c2ac71$export$dc8fbce3eb94dc1e = function() {};
$2dff1c3b98c2ac71$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$2dff1c3b98c2ac71$export$6d9c69b0de29b591 = function(create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useEffect(create, deps);
};
$2dff1c3b98c2ac71$export$7f54fc3180508a52 = function(callback) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$2dff1c3b98c2ac71$export$f680877a34711e37 = function() {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useId();
};
$2dff1c3b98c2ac71$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$2dff1c3b98c2ac71$export$aaabe4eda9ed9969 = function(create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$2dff1c3b98c2ac71$export$e5c5a5f917a5871c = function(create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$2dff1c3b98c2ac71$export$1538c33de8887b59 = function(create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useMemo(create, deps);
};
$2dff1c3b98c2ac71$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$2dff1c3b98c2ac71$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$2dff1c3b98c2ac71$export$b8f5890fc79d6aca = function(initialValue) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useRef(initialValue);
};
$2dff1c3b98c2ac71$export$60241385465d0a34 = function(initialState) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useState(initialState);
};
$2dff1c3b98c2ac71$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$2dff1c3b98c2ac71$export$7b286972b8d8ccbf = function() {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useTransition();
};
$2dff1c3b98c2ac71$export$83d89fbfd8236492 = "19.2.6";

});

parcelRegister("hoNSH", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $caab5ef096c4d11c$export$2b8d127b894957b9, (v) => $caab5ef096c4d11c$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $caab5ef096c4d11c$export$cea3a54a6425200c, (v) => $caab5ef096c4d11c$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $caab5ef096c4d11c$export$a7c73072b1a182ae, (v) => $caab5ef096c4d11c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $caab5ef096c4d11c$export$9f27bc3417b4524d, (v) => $caab5ef096c4d11c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $caab5ef096c4d11c$export$db77ccec0bb4ccac, (v) => $caab5ef096c4d11c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $caab5ef096c4d11c$export$8392c0c9d3dcbd35, (v) => $caab5ef096c4d11c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $caab5ef096c4d11c$export$ffb0004e005737fa, (v) => $caab5ef096c4d11c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $caab5ef096c4d11c$export$b624eff549462981, (v) => $caab5ef096c4d11c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $caab5ef096c4d11c$export$7897aa7841a5380c, (v) => $caab5ef096c4d11c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $caab5ef096c4d11c$export$602eac185826482c, (v) => $caab5ef096c4d11c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $caab5ef096c4d11c$export$e2c29f18771995cb, (v) => $caab5ef096c4d11c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $caab5ef096c4d11c$export$5f8d39834fd61797, (v) => $caab5ef096c4d11c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $caab5ef096c4d11c$export$74bf444e3cd11ea5, (v) => $caab5ef096c4d11c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $caab5ef096c4d11c$export$92387174baf9b227, (v) => $caab5ef096c4d11c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $caab5ef096c4d11c$export$ec112efeb987d9c6, (v) => $caab5ef096c4d11c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $caab5ef096c4d11c$export$b706b080d889d2c9, (v) => $caab5ef096c4d11c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $caab5ef096c4d11c$export$5be5a87408f70ddc, (v) => $caab5ef096c4d11c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $caab5ef096c4d11c$export$45a5e7f76e0caa8d, (v) => $caab5ef096c4d11c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $caab5ef096c4d11c$export$455c2e768291efa6, (v) => $caab5ef096c4d11c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $caab5ef096c4d11c$export$9522e17588c12572, (v) => $caab5ef096c4d11c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $caab5ef096c4d11c$export$2110ac352bb060b9, (v) => $caab5ef096c4d11c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $caab5ef096c4d11c$export$56885ab8b9c456ab, (v) => $caab5ef096c4d11c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $caab5ef096c4d11c$export$d927fcb6adf8f9de, (v) => $caab5ef096c4d11c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $caab5ef096c4d11c$export$b82d16f27459e05a, (v) => $caab5ef096c4d11c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $caab5ef096c4d11c$export$522c17b4f5e123e8, (v) => $caab5ef096c4d11c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $caab5ef096c4d11c$export$1aabd8a0274ecfd6, (v) => $caab5ef096c4d11c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $caab5ef096c4d11c$export$9b621391a187a31a, (v) => $caab5ef096c4d11c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $caab5ef096c4d11c$export$f5bbd400c2f4426f, (v) => $caab5ef096c4d11c$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $caab5ef096c4d11c$export$2b8d127b894957b9;
var $caab5ef096c4d11c$export$cea3a54a6425200c;
var $caab5ef096c4d11c$export$a7c73072b1a182ae;
var $caab5ef096c4d11c$export$9f27bc3417b4524d;
var $caab5ef096c4d11c$export$db77ccec0bb4ccac;
var $caab5ef096c4d11c$export$8392c0c9d3dcbd35;
var $caab5ef096c4d11c$export$ffb0004e005737fa;
var $caab5ef096c4d11c$export$b624eff549462981;
var $caab5ef096c4d11c$export$7897aa7841a5380c;
var $caab5ef096c4d11c$export$602eac185826482c;
var $caab5ef096c4d11c$export$e2c29f18771995cb;
var $caab5ef096c4d11c$export$5f8d39834fd61797;
var $caab5ef096c4d11c$export$74bf444e3cd11ea5;
var $caab5ef096c4d11c$export$92387174baf9b227;
var $caab5ef096c4d11c$export$ec112efeb987d9c6;
var $caab5ef096c4d11c$export$b706b080d889d2c9;
var $caab5ef096c4d11c$export$5be5a87408f70ddc;
var $caab5ef096c4d11c$export$45a5e7f76e0caa8d;
var $caab5ef096c4d11c$export$455c2e768291efa6;
var $caab5ef096c4d11c$export$9522e17588c12572;
var $caab5ef096c4d11c$export$2110ac352bb060b9;
var $caab5ef096c4d11c$export$56885ab8b9c456ab;
var $caab5ef096c4d11c$export$d927fcb6adf8f9de;
var $caab5ef096c4d11c$export$b82d16f27459e05a;
var $caab5ef096c4d11c$export$522c17b4f5e123e8;
var $caab5ef096c4d11c$export$1aabd8a0274ecfd6;
var $caab5ef096c4d11c$export$9b621391a187a31a;
var $caab5ef096c4d11c$export$f5bbd400c2f4426f;
'use strict';
var $caab5ef096c4d11c$var$b = "function" === typeof Symbol && Symbol.for, $caab5ef096c4d11c$var$c = $caab5ef096c4d11c$var$b ? Symbol.for("react.element") : 60103, $caab5ef096c4d11c$var$d = $caab5ef096c4d11c$var$b ? Symbol.for("react.portal") : 60106, $caab5ef096c4d11c$var$e = $caab5ef096c4d11c$var$b ? Symbol.for("react.fragment") : 60107, $caab5ef096c4d11c$var$f = $caab5ef096c4d11c$var$b ? Symbol.for("react.strict_mode") : 60108, $caab5ef096c4d11c$var$g = $caab5ef096c4d11c$var$b ? Symbol.for("react.profiler") : 60114, $caab5ef096c4d11c$var$h = $caab5ef096c4d11c$var$b ? Symbol.for("react.provider") : 60109, $caab5ef096c4d11c$var$k = $caab5ef096c4d11c$var$b ? Symbol.for("react.context") : 60110, $caab5ef096c4d11c$var$l = $caab5ef096c4d11c$var$b ? Symbol.for("react.async_mode") : 60111, $caab5ef096c4d11c$var$m = $caab5ef096c4d11c$var$b ? Symbol.for("react.concurrent_mode") : 60111, $caab5ef096c4d11c$var$n = $caab5ef096c4d11c$var$b ? Symbol.for("react.forward_ref") : 60112, $caab5ef096c4d11c$var$p = $caab5ef096c4d11c$var$b ? Symbol.for("react.suspense") : 60113, $caab5ef096c4d11c$var$q = $caab5ef096c4d11c$var$b ? Symbol.for("react.suspense_list") : 60120, $caab5ef096c4d11c$var$r = $caab5ef096c4d11c$var$b ? Symbol.for("react.memo") : 60115, $caab5ef096c4d11c$var$t = $caab5ef096c4d11c$var$b ? Symbol.for("react.lazy") : 60116, $caab5ef096c4d11c$var$v = $caab5ef096c4d11c$var$b ? Symbol.for("react.block") : 60121, $caab5ef096c4d11c$var$w = $caab5ef096c4d11c$var$b ? Symbol.for("react.fundamental") : 60117, $caab5ef096c4d11c$var$x = $caab5ef096c4d11c$var$b ? Symbol.for("react.responder") : 60118, $caab5ef096c4d11c$var$y = $caab5ef096c4d11c$var$b ? Symbol.for("react.scope") : 60119;
function $caab5ef096c4d11c$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $caab5ef096c4d11c$var$c:
                switch(a = a.type, a){
                    case $caab5ef096c4d11c$var$l:
                    case $caab5ef096c4d11c$var$m:
                    case $caab5ef096c4d11c$var$e:
                    case $caab5ef096c4d11c$var$g:
                    case $caab5ef096c4d11c$var$f:
                    case $caab5ef096c4d11c$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $caab5ef096c4d11c$var$k:
                            case $caab5ef096c4d11c$var$n:
                            case $caab5ef096c4d11c$var$t:
                            case $caab5ef096c4d11c$var$r:
                            case $caab5ef096c4d11c$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $caab5ef096c4d11c$var$d:
                return u;
        }
    }
}
function $caab5ef096c4d11c$var$A(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$m;
}
$caab5ef096c4d11c$export$2b8d127b894957b9 = $caab5ef096c4d11c$var$l;
$caab5ef096c4d11c$export$cea3a54a6425200c = $caab5ef096c4d11c$var$m;
$caab5ef096c4d11c$export$a7c73072b1a182ae = $caab5ef096c4d11c$var$k;
$caab5ef096c4d11c$export$9f27bc3417b4524d = $caab5ef096c4d11c$var$h;
$caab5ef096c4d11c$export$db77ccec0bb4ccac = $caab5ef096c4d11c$var$c;
$caab5ef096c4d11c$export$8392c0c9d3dcbd35 = $caab5ef096c4d11c$var$n;
$caab5ef096c4d11c$export$ffb0004e005737fa = $caab5ef096c4d11c$var$e;
$caab5ef096c4d11c$export$b624eff549462981 = $caab5ef096c4d11c$var$t;
$caab5ef096c4d11c$export$7897aa7841a5380c = $caab5ef096c4d11c$var$r;
$caab5ef096c4d11c$export$602eac185826482c = $caab5ef096c4d11c$var$d;
$caab5ef096c4d11c$export$e2c29f18771995cb = $caab5ef096c4d11c$var$g;
$caab5ef096c4d11c$export$5f8d39834fd61797 = $caab5ef096c4d11c$var$f;
$caab5ef096c4d11c$export$74bf444e3cd11ea5 = $caab5ef096c4d11c$var$p;
$caab5ef096c4d11c$export$92387174baf9b227 = function(a) {
    return $caab5ef096c4d11c$var$A(a) || $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$l;
};
$caab5ef096c4d11c$export$ec112efeb987d9c6 = $caab5ef096c4d11c$var$A;
$caab5ef096c4d11c$export$b706b080d889d2c9 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$k;
};
$caab5ef096c4d11c$export$5be5a87408f70ddc = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$h;
};
$caab5ef096c4d11c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $caab5ef096c4d11c$var$c;
};
$caab5ef096c4d11c$export$455c2e768291efa6 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$n;
};
$caab5ef096c4d11c$export$9522e17588c12572 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$e;
};
$caab5ef096c4d11c$export$2110ac352bb060b9 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$t;
};
$caab5ef096c4d11c$export$56885ab8b9c456ab = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$r;
};
$caab5ef096c4d11c$export$d927fcb6adf8f9de = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$d;
};
$caab5ef096c4d11c$export$b82d16f27459e05a = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$g;
};
$caab5ef096c4d11c$export$522c17b4f5e123e8 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$f;
};
$caab5ef096c4d11c$export$1aabd8a0274ecfd6 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$p;
};
$caab5ef096c4d11c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $caab5ef096c4d11c$var$e || a === $caab5ef096c4d11c$var$m || a === $caab5ef096c4d11c$var$g || a === $caab5ef096c4d11c$var$f || a === $caab5ef096c4d11c$var$p || a === $caab5ef096c4d11c$var$q || "object" === typeof a && null !== a && (a.$$typeof === $caab5ef096c4d11c$var$t || a.$$typeof === $caab5ef096c4d11c$var$r || a.$$typeof === $caab5ef096c4d11c$var$h || a.$$typeof === $caab5ef096c4d11c$var$k || a.$$typeof === $caab5ef096c4d11c$var$n || a.$$typeof === $caab5ef096c4d11c$var$w || a.$$typeof === $caab5ef096c4d11c$var$x || a.$$typeof === $caab5ef096c4d11c$var$y || a.$$typeof === $caab5ef096c4d11c$var$v);
};
$caab5ef096c4d11c$export$f5bbd400c2f4426f = $caab5ef096c4d11c$var$z;

});

parcelRegister("kUzXm", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $f394edd4427d52c3$export$882461b6382ed46c, (v) => $f394edd4427d52c3$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $f394edd4427d52c3$export$757ceba2d55c277e, (v) => $f394edd4427d52c3$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $f394edd4427d52c3$export$83d89fbfd8236492, (v) => $f394edd4427d52c3$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f394edd4427d52c3$export$882461b6382ed46c;
var $f394edd4427d52c3$export$757ceba2d55c277e;
var $f394edd4427d52c3$export$83d89fbfd8236492;
"use strict";

var $kkkYV = parcelRequire("kkkYV");

var $7pfQ9 = parcelRequire("7pfQ9");

var $3G714 = parcelRequire("3G714");
function $f394edd4427d52c3$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $f394edd4427d52c3$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $f394edd4427d52c3$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $f394edd4427d52c3$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $f394edd4427d52c3$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $f394edd4427d52c3$var$assertIsMounted(fiber) {
    if ($f394edd4427d52c3$var$getNearestMountedFiber(fiber) !== fiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
}
function $f394edd4427d52c3$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $f394edd4427d52c3$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $f394edd4427d52c3$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $f394edd4427d52c3$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $f394edd4427d52c3$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $f394edd4427d52c3$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $f394edd4427d52c3$var$assign = Object.assign, $f394edd4427d52c3$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $f394edd4427d52c3$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f394edd4427d52c3$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f394edd4427d52c3$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f394edd4427d52c3$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $f394edd4427d52c3$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f394edd4427d52c3$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f394edd4427d52c3$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f394edd4427d52c3$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f394edd4427d52c3$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $f394edd4427d52c3$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f394edd4427d52c3$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $f394edd4427d52c3$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $f394edd4427d52c3$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $f394edd4427d52c3$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $f394edd4427d52c3$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $f394edd4427d52c3$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$f394edd4427d52c3$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $f394edd4427d52c3$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $f394edd4427d52c3$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $f394edd4427d52c3$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $f394edd4427d52c3$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $f394edd4427d52c3$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $f394edd4427d52c3$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $f394edd4427d52c3$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $f394edd4427d52c3$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $f394edd4427d52c3$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $f394edd4427d52c3$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $f394edd4427d52c3$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $f394edd4427d52c3$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $f394edd4427d52c3$var$getComponentNameFromType(type.type) || "Memo";
        case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $f394edd4427d52c3$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $f394edd4427d52c3$var$isArrayImpl = Array.isArray, $f394edd4427d52c3$var$ReactSharedInternals = $7pfQ9.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f394edd4427d52c3$var$ReactDOMSharedInternals = $3G714.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f394edd4427d52c3$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $f394edd4427d52c3$var$valueStack = [], $f394edd4427d52c3$var$index = -1;
function $f394edd4427d52c3$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $f394edd4427d52c3$var$pop(cursor) {
    0 > $f394edd4427d52c3$var$index || (cursor.current = $f394edd4427d52c3$var$valueStack[$f394edd4427d52c3$var$index], $f394edd4427d52c3$var$valueStack[$f394edd4427d52c3$var$index] = null, $f394edd4427d52c3$var$index--);
}
function $f394edd4427d52c3$var$push(cursor, value) {
    $f394edd4427d52c3$var$index++;
    $f394edd4427d52c3$var$valueStack[$f394edd4427d52c3$var$index] = cursor.current;
    cursor.current = value;
}
var $f394edd4427d52c3$var$contextStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$contextFiberStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$rootInstanceStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$hostTransitionProviderCursor = $f394edd4427d52c3$var$createCursor(null);
function $f394edd4427d52c3$var$pushHostContainer(fiber, nextRootInstance) {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$rootInstanceStackCursor, nextRootInstance);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextFiberStackCursor, fiber);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $f394edd4427d52c3$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $f394edd4427d52c3$var$getOwnHostContext(nextRootInstance), fiber = $f394edd4427d52c3$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextStackCursor);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextStackCursor, fiber);
}
function $f394edd4427d52c3$var$popHostContainer() {
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextStackCursor);
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextFiberStackCursor);
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$rootInstanceStackCursor);
}
function $f394edd4427d52c3$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $f394edd4427d52c3$var$push($f394edd4427d52c3$var$hostTransitionProviderCursor, fiber);
    var context = $f394edd4427d52c3$var$contextStackCursor.current;
    var JSCompiler_inline_result = $f394edd4427d52c3$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextFiberStackCursor, fiber), $f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextStackCursor, JSCompiler_inline_result));
}
function $f394edd4427d52c3$var$popHostContext(fiber) {
    $f394edd4427d52c3$var$contextFiberStackCursor.current === fiber && ($f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextStackCursor), $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextFiberStackCursor));
    $f394edd4427d52c3$var$hostTransitionProviderCursor.current === fiber && ($f394edd4427d52c3$var$pop($f394edd4427d52c3$var$hostTransitionProviderCursor), $f394edd4427d52c3$var$HostTransitionContext._currentValue = $f394edd4427d52c3$var$sharedNotPendingObject);
}
var $f394edd4427d52c3$var$prefix, $f394edd4427d52c3$var$suffix;
function $f394edd4427d52c3$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $f394edd4427d52c3$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $f394edd4427d52c3$var$prefix = match && match[1] || "";
        $f394edd4427d52c3$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $f394edd4427d52c3$var$prefix + name + $f394edd4427d52c3$var$suffix;
}
var $f394edd4427d52c3$var$reentry = !1;
function $f394edd4427d52c3$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $f394edd4427d52c3$var$reentry) return "";
    $f394edd4427d52c3$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $f394edd4427d52c3$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $f394edd4427d52c3$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $f394edd4427d52c3$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $f394edd4427d52c3$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $f394edd4427d52c3$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $f394edd4427d52c3$var$describeBuiltInComponentFrame("Suspense Fallback") : $f394edd4427d52c3$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $f394edd4427d52c3$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $f394edd4427d52c3$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $f394edd4427d52c3$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $f394edd4427d52c3$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $f394edd4427d52c3$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $f394edd4427d52c3$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $f394edd4427d52c3$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $f394edd4427d52c3$var$hasOwnProperty = Object.prototype.hasOwnProperty, $f394edd4427d52c3$var$scheduleCallback$3 = $kkkYV.unstable_scheduleCallback, $f394edd4427d52c3$var$cancelCallback$1 = $kkkYV.unstable_cancelCallback, $f394edd4427d52c3$var$shouldYield = $kkkYV.unstable_shouldYield, $f394edd4427d52c3$var$requestPaint = $kkkYV.unstable_requestPaint, $f394edd4427d52c3$var$now = $kkkYV.unstable_now, $f394edd4427d52c3$var$getCurrentPriorityLevel = $kkkYV.unstable_getCurrentPriorityLevel, $f394edd4427d52c3$var$ImmediatePriority = $kkkYV.unstable_ImmediatePriority, $f394edd4427d52c3$var$UserBlockingPriority = $kkkYV.unstable_UserBlockingPriority, $f394edd4427d52c3$var$NormalPriority$1 = $kkkYV.unstable_NormalPriority, $f394edd4427d52c3$var$LowPriority = $kkkYV.unstable_LowPriority, $f394edd4427d52c3$var$IdlePriority = $kkkYV.unstable_IdlePriority, $f394edd4427d52c3$var$log$1 = $kkkYV.log, $f394edd4427d52c3$var$unstable_setDisableYieldValue = $kkkYV.unstable_setDisableYieldValue, $f394edd4427d52c3$var$rendererID = null, $f394edd4427d52c3$var$injectedHook = null;
function $f394edd4427d52c3$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $f394edd4427d52c3$var$log$1 && $f394edd4427d52c3$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($f394edd4427d52c3$var$injectedHook && "function" === typeof $f394edd4427d52c3$var$injectedHook.setStrictMode) try {
        $f394edd4427d52c3$var$injectedHook.setStrictMode($f394edd4427d52c3$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $f394edd4427d52c3$var$clz32 = Math.clz32 ? Math.clz32 : $f394edd4427d52c3$var$clz32Fallback, $f394edd4427d52c3$var$log = Math.log, $f394edd4427d52c3$var$LN2 = Math.LN2;
function $f394edd4427d52c3$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($f394edd4427d52c3$var$log(x) / $f394edd4427d52c3$var$LN2 | 0) | 0;
}
var $f394edd4427d52c3$var$nextTransitionUpdateLane = 256, $f394edd4427d52c3$var$nextTransitionDeferredLane = 262144, $f394edd4427d52c3$var$nextRetryLane = 4194304;
function $f394edd4427d52c3$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $f394edd4427d52c3$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $f394edd4427d52c3$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $f394edd4427d52c3$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f394edd4427d52c3$var$claimNextRetryLane() {
    var lane = $f394edd4427d52c3$var$nextRetryLane;
    $f394edd4427d52c3$var$nextRetryLane <<= 1;
    0 === ($f394edd4427d52c3$var$nextRetryLane & 62914560) && ($f394edd4427d52c3$var$nextRetryLane = 4194304);
    return lane;
}
function $f394edd4427d52c3$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $f394edd4427d52c3$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $f394edd4427d52c3$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $f394edd4427d52c3$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $f394edd4427d52c3$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $f394edd4427d52c3$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $f394edd4427d52c3$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $f394edd4427d52c3$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $f394edd4427d52c3$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $f394edd4427d52c3$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $f394edd4427d52c3$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $f394edd4427d52c3$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $f394edd4427d52c3$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $f394edd4427d52c3$var$resolveUpdatePriority() {
    var updatePriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $f394edd4427d52c3$var$getEventPriority(updatePriority.type);
}
function $f394edd4427d52c3$var$runWithPriority(priority, fn) {
    var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    try {
        return $f394edd4427d52c3$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $f394edd4427d52c3$var$randomKey = Math.random().toString(36).slice(2), $f394edd4427d52c3$var$internalInstanceKey = "__reactFiber$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalPropsKey = "__reactProps$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalContainerInstanceKey = "__reactContainer$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalEventHandlersKey = "__reactEvents$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalEventHandlerListenersKey = "__reactListeners$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalEventHandlesSetKey = "__reactHandles$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalRootNodeResourcesKey = "__reactResources$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalHoistableMarker = "__reactMarker$" + $f394edd4427d52c3$var$randomKey;
function $f394edd4427d52c3$var$detachDeletedInstance(node) {
    delete node[$f394edd4427d52c3$var$internalInstanceKey];
    delete node[$f394edd4427d52c3$var$internalPropsKey];
    delete node[$f394edd4427d52c3$var$internalEventHandlersKey];
    delete node[$f394edd4427d52c3$var$internalEventHandlerListenersKey];
    delete node[$f394edd4427d52c3$var$internalEventHandlesSetKey];
}
function $f394edd4427d52c3$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$f394edd4427d52c3$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$f394edd4427d52c3$var$internalContainerInstanceKey] || parentNode[$f394edd4427d52c3$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $f394edd4427d52c3$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$f394edd4427d52c3$var$internalInstanceKey]) return parentNode;
                targetNode = $f394edd4427d52c3$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $f394edd4427d52c3$var$getInstanceFromNode(node) {
    if (node = node[$f394edd4427d52c3$var$internalInstanceKey] || node[$f394edd4427d52c3$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $f394edd4427d52c3$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(33));
}
function $f394edd4427d52c3$var$getResourcesFromRoot(root) {
    var resources = root[$f394edd4427d52c3$var$internalRootNodeResourcesKey];
    resources || (resources = root[$f394edd4427d52c3$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $f394edd4427d52c3$var$markNodeAsHoistable(node) {
    node[$f394edd4427d52c3$var$internalHoistableMarker] = !0;
}
var $f394edd4427d52c3$var$allNativeEvents = new Set(), $f394edd4427d52c3$var$registrationNameDependencies = {};
function $f394edd4427d52c3$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $f394edd4427d52c3$var$registerDirectEvent(registrationName, dependencies);
    $f394edd4427d52c3$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $f394edd4427d52c3$var$registerDirectEvent(registrationName, dependencies) {
    $f394edd4427d52c3$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$f394edd4427d52c3$var$allNativeEvents.add(dependencies[registrationName]);
}
var $f394edd4427d52c3$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $f394edd4427d52c3$var$illegalAttributeNameCache = {}, $f394edd4427d52c3$var$validatedAttributeNameCache = {};
function $f394edd4427d52c3$var$isAttributeNameSafe(attributeName) {
    if ($f394edd4427d52c3$var$hasOwnProperty.call($f394edd4427d52c3$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($f394edd4427d52c3$var$hasOwnProperty.call($f394edd4427d52c3$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($f394edd4427d52c3$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $f394edd4427d52c3$var$validatedAttributeNameCache[attributeName] = !0;
    $f394edd4427d52c3$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $f394edd4427d52c3$var$setValueForAttribute(node, name, value) {
    if ($f394edd4427d52c3$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $f394edd4427d52c3$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $f394edd4427d52c3$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $f394edd4427d52c3$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $f394edd4427d52c3$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $f394edd4427d52c3$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $f394edd4427d52c3$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $f394edd4427d52c3$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $f394edd4427d52c3$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $f394edd4427d52c3$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $f394edd4427d52c3$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $f394edd4427d52c3$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $f394edd4427d52c3$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $f394edd4427d52c3$var$getToStringValue(value);
        } else element.value !== "" + $f394edd4427d52c3$var$getToStringValue(value) && (element.value = "" + $f394edd4427d52c3$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $f394edd4427d52c3$var$setDefaultValue(element, type, $f394edd4427d52c3$var$getToStringValue(value)) : null != defaultValue ? $f394edd4427d52c3$var$setDefaultValue(element, type, $f394edd4427d52c3$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $f394edd4427d52c3$var$getToStringValue(name) : element.removeAttribute("name");
}
function $f394edd4427d52c3$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $f394edd4427d52c3$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $f394edd4427d52c3$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $f394edd4427d52c3$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $f394edd4427d52c3$var$track(element);
}
function $f394edd4427d52c3$var$setDefaultValue(node, type, value) {
    "number" === type && $f394edd4427d52c3$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $f394edd4427d52c3$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $f394edd4427d52c3$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $f394edd4427d52c3$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $f394edd4427d52c3$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $f394edd4427d52c3$var$getToStringValue(defaultValue) : "";
}
function $f394edd4427d52c3$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(92));
            if ($f394edd4427d52c3$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $f394edd4427d52c3$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $f394edd4427d52c3$var$track(element);
}
function $f394edd4427d52c3$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $f394edd4427d52c3$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $f394edd4427d52c3$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $f394edd4427d52c3$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $f394edd4427d52c3$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $f394edd4427d52c3$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $f394edd4427d52c3$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $f394edd4427d52c3$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f394edd4427d52c3$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $f394edd4427d52c3$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $f394edd4427d52c3$var$sanitizeURL(url) {
    return $f394edd4427d52c3$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $f394edd4427d52c3$var$noop$1() {}
var $f394edd4427d52c3$var$currentReplayingEvent = null;
function $f394edd4427d52c3$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $f394edd4427d52c3$var$restoreTarget = null, $f394edd4427d52c3$var$restoreQueue = null;
function $f394edd4427d52c3$var$restoreStateOfTarget(target) {
    var internalInstance = $f394edd4427d52c3$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$f394edd4427d52c3$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $f394edd4427d52c3$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$f394edd4427d52c3$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(90));
                            $f394edd4427d52c3$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $f394edd4427d52c3$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $f394edd4427d52c3$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $f394edd4427d52c3$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $f394edd4427d52c3$var$isInsideEventHandler = !1;
function $f394edd4427d52c3$var$batchedUpdates$1(fn, a, b) {
    if ($f394edd4427d52c3$var$isInsideEventHandler) return fn(a, b);
    $f394edd4427d52c3$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($f394edd4427d52c3$var$isInsideEventHandler = !1, null !== $f394edd4427d52c3$var$restoreTarget || null !== $f394edd4427d52c3$var$restoreQueue) {
            if ($f394edd4427d52c3$var$flushSyncWork$1(), $f394edd4427d52c3$var$restoreTarget && (a = $f394edd4427d52c3$var$restoreTarget, fn = $f394edd4427d52c3$var$restoreQueue, $f394edd4427d52c3$var$restoreQueue = $f394edd4427d52c3$var$restoreTarget = null, $f394edd4427d52c3$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$f394edd4427d52c3$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $f394edd4427d52c3$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$f394edd4427d52c3$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $f394edd4427d52c3$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f394edd4427d52c3$var$passiveBrowserEventsSupported = !1;
if ($f394edd4427d52c3$var$canUseDOM) try {
    var $f394edd4427d52c3$var$options = {};
    Object.defineProperty($f394edd4427d52c3$var$options, "passive", {
        get: function() {
            $f394edd4427d52c3$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $f394edd4427d52c3$var$options, $f394edd4427d52c3$var$options);
    window.removeEventListener("test", $f394edd4427d52c3$var$options, $f394edd4427d52c3$var$options);
} catch (e) {
    $f394edd4427d52c3$var$passiveBrowserEventsSupported = !1;
}
var $f394edd4427d52c3$var$root = null, $f394edd4427d52c3$var$startText = null, $f394edd4427d52c3$var$fallbackText = null;
function $f394edd4427d52c3$var$getData() {
    if ($f394edd4427d52c3$var$fallbackText) return $f394edd4427d52c3$var$fallbackText;
    var start, startValue = $f394edd4427d52c3$var$startText, startLength = startValue.length, end, endValue = "value" in $f394edd4427d52c3$var$root ? $f394edd4427d52c3$var$root.value : $f394edd4427d52c3$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $f394edd4427d52c3$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $f394edd4427d52c3$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $f394edd4427d52c3$var$functionThatReturnsTrue() {
    return !0;
}
function $f394edd4427d52c3$var$functionThatReturnsFalse() {
    return !1;
}
function $f394edd4427d52c3$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $f394edd4427d52c3$var$functionThatReturnsTrue : $f394edd4427d52c3$var$functionThatReturnsFalse;
        this.isPropagationStopped = $f394edd4427d52c3$var$functionThatReturnsFalse;
        return this;
    }
    $f394edd4427d52c3$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $f394edd4427d52c3$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $f394edd4427d52c3$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $f394edd4427d52c3$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $f394edd4427d52c3$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f394edd4427d52c3$var$SyntheticEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$EventInterface), $f394edd4427d52c3$var$UIEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    view: 0,
    detail: 0
}), $f394edd4427d52c3$var$SyntheticUIEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$UIEventInterface), $f394edd4427d52c3$var$lastMovementX, $f394edd4427d52c3$var$lastMovementY, $f394edd4427d52c3$var$lastMouseEvent, $f394edd4427d52c3$var$MouseEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f394edd4427d52c3$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $f394edd4427d52c3$var$lastMouseEvent && ($f394edd4427d52c3$var$lastMouseEvent && "mousemove" === event.type ? ($f394edd4427d52c3$var$lastMovementX = event.screenX - $f394edd4427d52c3$var$lastMouseEvent.screenX, $f394edd4427d52c3$var$lastMovementY = event.screenY - $f394edd4427d52c3$var$lastMouseEvent.screenY) : $f394edd4427d52c3$var$lastMovementY = $f394edd4427d52c3$var$lastMovementX = 0, $f394edd4427d52c3$var$lastMouseEvent = event);
        return $f394edd4427d52c3$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $f394edd4427d52c3$var$lastMovementY;
    }
}), $f394edd4427d52c3$var$SyntheticMouseEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$MouseEventInterface), $f394edd4427d52c3$var$DragEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$MouseEventInterface, {
    dataTransfer: 0
}), $f394edd4427d52c3$var$SyntheticDragEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$DragEventInterface), $f394edd4427d52c3$var$FocusEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$UIEventInterface, {
    relatedTarget: 0
}), $f394edd4427d52c3$var$SyntheticFocusEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$FocusEventInterface), $f394edd4427d52c3$var$AnimationEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f394edd4427d52c3$var$SyntheticAnimationEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$AnimationEventInterface), $f394edd4427d52c3$var$ClipboardEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $f394edd4427d52c3$var$SyntheticClipboardEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$ClipboardEventInterface), $f394edd4427d52c3$var$CompositionEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    data: 0
}), $f394edd4427d52c3$var$SyntheticCompositionEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$CompositionEventInterface), $f394edd4427d52c3$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f394edd4427d52c3$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f394edd4427d52c3$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f394edd4427d52c3$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $f394edd4427d52c3$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $f394edd4427d52c3$var$getEventModifierState() {
    return $f394edd4427d52c3$var$modifierStateGetter;
}
var $f394edd4427d52c3$var$KeyboardEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $f394edd4427d52c3$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $f394edd4427d52c3$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $f394edd4427d52c3$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f394edd4427d52c3$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $f394edd4427d52c3$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $f394edd4427d52c3$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $f394edd4427d52c3$var$SyntheticKeyboardEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$KeyboardEventInterface), $f394edd4427d52c3$var$PointerEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f394edd4427d52c3$var$SyntheticPointerEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$PointerEventInterface), $f394edd4427d52c3$var$TouchEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f394edd4427d52c3$var$getEventModifierState
}), $f394edd4427d52c3$var$SyntheticTouchEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$TouchEventInterface), $f394edd4427d52c3$var$TransitionEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f394edd4427d52c3$var$SyntheticTransitionEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$TransitionEventInterface), $f394edd4427d52c3$var$WheelEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f394edd4427d52c3$var$SyntheticWheelEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$WheelEventInterface), $f394edd4427d52c3$var$ToggleEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $f394edd4427d52c3$var$SyntheticToggleEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$ToggleEventInterface), $f394edd4427d52c3$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $f394edd4427d52c3$var$canUseCompositionEvent = $f394edd4427d52c3$var$canUseDOM && "CompositionEvent" in window, $f394edd4427d52c3$var$documentMode = null;
$f394edd4427d52c3$var$canUseDOM && "documentMode" in document && ($f394edd4427d52c3$var$documentMode = document.documentMode);
var $f394edd4427d52c3$var$canUseTextInputEvent = $f394edd4427d52c3$var$canUseDOM && "TextEvent" in window && !$f394edd4427d52c3$var$documentMode, $f394edd4427d52c3$var$useFallbackCompositionData = $f394edd4427d52c3$var$canUseDOM && (!$f394edd4427d52c3$var$canUseCompositionEvent || $f394edd4427d52c3$var$documentMode && 8 < $f394edd4427d52c3$var$documentMode && 11 >= $f394edd4427d52c3$var$documentMode), $f394edd4427d52c3$var$SPACEBAR_CHAR = String.fromCharCode(32), $f394edd4427d52c3$var$hasSpaceKeypress = !1;
function $f394edd4427d52c3$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $f394edd4427d52c3$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f394edd4427d52c3$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $f394edd4427d52c3$var$isComposing = !1;
function $f394edd4427d52c3$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $f394edd4427d52c3$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $f394edd4427d52c3$var$hasSpaceKeypress = !0;
            return $f394edd4427d52c3$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $f394edd4427d52c3$var$SPACEBAR_CHAR && $f394edd4427d52c3$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $f394edd4427d52c3$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($f394edd4427d52c3$var$isComposing) return "compositionend" === domEventName || !$f394edd4427d52c3$var$canUseCompositionEvent && $f394edd4427d52c3$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $f394edd4427d52c3$var$getData(), $f394edd4427d52c3$var$fallbackText = $f394edd4427d52c3$var$startText = $f394edd4427d52c3$var$root = null, $f394edd4427d52c3$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $f394edd4427d52c3$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $f394edd4427d52c3$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f394edd4427d52c3$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$f394edd4427d52c3$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $f394edd4427d52c3$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $f394edd4427d52c3$var$restoreTarget ? $f394edd4427d52c3$var$restoreQueue ? $f394edd4427d52c3$var$restoreQueue.push(target) : $f394edd4427d52c3$var$restoreQueue = [
        target
    ] : $f394edd4427d52c3$var$restoreTarget = target;
    inst = $f394edd4427d52c3$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $f394edd4427d52c3$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $f394edd4427d52c3$var$activeElement$1 = null, $f394edd4427d52c3$var$activeElementInst$1 = null;
function $f394edd4427d52c3$var$runEventInBatch(dispatchQueue) {
    $f394edd4427d52c3$var$processDispatchQueue(dispatchQueue, 0);
}
function $f394edd4427d52c3$var$getInstIfValueChanged(targetInst) {
    var targetNode = $f394edd4427d52c3$var$getNodeFromInstance(targetInst);
    if ($f394edd4427d52c3$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $f394edd4427d52c3$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $f394edd4427d52c3$var$isInputEventSupported = !1;
if ($f394edd4427d52c3$var$canUseDOM) {
    var $f394edd4427d52c3$var$JSCompiler_inline_result$jscomp$286;
    if ($f394edd4427d52c3$var$canUseDOM) {
        var $f394edd4427d52c3$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$f394edd4427d52c3$var$isSupported$jscomp$inline_427) {
            var $f394edd4427d52c3$var$element$jscomp$inline_428 = document.createElement("div");
            $f394edd4427d52c3$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $f394edd4427d52c3$var$isSupported$jscomp$inline_427 = "function" === typeof $f394edd4427d52c3$var$element$jscomp$inline_428.oninput;
        }
        $f394edd4427d52c3$var$JSCompiler_inline_result$jscomp$286 = $f394edd4427d52c3$var$isSupported$jscomp$inline_427;
    } else $f394edd4427d52c3$var$JSCompiler_inline_result$jscomp$286 = !1;
    $f394edd4427d52c3$var$isInputEventSupported = $f394edd4427d52c3$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $f394edd4427d52c3$var$stopWatchingForValueChange() {
    $f394edd4427d52c3$var$activeElement$1 && ($f394edd4427d52c3$var$activeElement$1.detachEvent("onpropertychange", $f394edd4427d52c3$var$handlePropertyChange), $f394edd4427d52c3$var$activeElementInst$1 = $f394edd4427d52c3$var$activeElement$1 = null);
}
function $f394edd4427d52c3$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $f394edd4427d52c3$var$getInstIfValueChanged($f394edd4427d52c3$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $f394edd4427d52c3$var$createAndAccumulateChangeEvent(dispatchQueue, $f394edd4427d52c3$var$activeElementInst$1, nativeEvent, $f394edd4427d52c3$var$getEventTarget(nativeEvent));
        $f394edd4427d52c3$var$batchedUpdates$1($f394edd4427d52c3$var$runEventInBatch, dispatchQueue);
    }
}
function $f394edd4427d52c3$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($f394edd4427d52c3$var$stopWatchingForValueChange(), $f394edd4427d52c3$var$activeElement$1 = target, $f394edd4427d52c3$var$activeElementInst$1 = targetInst, $f394edd4427d52c3$var$activeElement$1.attachEvent("onpropertychange", $f394edd4427d52c3$var$handlePropertyChange)) : "focusout" === domEventName && $f394edd4427d52c3$var$stopWatchingForValueChange();
}
function $f394edd4427d52c3$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $f394edd4427d52c3$var$getInstIfValueChanged($f394edd4427d52c3$var$activeElementInst$1);
}
function $f394edd4427d52c3$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $f394edd4427d52c3$var$getInstIfValueChanged(targetInst);
}
function $f394edd4427d52c3$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $f394edd4427d52c3$var$getInstIfValueChanged(targetInst);
}
function $f394edd4427d52c3$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f394edd4427d52c3$var$objectIs = "function" === typeof Object.is ? Object.is : $f394edd4427d52c3$var$is;
function $f394edd4427d52c3$var$shallowEqual(objA, objB) {
    if ($f394edd4427d52c3$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$f394edd4427d52c3$var$hasOwnProperty.call(objB, currentKey) || !$f394edd4427d52c3$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $f394edd4427d52c3$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $f394edd4427d52c3$var$getNodeForCharacterOffset(root, offset) {
    var node = $f394edd4427d52c3$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $f394edd4427d52c3$var$getLeafNode(node);
    }
}
function $f394edd4427d52c3$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $f394edd4427d52c3$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $f394edd4427d52c3$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $f394edd4427d52c3$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $f394edd4427d52c3$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $f394edd4427d52c3$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $f394edd4427d52c3$var$skipSelectionChangeEvent = $f394edd4427d52c3$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $f394edd4427d52c3$var$activeElement = null, $f394edd4427d52c3$var$activeElementInst = null, $f394edd4427d52c3$var$lastSelection = null, $f394edd4427d52c3$var$mouseDown = !1;
function $f394edd4427d52c3$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $f394edd4427d52c3$var$mouseDown || null == $f394edd4427d52c3$var$activeElement || $f394edd4427d52c3$var$activeElement !== $f394edd4427d52c3$var$getActiveElement(doc) || (doc = $f394edd4427d52c3$var$activeElement, "selectionStart" in doc && $f394edd4427d52c3$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $f394edd4427d52c3$var$lastSelection && $f394edd4427d52c3$var$shallowEqual($f394edd4427d52c3$var$lastSelection, doc) || ($f394edd4427d52c3$var$lastSelection = doc, doc = $f394edd4427d52c3$var$accumulateTwoPhaseListeners($f394edd4427d52c3$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $f394edd4427d52c3$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $f394edd4427d52c3$var$activeElement)));
}
function $f394edd4427d52c3$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $f394edd4427d52c3$var$vendorPrefixes = {
    animationend: $f394edd4427d52c3$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $f394edd4427d52c3$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $f394edd4427d52c3$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $f394edd4427d52c3$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $f394edd4427d52c3$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $f394edd4427d52c3$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $f394edd4427d52c3$var$makePrefixMap("Transition", "TransitionEnd")
}, $f394edd4427d52c3$var$prefixedEventNames = {}, $f394edd4427d52c3$var$style = {};
$f394edd4427d52c3$var$canUseDOM && ($f394edd4427d52c3$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $f394edd4427d52c3$var$vendorPrefixes.animationend.animation, delete $f394edd4427d52c3$var$vendorPrefixes.animationiteration.animation, delete $f394edd4427d52c3$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $f394edd4427d52c3$var$vendorPrefixes.transitionend.transition);
function $f394edd4427d52c3$var$getVendorPrefixedEventName(eventName) {
    if ($f394edd4427d52c3$var$prefixedEventNames[eventName]) return $f394edd4427d52c3$var$prefixedEventNames[eventName];
    if (!$f394edd4427d52c3$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $f394edd4427d52c3$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $f394edd4427d52c3$var$style) return $f394edd4427d52c3$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $f394edd4427d52c3$var$ANIMATION_END = $f394edd4427d52c3$var$getVendorPrefixedEventName("animationend"), $f394edd4427d52c3$var$ANIMATION_ITERATION = $f394edd4427d52c3$var$getVendorPrefixedEventName("animationiteration"), $f394edd4427d52c3$var$ANIMATION_START = $f394edd4427d52c3$var$getVendorPrefixedEventName("animationstart"), $f394edd4427d52c3$var$TRANSITION_RUN = $f394edd4427d52c3$var$getVendorPrefixedEventName("transitionrun"), $f394edd4427d52c3$var$TRANSITION_START = $f394edd4427d52c3$var$getVendorPrefixedEventName("transitionstart"), $f394edd4427d52c3$var$TRANSITION_CANCEL = $f394edd4427d52c3$var$getVendorPrefixedEventName("transitioncancel"), $f394edd4427d52c3$var$TRANSITION_END = $f394edd4427d52c3$var$getVendorPrefixedEventName("transitionend"), $f394edd4427d52c3$var$topLevelEventsToReactNames = new Map(), $f394edd4427d52c3$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$f394edd4427d52c3$var$simpleEventPluginEvents.push("scrollEnd");
function $f394edd4427d52c3$var$registerSimpleEvent(domEventName, reactName) {
    $f394edd4427d52c3$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $f394edd4427d52c3$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $f394edd4427d52c3$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $f394edd4427d52c3$var$concurrentQueues = [], $f394edd4427d52c3$var$concurrentQueuesIndex = 0, $f394edd4427d52c3$var$concurrentlyUpdatedLanes = 0;
function $f394edd4427d52c3$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $f394edd4427d52c3$var$concurrentQueuesIndex, i = $f394edd4427d52c3$var$concurrentlyUpdatedLanes = $f394edd4427d52c3$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $f394edd4427d52c3$var$concurrentQueues[i];
        $f394edd4427d52c3$var$concurrentQueues[i++] = null;
        var queue = $f394edd4427d52c3$var$concurrentQueues[i];
        $f394edd4427d52c3$var$concurrentQueues[i++] = null;
        var update = $f394edd4427d52c3$var$concurrentQueues[i];
        $f394edd4427d52c3$var$concurrentQueues[i++] = null;
        var lane = $f394edd4427d52c3$var$concurrentQueues[i];
        $f394edd4427d52c3$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $f394edd4427d52c3$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $f394edd4427d52c3$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $f394edd4427d52c3$var$concurrentQueues[$f394edd4427d52c3$var$concurrentQueuesIndex++] = fiber;
    $f394edd4427d52c3$var$concurrentQueues[$f394edd4427d52c3$var$concurrentQueuesIndex++] = queue;
    $f394edd4427d52c3$var$concurrentQueues[$f394edd4427d52c3$var$concurrentQueuesIndex++] = update;
    $f394edd4427d52c3$var$concurrentQueues[$f394edd4427d52c3$var$concurrentQueuesIndex++] = lane;
    $f394edd4427d52c3$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $f394edd4427d52c3$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $f394edd4427d52c3$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $f394edd4427d52c3$var$getRootForUpdatedFiber(fiber);
}
function $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $f394edd4427d52c3$var$enqueueUpdate$1(fiber, null, null, lane);
    return $f394edd4427d52c3$var$getRootForUpdatedFiber(fiber);
}
function $f394edd4427d52c3$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $f394edd4427d52c3$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $f394edd4427d52c3$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $f394edd4427d52c3$var$nestedUpdateCount) throw $f394edd4427d52c3$var$nestedUpdateCount = 0, $f394edd4427d52c3$var$rootWithNestedUpdates = null, Error($f394edd4427d52c3$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $f394edd4427d52c3$var$emptyContextObject = {};
function $f394edd4427d52c3$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f394edd4427d52c3$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $f394edd4427d52c3$var$FiberNode(tag, pendingProps, key, mode);
}
function $f394edd4427d52c3$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $f394edd4427d52c3$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $f394edd4427d52c3$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $f394edd4427d52c3$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $f394edd4427d52c3$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $f394edd4427d52c3$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $f394edd4427d52c3$var$isHostHoistableType(type, pendingProps, $f394edd4427d52c3$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $f394edd4427d52c3$var$REACT_ACTIVITY_TYPE:
            return type = $f394edd4427d52c3$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $f394edd4427d52c3$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE:
            return $f394edd4427d52c3$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $f394edd4427d52c3$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $f394edd4427d52c3$var$REACT_PROFILER_TYPE:
            return type = $f394edd4427d52c3$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $f394edd4427d52c3$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $f394edd4427d52c3$var$REACT_SUSPENSE_TYPE:
            return type = $f394edd4427d52c3$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $f394edd4427d52c3$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $f394edd4427d52c3$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $f394edd4427d52c3$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $f394edd4427d52c3$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $f394edd4427d52c3$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $f394edd4427d52c3$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $f394edd4427d52c3$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $f394edd4427d52c3$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($f394edd4427d52c3$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $f394edd4427d52c3$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $f394edd4427d52c3$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $f394edd4427d52c3$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $f394edd4427d52c3$var$createFiberFromText(content, mode, lanes) {
    content = $f394edd4427d52c3$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $f394edd4427d52c3$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $f394edd4427d52c3$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $f394edd4427d52c3$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $f394edd4427d52c3$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $f394edd4427d52c3$var$CapturedStacks = new WeakMap();
function $f394edd4427d52c3$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $f394edd4427d52c3$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $f394edd4427d52c3$var$getStackByFiberInDevAndProd(source)
        };
        $f394edd4427d52c3$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $f394edd4427d52c3$var$getStackByFiberInDevAndProd(source)
    };
}
var $f394edd4427d52c3$var$forkStack = [], $f394edd4427d52c3$var$forkStackIndex = 0, $f394edd4427d52c3$var$treeForkProvider = null, $f394edd4427d52c3$var$treeForkCount = 0, $f394edd4427d52c3$var$idStack = [], $f394edd4427d52c3$var$idStackIndex = 0, $f394edd4427d52c3$var$treeContextProvider = null, $f394edd4427d52c3$var$treeContextId = 1, $f394edd4427d52c3$var$treeContextOverflow = "";
function $f394edd4427d52c3$var$pushTreeFork(workInProgress, totalChildren) {
    $f394edd4427d52c3$var$forkStack[$f394edd4427d52c3$var$forkStackIndex++] = $f394edd4427d52c3$var$treeForkCount;
    $f394edd4427d52c3$var$forkStack[$f394edd4427d52c3$var$forkStackIndex++] = $f394edd4427d52c3$var$treeForkProvider;
    $f394edd4427d52c3$var$treeForkProvider = workInProgress;
    $f394edd4427d52c3$var$treeForkCount = totalChildren;
}
function $f394edd4427d52c3$var$pushTreeId(workInProgress, totalChildren, index) {
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextId;
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextOverflow;
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextProvider;
    $f394edd4427d52c3$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $f394edd4427d52c3$var$treeContextId;
    workInProgress = $f394edd4427d52c3$var$treeContextOverflow;
    var baseLength = 32 - $f394edd4427d52c3$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $f394edd4427d52c3$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $f394edd4427d52c3$var$treeContextId = 1 << 32 - $f394edd4427d52c3$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $f394edd4427d52c3$var$treeContextOverflow = length + workInProgress;
    } else $f394edd4427d52c3$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $f394edd4427d52c3$var$treeContextOverflow = workInProgress;
}
function $f394edd4427d52c3$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($f394edd4427d52c3$var$pushTreeFork(workInProgress, 1), $f394edd4427d52c3$var$pushTreeId(workInProgress, 1, 0));
}
function $f394edd4427d52c3$var$popTreeContext(workInProgress) {
    for(; workInProgress === $f394edd4427d52c3$var$treeForkProvider;)$f394edd4427d52c3$var$treeForkProvider = $f394edd4427d52c3$var$forkStack[--$f394edd4427d52c3$var$forkStackIndex], $f394edd4427d52c3$var$forkStack[$f394edd4427d52c3$var$forkStackIndex] = null, $f394edd4427d52c3$var$treeForkCount = $f394edd4427d52c3$var$forkStack[--$f394edd4427d52c3$var$forkStackIndex], $f394edd4427d52c3$var$forkStack[$f394edd4427d52c3$var$forkStackIndex] = null;
    for(; workInProgress === $f394edd4427d52c3$var$treeContextProvider;)$f394edd4427d52c3$var$treeContextProvider = $f394edd4427d52c3$var$idStack[--$f394edd4427d52c3$var$idStackIndex], $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex] = null, $f394edd4427d52c3$var$treeContextOverflow = $f394edd4427d52c3$var$idStack[--$f394edd4427d52c3$var$idStackIndex], $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex] = null, $f394edd4427d52c3$var$treeContextId = $f394edd4427d52c3$var$idStack[--$f394edd4427d52c3$var$idStackIndex], $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex] = null;
}
function $f394edd4427d52c3$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextId;
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextOverflow;
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextProvider;
    $f394edd4427d52c3$var$treeContextId = suspendedContext.id;
    $f394edd4427d52c3$var$treeContextOverflow = suspendedContext.overflow;
    $f394edd4427d52c3$var$treeContextProvider = workInProgress;
}
var $f394edd4427d52c3$var$hydrationParentFiber = null, $f394edd4427d52c3$var$nextHydratableInstance = null, $f394edd4427d52c3$var$isHydrating = !1, $f394edd4427d52c3$var$hydrationErrors = null, $f394edd4427d52c3$var$rootOrSingletonContext = !1, $f394edd4427d52c3$var$HydrationMismatchException = Error($f394edd4427d52c3$var$formatProdErrorMessage(519));
function $f394edd4427d52c3$var$throwOnHydrationMismatch(fiber) {
    var error = Error($f394edd4427d52c3$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $f394edd4427d52c3$var$queueHydrationError($f394edd4427d52c3$var$createCapturedValueAtFiber(error, fiber));
    throw $f394edd4427d52c3$var$HydrationMismatchException;
}
function $f394edd4427d52c3$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$f394edd4427d52c3$var$internalInstanceKey] = fiber;
    instance[$f394edd4427d52c3$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("cancel", instance);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $f394edd4427d52c3$var$mediaEventTypes.length; type++)$f394edd4427d52c3$var$listenToNonDelegatedEvent($f394edd4427d52c3$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", instance);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", instance);
            $f394edd4427d52c3$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", instance), $f394edd4427d52c3$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $f394edd4427d52c3$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($f394edd4427d52c3$var$listenToNonDelegatedEvent("beforetoggle", instance), $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $f394edd4427d52c3$var$noop$1), instance = !0) : instance = !1;
    instance || $f394edd4427d52c3$var$throwOnHydrationMismatch(fiber, !0);
}
function $f394edd4427d52c3$var$popToNextHostParent(fiber) {
    for($f394edd4427d52c3$var$hydrationParentFiber = fiber.return; $f394edd4427d52c3$var$hydrationParentFiber;)switch($f394edd4427d52c3$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $f394edd4427d52c3$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $f394edd4427d52c3$var$rootOrSingletonContext = !0;
            return;
        default:
            $f394edd4427d52c3$var$hydrationParentFiber = $f394edd4427d52c3$var$hydrationParentFiber.return;
    }
}
function $f394edd4427d52c3$var$popHydrationState(fiber) {
    if (fiber !== $f394edd4427d52c3$var$hydrationParentFiber) return !1;
    if (!$f394edd4427d52c3$var$isHydrating) return $f394edd4427d52c3$var$popToNextHostParent(fiber), $f394edd4427d52c3$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $f394edd4427d52c3$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $f394edd4427d52c3$var$nextHydratableInstance && $f394edd4427d52c3$var$throwOnHydrationMismatch(fiber);
    $f394edd4427d52c3$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(317));
        $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(317));
        $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $f394edd4427d52c3$var$nextHydratableInstance, $f394edd4427d52c3$var$isSingletonScope(fiber.type) ? (fiber = $f394edd4427d52c3$var$previousHydratableOnEnteringScopedSingleton, $f394edd4427d52c3$var$previousHydratableOnEnteringScopedSingleton = null, $f394edd4427d52c3$var$nextHydratableInstance = fiber) : $f394edd4427d52c3$var$nextHydratableInstance = tag) : $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$hydrationParentFiber ? $f394edd4427d52c3$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $f394edd4427d52c3$var$resetHydrationState() {
    $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$hydrationParentFiber = null;
    $f394edd4427d52c3$var$isHydrating = !1;
}
function $f394edd4427d52c3$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $f394edd4427d52c3$var$hydrationErrors;
    null !== queuedErrors && (null === $f394edd4427d52c3$var$workInProgressRootRecoverableErrors ? $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = queuedErrors : $f394edd4427d52c3$var$workInProgressRootRecoverableErrors.push.apply($f394edd4427d52c3$var$workInProgressRootRecoverableErrors, queuedErrors), $f394edd4427d52c3$var$hydrationErrors = null);
    return queuedErrors;
}
function $f394edd4427d52c3$var$queueHydrationError(error) {
    null === $f394edd4427d52c3$var$hydrationErrors ? $f394edd4427d52c3$var$hydrationErrors = [
        error
    ] : $f394edd4427d52c3$var$hydrationErrors.push(error);
}
var $f394edd4427d52c3$var$valueCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null, $f394edd4427d52c3$var$lastContextDependency = null;
function $f394edd4427d52c3$var$pushProvider(providerFiber, context, nextValue) {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $f394edd4427d52c3$var$popProvider(context) {
    context._currentValue = $f394edd4427d52c3$var$valueCursor.current;
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$valueCursor);
}
function $f394edd4427d52c3$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $f394edd4427d52c3$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $f394edd4427d52c3$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $f394edd4427d52c3$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $f394edd4427d52c3$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $f394edd4427d52c3$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($f394edd4427d52c3$var$HostTransitionContext) : current = [
                $f394edd4427d52c3$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $f394edd4427d52c3$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $f394edd4427d52c3$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$f394edd4427d52c3$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $f394edd4427d52c3$var$prepareToReadContext(workInProgress) {
    $f394edd4427d52c3$var$currentlyRenderingFiber$1 = workInProgress;
    $f394edd4427d52c3$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $f394edd4427d52c3$var$readContext(context) {
    return $f394edd4427d52c3$var$readContextForConsumer($f394edd4427d52c3$var$currentlyRenderingFiber$1, context);
}
function $f394edd4427d52c3$var$readContextDuringReconciliation(consumer, context) {
    null === $f394edd4427d52c3$var$currentlyRenderingFiber$1 && $f394edd4427d52c3$var$prepareToReadContext(consumer);
    return $f394edd4427d52c3$var$readContextForConsumer(consumer, context);
}
function $f394edd4427d52c3$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $f394edd4427d52c3$var$lastContextDependency) {
        if (null === consumer) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(308));
        $f394edd4427d52c3$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$lastContextDependency.next = context;
    return value;
}
var $f394edd4427d52c3$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $f394edd4427d52c3$var$scheduleCallback$2 = $kkkYV.unstable_scheduleCallback, $f394edd4427d52c3$var$NormalPriority = $kkkYV.unstable_NormalPriority, $f394edd4427d52c3$var$CacheContext = {
    $$typeof: $f394edd4427d52c3$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $f394edd4427d52c3$var$createCache() {
    return {
        controller: new $f394edd4427d52c3$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $f394edd4427d52c3$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $f394edd4427d52c3$var$scheduleCallback$2($f394edd4427d52c3$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $f394edd4427d52c3$var$currentEntangledListeners = null, $f394edd4427d52c3$var$currentEntangledPendingCount = 0, $f394edd4427d52c3$var$currentEntangledLane = 0, $f394edd4427d52c3$var$currentEntangledActionThenable = null;
function $f394edd4427d52c3$var$entangleAsyncAction(transition, thenable) {
    if (null === $f394edd4427d52c3$var$currentEntangledListeners) {
        var entangledListeners = $f394edd4427d52c3$var$currentEntangledListeners = [];
        $f394edd4427d52c3$var$currentEntangledPendingCount = 0;
        $f394edd4427d52c3$var$currentEntangledLane = $f394edd4427d52c3$var$requestTransitionLane();
        $f394edd4427d52c3$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $f394edd4427d52c3$var$currentEntangledPendingCount++;
    thenable.then($f394edd4427d52c3$var$pingEngtangledActionScope, $f394edd4427d52c3$var$pingEngtangledActionScope);
    return thenable;
}
function $f394edd4427d52c3$var$pingEngtangledActionScope() {
    if (0 === --$f394edd4427d52c3$var$currentEntangledPendingCount && null !== $f394edd4427d52c3$var$currentEntangledListeners) {
        null !== $f394edd4427d52c3$var$currentEntangledActionThenable && ($f394edd4427d52c3$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $f394edd4427d52c3$var$currentEntangledListeners;
        $f394edd4427d52c3$var$currentEntangledListeners = null;
        $f394edd4427d52c3$var$currentEntangledLane = 0;
        $f394edd4427d52c3$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $f394edd4427d52c3$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $f394edd4427d52c3$var$prevOnStartTransitionFinish = $f394edd4427d52c3$var$ReactSharedInternals.S;
$f394edd4427d52c3$var$ReactSharedInternals.S = function(transition, returnValue) {
    $f394edd4427d52c3$var$globalMostRecentTransitionTime = $f394edd4427d52c3$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $f394edd4427d52c3$var$entangleAsyncAction(transition, returnValue);
    null !== $f394edd4427d52c3$var$prevOnStartTransitionFinish && $f394edd4427d52c3$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $f394edd4427d52c3$var$resumedCache = $f394edd4427d52c3$var$createCursor(null);
function $f394edd4427d52c3$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $f394edd4427d52c3$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $f394edd4427d52c3$var$workInProgressRoot.pooledCache;
}
function $f394edd4427d52c3$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $f394edd4427d52c3$var$push($f394edd4427d52c3$var$resumedCache, $f394edd4427d52c3$var$resumedCache.current) : $f394edd4427d52c3$var$push($f394edd4427d52c3$var$resumedCache, prevCachePool.pool);
}
function $f394edd4427d52c3$var$getSuspendedCache() {
    var cacheFromPool = $f394edd4427d52c3$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $f394edd4427d52c3$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $f394edd4427d52c3$var$SuspenseException = Error($f394edd4427d52c3$var$formatProdErrorMessage(460)), $f394edd4427d52c3$var$SuspenseyCommitException = Error($f394edd4427d52c3$var$formatProdErrorMessage(474)), $f394edd4427d52c3$var$SuspenseActionException = Error($f394edd4427d52c3$var$formatProdErrorMessage(542)), $f394edd4427d52c3$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $f394edd4427d52c3$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $f394edd4427d52c3$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($f394edd4427d52c3$var$noop$1, $f394edd4427d52c3$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $f394edd4427d52c3$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($f394edd4427d52c3$var$noop$1, $f394edd4427d52c3$var$noop$1);
            else {
                thenableState = $f394edd4427d52c3$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $f394edd4427d52c3$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $f394edd4427d52c3$var$suspendedThenable = thenable;
            throw $f394edd4427d52c3$var$SuspenseException;
    }
}
function $f394edd4427d52c3$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $f394edd4427d52c3$var$suspendedThenable = x, $f394edd4427d52c3$var$SuspenseException;
        throw x;
    }
}
var $f394edd4427d52c3$var$suspendedThenable = null;
function $f394edd4427d52c3$var$getSuspendedThenable() {
    if (null === $f394edd4427d52c3$var$suspendedThenable) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(459));
    var thenable = $f394edd4427d52c3$var$suspendedThenable;
    $f394edd4427d52c3$var$suspendedThenable = null;
    return thenable;
}
function $f394edd4427d52c3$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $f394edd4427d52c3$var$SuspenseException || rejectedReason === $f394edd4427d52c3$var$SuspenseActionException) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(483));
}
var $f394edd4427d52c3$var$thenableState$1 = null, $f394edd4427d52c3$var$thenableIndexCounter$1 = 0;
function $f394edd4427d52c3$var$unwrapThenable(thenable) {
    var index = $f394edd4427d52c3$var$thenableIndexCounter$1;
    $f394edd4427d52c3$var$thenableIndexCounter$1 += 1;
    null === $f394edd4427d52c3$var$thenableState$1 && ($f394edd4427d52c3$var$thenableState$1 = []);
    return $f394edd4427d52c3$var$trackUsedThenable($f394edd4427d52c3$var$thenableState$1, thenable, index);
}
function $f394edd4427d52c3$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $f394edd4427d52c3$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $f394edd4427d52c3$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $f394edd4427d52c3$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $f394edd4427d52c3$var$REACT_LAZY_TYPE && $f394edd4427d52c3$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $f394edd4427d52c3$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $f394edd4427d52c3$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $f394edd4427d52c3$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $f394edd4427d52c3$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $f394edd4427d52c3$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $f394edd4427d52c3$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f394edd4427d52c3$var$REACT_ELEMENT_TYPE:
                    return lanes = $f394edd4427d52c3$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f394edd4427d52c3$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
                    return newChild = $f394edd4427d52c3$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    return newChild = $f394edd4427d52c3$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($f394edd4427d52c3$var$isArrayImpl(newChild) || $f394edd4427d52c3$var$getIteratorFn(newChild)) return newChild = $f394edd4427d52c3$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $f394edd4427d52c3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $f394edd4427d52c3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f394edd4427d52c3$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    return newChild = $f394edd4427d52c3$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($f394edd4427d52c3$var$isArrayImpl(newChild) || $f394edd4427d52c3$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $f394edd4427d52c3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $f394edd4427d52c3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f394edd4427d52c3$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    return newChild = $f394edd4427d52c3$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($f394edd4427d52c3$var$isArrayImpl(newChild) || $f394edd4427d52c3$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $f394edd4427d52c3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $f394edd4427d52c3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f394edd4427d52c3$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $f394edd4427d52c3$var$REACT_LAZY_TYPE && $f394edd4427d52c3$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $f394edd4427d52c3$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE ? (lanes = $f394edd4427d52c3$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $f394edd4427d52c3$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f394edd4427d52c3$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $f394edd4427d52c3$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    return newChild = $f394edd4427d52c3$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($f394edd4427d52c3$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($f394edd4427d52c3$var$getIteratorFn(newChild)) {
                key = $f394edd4427d52c3$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f394edd4427d52c3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f394edd4427d52c3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $f394edd4427d52c3$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $f394edd4427d52c3$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $f394edd4427d52c3$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $f394edd4427d52c3$var$SuspenseException || x === $f394edd4427d52c3$var$SuspenseActionException) throw x;
            var fiber = $f394edd4427d52c3$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $f394edd4427d52c3$var$reconcileChildFibers = $f394edd4427d52c3$var$createChildReconciler(!0), $f394edd4427d52c3$var$mountChildFibers = $f394edd4427d52c3$var$createChildReconciler(!1), $f394edd4427d52c3$var$hasForceUpdate = !1;
function $f394edd4427d52c3$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $f394edd4427d52c3$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $f394edd4427d52c3$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f394edd4427d52c3$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($f394edd4427d52c3$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $f394edd4427d52c3$var$getRootForUpdatedFiber(fiber);
        $f394edd4427d52c3$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $f394edd4427d52c3$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $f394edd4427d52c3$var$getRootForUpdatedFiber(fiber);
}
function $f394edd4427d52c3$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $f394edd4427d52c3$var$markRootEntangled(root, lane);
    }
}
function $f394edd4427d52c3$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $f394edd4427d52c3$var$didReadFromEntangledAsyncAction = !1;
function $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($f394edd4427d52c3$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $f394edd4427d52c3$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $f394edd4427d52c3$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $f394edd4427d52c3$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $f394edd4427d52c3$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($f394edd4427d52c3$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $f394edd4427d52c3$var$currentEntangledLane && ($f394edd4427d52c3$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $f394edd4427d52c3$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $f394edd4427d52c3$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $f394edd4427d52c3$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $f394edd4427d52c3$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$f394edd4427d52c3$var$callCallback(callbacks[updateQueue], context);
}
var $f394edd4427d52c3$var$currentTreeHiddenStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$prevEntangledRenderLanesCursor = $f394edd4427d52c3$var$createCursor(0);
function $f394edd4427d52c3$var$pushHiddenContext(fiber, context) {
    fiber = $f394edd4427d52c3$var$entangledRenderLanes;
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$prevEntangledRenderLanesCursor, fiber);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$currentTreeHiddenStackCursor, context);
    $f394edd4427d52c3$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $f394edd4427d52c3$var$reuseHiddenContextOnStack() {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$prevEntangledRenderLanesCursor, $f394edd4427d52c3$var$entangledRenderLanes);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$currentTreeHiddenStackCursor, $f394edd4427d52c3$var$currentTreeHiddenStackCursor.current);
}
function $f394edd4427d52c3$var$popHiddenContext() {
    $f394edd4427d52c3$var$entangledRenderLanes = $f394edd4427d52c3$var$prevEntangledRenderLanesCursor.current;
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$currentTreeHiddenStackCursor);
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$prevEntangledRenderLanesCursor);
}
var $f394edd4427d52c3$var$suspenseHandlerStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$shellBoundary = null;
function $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current & 1);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseHandlerStackCursor, handler);
    null === $f394edd4427d52c3$var$shellBoundary && (null === current || null !== $f394edd4427d52c3$var$currentTreeHiddenStackCursor.current ? $f394edd4427d52c3$var$shellBoundary = handler : null !== current.memoizedState && ($f394edd4427d52c3$var$shellBoundary = handler));
}
function $f394edd4427d52c3$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseHandlerStackCursor, fiber);
    null === $f394edd4427d52c3$var$shellBoundary && ($f394edd4427d52c3$var$shellBoundary = fiber);
}
function $f394edd4427d52c3$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current), $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseHandlerStackCursor, fiber), null === $f394edd4427d52c3$var$shellBoundary && ($f394edd4427d52c3$var$shellBoundary = fiber)) : $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(fiber);
}
function $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack() {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseHandlerStackCursor, $f394edd4427d52c3$var$suspenseHandlerStackCursor.current);
}
function $f394edd4427d52c3$var$popSuspenseHandler(fiber) {
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseHandlerStackCursor);
    $f394edd4427d52c3$var$shellBoundary === fiber && ($f394edd4427d52c3$var$shellBoundary = null);
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseStackCursor);
}
var $f394edd4427d52c3$var$suspenseStackCursor = $f394edd4427d52c3$var$createCursor(0);
function $f394edd4427d52c3$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $f394edd4427d52c3$var$isSuspenseInstancePending(state) || $f394edd4427d52c3$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $f394edd4427d52c3$var$renderLanes = 0, $f394edd4427d52c3$var$currentlyRenderingFiber = null, $f394edd4427d52c3$var$currentHook = null, $f394edd4427d52c3$var$workInProgressHook = null, $f394edd4427d52c3$var$didScheduleRenderPhaseUpdate = !1, $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $f394edd4427d52c3$var$localIdCounter = 0, $f394edd4427d52c3$var$thenableIndexCounter = 0, $f394edd4427d52c3$var$thenableState = null, $f394edd4427d52c3$var$globalClientIdCounter = 0;
function $f394edd4427d52c3$var$throwInvalidHookError() {
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(321));
}
function $f394edd4427d52c3$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$f394edd4427d52c3$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $f394edd4427d52c3$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $f394edd4427d52c3$var$renderLanes = nextRenderLanes;
    $f394edd4427d52c3$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $f394edd4427d52c3$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $f394edd4427d52c3$var$HooksDispatcherOnMount : $f394edd4427d52c3$var$HooksDispatcherOnUpdate;
    $f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $f394edd4427d52c3$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $f394edd4427d52c3$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $f394edd4427d52c3$var$finishRenderingHooks(current) {
    $f394edd4427d52c3$var$ReactSharedInternals.H = $f394edd4427d52c3$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $f394edd4427d52c3$var$currentHook && null !== $f394edd4427d52c3$var$currentHook.next;
    $f394edd4427d52c3$var$renderLanes = 0;
    $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$currentHook = $f394edd4427d52c3$var$currentlyRenderingFiber = null;
    $f394edd4427d52c3$var$didScheduleRenderPhaseUpdate = !1;
    $f394edd4427d52c3$var$thenableIndexCounter = 0;
    $f394edd4427d52c3$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(300));
    null === current || $f394edd4427d52c3$var$didReceiveUpdate || (current = current.dependencies, null !== current && $f394edd4427d52c3$var$checkIfContextChanged(current) && ($f394edd4427d52c3$var$didReceiveUpdate = !0));
}
function $f394edd4427d52c3$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $f394edd4427d52c3$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass && ($f394edd4427d52c3$var$thenableState = null);
        $f394edd4427d52c3$var$thenableIndexCounter = 0;
        $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $f394edd4427d52c3$var$ReactSharedInternals.H = $f394edd4427d52c3$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $f394edd4427d52c3$var$TransitionAwareHostComponent() {
    var dispatcher = $f394edd4427d52c3$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $f394edd4427d52c3$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $f394edd4427d52c3$var$currentHook ? $f394edd4427d52c3$var$currentHook.memoizedState : null) !== dispatcher && ($f394edd4427d52c3$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $f394edd4427d52c3$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $f394edd4427d52c3$var$localIdCounter;
    $f394edd4427d52c3$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $f394edd4427d52c3$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $f394edd4427d52c3$var$resetHooksOnUnwind(workInProgress) {
    if ($f394edd4427d52c3$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $f394edd4427d52c3$var$didScheduleRenderPhaseUpdate = !1;
    }
    $f394edd4427d52c3$var$renderLanes = 0;
    $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$currentHook = $f394edd4427d52c3$var$currentlyRenderingFiber = null;
    $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $f394edd4427d52c3$var$thenableIndexCounter = $f394edd4427d52c3$var$localIdCounter = 0;
    $f394edd4427d52c3$var$thenableState = null;
}
function $f394edd4427d52c3$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f394edd4427d52c3$var$workInProgressHook ? $f394edd4427d52c3$var$currentlyRenderingFiber.memoizedState = $f394edd4427d52c3$var$workInProgressHook = hook : $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$workInProgressHook.next = hook;
    return $f394edd4427d52c3$var$workInProgressHook;
}
function $f394edd4427d52c3$var$updateWorkInProgressHook() {
    if (null === $f394edd4427d52c3$var$currentHook) {
        var nextCurrentHook = $f394edd4427d52c3$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $f394edd4427d52c3$var$currentHook.next;
    var nextWorkInProgressHook = null === $f394edd4427d52c3$var$workInProgressHook ? $f394edd4427d52c3$var$currentlyRenderingFiber.memoizedState : $f394edd4427d52c3$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $f394edd4427d52c3$var$workInProgressHook = nextWorkInProgressHook, $f394edd4427d52c3$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $f394edd4427d52c3$var$currentlyRenderingFiber.alternate) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(467));
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(310));
        }
        $f394edd4427d52c3$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $f394edd4427d52c3$var$currentHook.memoizedState,
            baseState: $f394edd4427d52c3$var$currentHook.baseState,
            baseQueue: $f394edd4427d52c3$var$currentHook.baseQueue,
            queue: $f394edd4427d52c3$var$currentHook.queue,
            next: null
        };
        null === $f394edd4427d52c3$var$workInProgressHook ? $f394edd4427d52c3$var$currentlyRenderingFiber.memoizedState = $f394edd4427d52c3$var$workInProgressHook = nextCurrentHook : $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$workInProgressHook.next = nextCurrentHook;
    }
    return $f394edd4427d52c3$var$workInProgressHook;
}
function $f394edd4427d52c3$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $f394edd4427d52c3$var$useThenable(thenable) {
    var index = $f394edd4427d52c3$var$thenableIndexCounter;
    $f394edd4427d52c3$var$thenableIndexCounter += 1;
    null === $f394edd4427d52c3$var$thenableState && ($f394edd4427d52c3$var$thenableState = []);
    thenable = $f394edd4427d52c3$var$trackUsedThenable($f394edd4427d52c3$var$thenableState, thenable, index);
    index = $f394edd4427d52c3$var$currentlyRenderingFiber;
    null === (null === $f394edd4427d52c3$var$workInProgressHook ? index.memoizedState : $f394edd4427d52c3$var$workInProgressHook.next) && (index = index.alternate, $f394edd4427d52c3$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $f394edd4427d52c3$var$HooksDispatcherOnMount : $f394edd4427d52c3$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $f394edd4427d52c3$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $f394edd4427d52c3$var$useThenable(usable);
        if (usable.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return $f394edd4427d52c3$var$readContext(usable);
    }
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(438, String(usable)));
}
function $f394edd4427d52c3$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $f394edd4427d52c3$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $f394edd4427d52c3$var$createFunctionComponentUpdateQueue(), $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $f394edd4427d52c3$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $f394edd4427d52c3$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $f394edd4427d52c3$var$updateReducer(reducer) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    return $f394edd4427d52c3$var$updateReducerImpl(hook, $f394edd4427d52c3$var$currentHook, reducer);
}
function $f394edd4427d52c3$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($f394edd4427d52c3$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($f394edd4427d52c3$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $f394edd4427d52c3$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($f394edd4427d52c3$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $f394edd4427d52c3$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $f394edd4427d52c3$var$currentlyRenderingFiber.lanes |= revertLane, $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $f394edd4427d52c3$var$currentlyRenderingFiber.lanes |= updateLane, $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$f394edd4427d52c3$var$objectIs(pendingQueue, hook.memoizedState) && ($f394edd4427d52c3$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $f394edd4427d52c3$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $f394edd4427d52c3$var$rerenderReducer(reducer) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $f394edd4427d52c3$var$objectIs(newState, hook.memoizedState) || ($f394edd4427d52c3$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $f394edd4427d52c3$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $f394edd4427d52c3$var$currentlyRenderingFiber, hook = $f394edd4427d52c3$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $f394edd4427d52c3$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$f394edd4427d52c3$var$objectIs(($f394edd4427d52c3$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $f394edd4427d52c3$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $f394edd4427d52c3$var$updateEffect($f394edd4427d52c3$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $f394edd4427d52c3$var$workInProgressHook && $f394edd4427d52c3$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $f394edd4427d52c3$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $f394edd4427d52c3$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $f394edd4427d52c3$var$workInProgressRoot) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($f394edd4427d52c3$var$renderLanes & 127) || $f394edd4427d52c3$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $f394edd4427d52c3$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $f394edd4427d52c3$var$createFunctionComponentUpdateQueue(), $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $f394edd4427d52c3$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $f394edd4427d52c3$var$checkIfSnapshotChanged(inst) && $f394edd4427d52c3$var$forceStoreRerender(fiber);
}
function $f394edd4427d52c3$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $f394edd4427d52c3$var$checkIfSnapshotChanged(inst) && $f394edd4427d52c3$var$forceStoreRerender(fiber);
    });
}
function $f394edd4427d52c3$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f394edd4427d52c3$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f394edd4427d52c3$var$forceStoreRerender(fiber) {
    var root = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $f394edd4427d52c3$var$mountStateImpl(initialState) {
    var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f394edd4427d52c3$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $f394edd4427d52c3$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f394edd4427d52c3$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $f394edd4427d52c3$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $f394edd4427d52c3$var$updateReducerImpl(hook, $f394edd4427d52c3$var$currentHook, "function" === typeof reducer ? reducer : $f394edd4427d52c3$var$basicStateReducer);
}
function $f394edd4427d52c3$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($f394edd4427d52c3$var$isRenderPhaseUpdate(fiber)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $f394edd4427d52c3$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $f394edd4427d52c3$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $f394edd4427d52c3$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T, currentTransition = {};
        $f394edd4427d52c3$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $f394edd4427d52c3$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $f394edd4427d52c3$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $f394edd4427d52c3$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $f394edd4427d52c3$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $f394edd4427d52c3$var$onActionError(actionQueue, node, error$66);
    }
}
function $f394edd4427d52c3$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $f394edd4427d52c3$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $f394edd4427d52c3$var$onActionError(actionQueue, node, error);
    }) : $f394edd4427d52c3$var$onActionSuccess(actionQueue, node, returnValue);
}
function $f394edd4427d52c3$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $f394edd4427d52c3$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $f394edd4427d52c3$var$runActionStateAction(actionQueue, nextState)));
}
function $f394edd4427d52c3$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $f394edd4427d52c3$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $f394edd4427d52c3$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $f394edd4427d52c3$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $f394edd4427d52c3$var$mountActionState(action, initialStateProp) {
    if ($f394edd4427d52c3$var$isHydrating) {
        var ssrFormState = $f394edd4427d52c3$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $f394edd4427d52c3$var$currentlyRenderingFiber;
                if ($f394edd4427d52c3$var$isHydrating) {
                    if ($f394edd4427d52c3$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $f394edd4427d52c3$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $f394edd4427d52c3$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $f394edd4427d52c3$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $f394edd4427d52c3$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $f394edd4427d52c3$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f394edd4427d52c3$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $f394edd4427d52c3$var$dispatchSetState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $f394edd4427d52c3$var$mountStateImpl(!1);
    inRootOrSingleton = $f394edd4427d52c3$var$dispatchOptimisticSetState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $f394edd4427d52c3$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $f394edd4427d52c3$var$dispatchActionState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $f394edd4427d52c3$var$updateActionState(action) {
    var stateHook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    return $f394edd4427d52c3$var$updateActionStateImpl(stateHook, $f394edd4427d52c3$var$currentHook, action);
}
function $f394edd4427d52c3$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $f394edd4427d52c3$var$updateReducerImpl(stateHook, currentStateHook, $f394edd4427d52c3$var$actionStateReducer)[0];
    stateHook = $f394edd4427d52c3$var$updateReducer($f394edd4427d52c3$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $f394edd4427d52c3$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $f394edd4427d52c3$var$SuspenseException) throw $f394edd4427d52c3$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($f394edd4427d52c3$var$currentlyRenderingFiber.flags |= 2048, $f394edd4427d52c3$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $f394edd4427d52c3$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $f394edd4427d52c3$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $f394edd4427d52c3$var$rerenderActionState(action) {
    var stateHook = $f394edd4427d52c3$var$updateWorkInProgressHook(), currentStateHook = $f394edd4427d52c3$var$currentHook;
    if (null !== currentStateHook) return $f394edd4427d52c3$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $f394edd4427d52c3$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $f394edd4427d52c3$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $f394edd4427d52c3$var$createFunctionComponentUpdateQueue(), $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $f394edd4427d52c3$var$updateRef() {
    return $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
}
function $f394edd4427d52c3$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
    $f394edd4427d52c3$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $f394edd4427d52c3$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $f394edd4427d52c3$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $f394edd4427d52c3$var$currentHook && null !== deps && $f394edd4427d52c3$var$areHookInputsEqual(deps, $f394edd4427d52c3$var$currentHook.memoizedState.deps) ? hook.memoizedState = $f394edd4427d52c3$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($f394edd4427d52c3$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $f394edd4427d52c3$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $f394edd4427d52c3$var$mountEffect(create, deps) {
    $f394edd4427d52c3$var$mountEffectImpl(8390656, 8, create, deps);
}
function $f394edd4427d52c3$var$updateEffect(create, deps) {
    $f394edd4427d52c3$var$updateEffectImpl(2048, 8, create, deps);
}
function $f394edd4427d52c3$var$useEffectEventImpl(payload) {
    $f394edd4427d52c3$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $f394edd4427d52c3$var$createFunctionComponentUpdateQueue(), $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $f394edd4427d52c3$var$updateEvent(callback) {
    var ref = $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
    $f394edd4427d52c3$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($f394edd4427d52c3$var$executionContext & 2)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $f394edd4427d52c3$var$updateInsertionEffect(create, deps) {
    return $f394edd4427d52c3$var$updateEffectImpl(4, 2, create, deps);
}
function $f394edd4427d52c3$var$updateLayoutEffect(create, deps) {
    return $f394edd4427d52c3$var$updateEffectImpl(4, 4, create, deps);
}
function $f394edd4427d52c3$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $f394edd4427d52c3$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $f394edd4427d52c3$var$updateEffectImpl(4, 4, $f394edd4427d52c3$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $f394edd4427d52c3$var$mountDebugValue() {}
function $f394edd4427d52c3$var$updateCallback(callback, deps) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f394edd4427d52c3$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $f394edd4427d52c3$var$updateMemo(nextCreate, deps) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f394edd4427d52c3$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $f394edd4427d52c3$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $f394edd4427d52c3$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $f394edd4427d52c3$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($f394edd4427d52c3$var$renderLanes & 1073741824) && 0 === ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $f394edd4427d52c3$var$requestDeferredLane();
    $f394edd4427d52c3$var$currentlyRenderingFiber.lanes |= hook;
    $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $f394edd4427d52c3$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($f394edd4427d52c3$var$objectIs(value, prevValue)) return value;
    if (null !== $f394edd4427d52c3$var$currentTreeHiddenStackCursor.current) return hook = $f394edd4427d52c3$var$mountDeferredValueImpl(hook, value, initialValue), $f394edd4427d52c3$var$objectIs(hook, prevValue) || ($f394edd4427d52c3$var$didReceiveUpdate = !0), hook;
    if (0 === ($f394edd4427d52c3$var$renderLanes & 42) || 0 !== ($f394edd4427d52c3$var$renderLanes & 1073741824) && 0 === ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 261930)) return $f394edd4427d52c3$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $f394edd4427d52c3$var$requestDeferredLane();
    $f394edd4427d52c3$var$currentlyRenderingFiber.lanes |= hook;
    $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $f394edd4427d52c3$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T, currentTransition = {};
    $f394edd4427d52c3$var$ReactSharedInternals.T = currentTransition;
    $f394edd4427d52c3$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $f394edd4427d52c3$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $f394edd4427d52c3$var$chainThenableValue(returnValue, finishedState);
            $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $f394edd4427d52c3$var$requestUpdateLane(fiber));
        } else $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, finishedState, $f394edd4427d52c3$var$requestUpdateLane(fiber));
    } catch (error) {
        $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $f394edd4427d52c3$var$requestUpdateLane());
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f394edd4427d52c3$var$noop() {}
function $f394edd4427d52c3$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(476));
    var queue = $f394edd4427d52c3$var$ensureFormComponentIsStateful(formFiber).queue;
    $f394edd4427d52c3$var$startTransition(formFiber, queue, pendingState, $f394edd4427d52c3$var$sharedNotPendingObject, null === action ? $f394edd4427d52c3$var$noop : function() {
        $f394edd4427d52c3$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $f394edd4427d52c3$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $f394edd4427d52c3$var$sharedNotPendingObject,
        baseState: $f394edd4427d52c3$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f394edd4427d52c3$var$basicStateReducer,
            lastRenderedState: $f394edd4427d52c3$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f394edd4427d52c3$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $f394edd4427d52c3$var$requestFormReset$1(formFiber) {
    var stateHook = $f394edd4427d52c3$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $f394edd4427d52c3$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $f394edd4427d52c3$var$requestUpdateLane());
}
function $f394edd4427d52c3$var$useHostTransitionStatus() {
    return $f394edd4427d52c3$var$readContext($f394edd4427d52c3$var$HostTransitionContext);
}
function $f394edd4427d52c3$var$updateId() {
    return $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
}
function $f394edd4427d52c3$var$updateRefresh() {
    return $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
}
function $f394edd4427d52c3$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $f394edd4427d52c3$var$requestUpdateLane();
                fiber = $f394edd4427d52c3$var$createUpdate(lane);
                var root$69 = $f394edd4427d52c3$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(root$69, provider, lane), $f394edd4427d52c3$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $f394edd4427d52c3$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $f394edd4427d52c3$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $f394edd4427d52c3$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $f394edd4427d52c3$var$isRenderPhaseUpdate(fiber) ? $f394edd4427d52c3$var$enqueueRenderPhaseUpdate(queue, action) : (action = $f394edd4427d52c3$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(action, fiber, lane), $f394edd4427d52c3$var$entangleTransitionUpdate(action, queue, lane)));
}
function $f394edd4427d52c3$var$dispatchSetState(fiber, queue, action) {
    var lane = $f394edd4427d52c3$var$requestUpdateLane();
    $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f394edd4427d52c3$var$isRenderPhaseUpdate(fiber)) $f394edd4427d52c3$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($f394edd4427d52c3$var$objectIs(eagerState, currentState)) return $f394edd4427d52c3$var$enqueueUpdate$1(fiber, queue, update, 0), null === $f394edd4427d52c3$var$workInProgressRoot && $f394edd4427d52c3$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $f394edd4427d52c3$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $f394edd4427d52c3$var$scheduleUpdateOnFiber(action, fiber, lane), $f394edd4427d52c3$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $f394edd4427d52c3$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $f394edd4427d52c3$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f394edd4427d52c3$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $f394edd4427d52c3$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $f394edd4427d52c3$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $f394edd4427d52c3$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $f394edd4427d52c3$var$currentlyRenderingFiber || null !== alternate && alternate === $f394edd4427d52c3$var$currentlyRenderingFiber;
}
function $f394edd4427d52c3$var$enqueueRenderPhaseUpdate(queue, update) {
    $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass = $f394edd4427d52c3$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $f394edd4427d52c3$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $f394edd4427d52c3$var$markRootEntangled(root, lane);
    }
}
var $f394edd4427d52c3$var$ContextOnlyDispatcher = {
    readContext: $f394edd4427d52c3$var$readContext,
    use: $f394edd4427d52c3$var$use,
    useCallback: $f394edd4427d52c3$var$throwInvalidHookError,
    useContext: $f394edd4427d52c3$var$throwInvalidHookError,
    useEffect: $f394edd4427d52c3$var$throwInvalidHookError,
    useImperativeHandle: $f394edd4427d52c3$var$throwInvalidHookError,
    useLayoutEffect: $f394edd4427d52c3$var$throwInvalidHookError,
    useInsertionEffect: $f394edd4427d52c3$var$throwInvalidHookError,
    useMemo: $f394edd4427d52c3$var$throwInvalidHookError,
    useReducer: $f394edd4427d52c3$var$throwInvalidHookError,
    useRef: $f394edd4427d52c3$var$throwInvalidHookError,
    useState: $f394edd4427d52c3$var$throwInvalidHookError,
    useDebugValue: $f394edd4427d52c3$var$throwInvalidHookError,
    useDeferredValue: $f394edd4427d52c3$var$throwInvalidHookError,
    useTransition: $f394edd4427d52c3$var$throwInvalidHookError,
    useSyncExternalStore: $f394edd4427d52c3$var$throwInvalidHookError,
    useId: $f394edd4427d52c3$var$throwInvalidHookError,
    useHostTransitionStatus: $f394edd4427d52c3$var$throwInvalidHookError,
    useFormState: $f394edd4427d52c3$var$throwInvalidHookError,
    useActionState: $f394edd4427d52c3$var$throwInvalidHookError,
    useOptimistic: $f394edd4427d52c3$var$throwInvalidHookError,
    useMemoCache: $f394edd4427d52c3$var$throwInvalidHookError,
    useCacheRefresh: $f394edd4427d52c3$var$throwInvalidHookError
};
$f394edd4427d52c3$var$ContextOnlyDispatcher.useEffectEvent = $f394edd4427d52c3$var$throwInvalidHookError;
var $f394edd4427d52c3$var$HooksDispatcherOnMount = {
    readContext: $f394edd4427d52c3$var$readContext,
    use: $f394edd4427d52c3$var$use,
    useCallback: function(callback, deps) {
        $f394edd4427d52c3$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $f394edd4427d52c3$var$readContext,
    useEffect: $f394edd4427d52c3$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $f394edd4427d52c3$var$mountEffectImpl(4194308, 4, $f394edd4427d52c3$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $f394edd4427d52c3$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $f394edd4427d52c3$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f394edd4427d52c3$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $f394edd4427d52c3$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $f394edd4427d52c3$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $f394edd4427d52c3$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $f394edd4427d52c3$var$dispatchReducerAction.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $f394edd4427d52c3$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $f394edd4427d52c3$var$dispatchSetState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $f394edd4427d52c3$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        return $f394edd4427d52c3$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $f394edd4427d52c3$var$mountStateImpl(!1);
        stateHook = $f394edd4427d52c3$var$startTransition.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $f394edd4427d52c3$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $f394edd4427d52c3$var$currentlyRenderingFiber, hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        if ($f394edd4427d52c3$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $f394edd4427d52c3$var$workInProgressRoot) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(349));
            0 !== ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 127) || $f394edd4427d52c3$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $f394edd4427d52c3$var$mountEffect($f394edd4427d52c3$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $f394edd4427d52c3$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $f394edd4427d52c3$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook(), identifierPrefix = $f394edd4427d52c3$var$workInProgressRoot.identifierPrefix;
        if ($f394edd4427d52c3$var$isHydrating) {
            var JSCompiler_inline_result = $f394edd4427d52c3$var$treeContextOverflow;
            var idWithLeadingBit = $f394edd4427d52c3$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $f394edd4427d52c3$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $f394edd4427d52c3$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $f394edd4427d52c3$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $f394edd4427d52c3$var$useHostTransitionStatus,
    useFormState: $f394edd4427d52c3$var$mountActionState,
    useActionState: $f394edd4427d52c3$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $f394edd4427d52c3$var$dispatchOptimisticSetState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $f394edd4427d52c3$var$useMemoCache,
    useCacheRefresh: function() {
        return $f394edd4427d52c3$var$mountWorkInProgressHook().memoizedState = $f394edd4427d52c3$var$refreshCache.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($f394edd4427d52c3$var$executionContext & 2)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $f394edd4427d52c3$var$HooksDispatcherOnUpdate = {
    readContext: $f394edd4427d52c3$var$readContext,
    use: $f394edd4427d52c3$var$use,
    useCallback: $f394edd4427d52c3$var$updateCallback,
    useContext: $f394edd4427d52c3$var$readContext,
    useEffect: $f394edd4427d52c3$var$updateEffect,
    useImperativeHandle: $f394edd4427d52c3$var$updateImperativeHandle,
    useInsertionEffect: $f394edd4427d52c3$var$updateInsertionEffect,
    useLayoutEffect: $f394edd4427d52c3$var$updateLayoutEffect,
    useMemo: $f394edd4427d52c3$var$updateMemo,
    useReducer: $f394edd4427d52c3$var$updateReducer,
    useRef: $f394edd4427d52c3$var$updateRef,
    useState: function() {
        return $f394edd4427d52c3$var$updateReducer($f394edd4427d52c3$var$basicStateReducer);
    },
    useDebugValue: $f394edd4427d52c3$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
        return $f394edd4427d52c3$var$updateDeferredValueImpl(hook, $f394edd4427d52c3$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f394edd4427d52c3$var$updateReducer($f394edd4427d52c3$var$basicStateReducer)[0], start = $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f394edd4427d52c3$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f394edd4427d52c3$var$updateSyncExternalStore,
    useId: $f394edd4427d52c3$var$updateId,
    useHostTransitionStatus: $f394edd4427d52c3$var$useHostTransitionStatus,
    useFormState: $f394edd4427d52c3$var$updateActionState,
    useActionState: $f394edd4427d52c3$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
        return $f394edd4427d52c3$var$updateOptimisticImpl(hook, $f394edd4427d52c3$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $f394edd4427d52c3$var$useMemoCache,
    useCacheRefresh: $f394edd4427d52c3$var$updateRefresh
};
$f394edd4427d52c3$var$HooksDispatcherOnUpdate.useEffectEvent = $f394edd4427d52c3$var$updateEvent;
var $f394edd4427d52c3$var$HooksDispatcherOnRerender = {
    readContext: $f394edd4427d52c3$var$readContext,
    use: $f394edd4427d52c3$var$use,
    useCallback: $f394edd4427d52c3$var$updateCallback,
    useContext: $f394edd4427d52c3$var$readContext,
    useEffect: $f394edd4427d52c3$var$updateEffect,
    useImperativeHandle: $f394edd4427d52c3$var$updateImperativeHandle,
    useInsertionEffect: $f394edd4427d52c3$var$updateInsertionEffect,
    useLayoutEffect: $f394edd4427d52c3$var$updateLayoutEffect,
    useMemo: $f394edd4427d52c3$var$updateMemo,
    useReducer: $f394edd4427d52c3$var$rerenderReducer,
    useRef: $f394edd4427d52c3$var$updateRef,
    useState: function() {
        return $f394edd4427d52c3$var$rerenderReducer($f394edd4427d52c3$var$basicStateReducer);
    },
    useDebugValue: $f394edd4427d52c3$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
        return null === $f394edd4427d52c3$var$currentHook ? $f394edd4427d52c3$var$mountDeferredValueImpl(hook, value, initialValue) : $f394edd4427d52c3$var$updateDeferredValueImpl(hook, $f394edd4427d52c3$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f394edd4427d52c3$var$rerenderReducer($f394edd4427d52c3$var$basicStateReducer)[0], start = $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f394edd4427d52c3$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f394edd4427d52c3$var$updateSyncExternalStore,
    useId: $f394edd4427d52c3$var$updateId,
    useHostTransitionStatus: $f394edd4427d52c3$var$useHostTransitionStatus,
    useFormState: $f394edd4427d52c3$var$rerenderActionState,
    useActionState: $f394edd4427d52c3$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
        if (null !== $f394edd4427d52c3$var$currentHook) return $f394edd4427d52c3$var$updateOptimisticImpl(hook, $f394edd4427d52c3$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $f394edd4427d52c3$var$useMemoCache,
    useCacheRefresh: $f394edd4427d52c3$var$updateRefresh
};
$f394edd4427d52c3$var$HooksDispatcherOnRerender.useEffectEvent = $f394edd4427d52c3$var$updateEvent;
function $f394edd4427d52c3$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $f394edd4427d52c3$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $f394edd4427d52c3$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f394edd4427d52c3$var$requestUpdateLane(), update = $f394edd4427d52c3$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f394edd4427d52c3$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(payload, inst, lane), $f394edd4427d52c3$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f394edd4427d52c3$var$requestUpdateLane(), update = $f394edd4427d52c3$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f394edd4427d52c3$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(payload, inst, lane), $f394edd4427d52c3$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $f394edd4427d52c3$var$requestUpdateLane(), update = $f394edd4427d52c3$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $f394edd4427d52c3$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(callback, inst, lane), $f394edd4427d52c3$var$entangleTransitions(callback, inst, lane));
    }
};
function $f394edd4427d52c3$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$f394edd4427d52c3$var$shallowEqual(oldProps, newProps) || !$f394edd4427d52c3$var$shallowEqual(oldState, newState) : !0;
}
function $f394edd4427d52c3$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $f394edd4427d52c3$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $f394edd4427d52c3$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $f394edd4427d52c3$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $f394edd4427d52c3$var$defaultOnUncaughtError(error) {
    $f394edd4427d52c3$var$reportGlobalError(error);
}
function $f394edd4427d52c3$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $f394edd4427d52c3$var$defaultOnRecoverableError(error) {
    $f394edd4427d52c3$var$reportGlobalError(error);
}
function $f394edd4427d52c3$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $f394edd4427d52c3$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $f394edd4427d52c3$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $f394edd4427d52c3$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $f394edd4427d52c3$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $f394edd4427d52c3$var$createClassErrorUpdate(lane) {
    lane = $f394edd4427d52c3$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $f394edd4427d52c3$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $f394edd4427d52c3$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $f394edd4427d52c3$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed ? $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $f394edd4427d52c3$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $f394edd4427d52c3$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $f394edd4427d52c3$var$shellBoundary ? $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $f394edd4427d52c3$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $f394edd4427d52c3$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $f394edd4427d52c3$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $f394edd4427d52c3$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $f394edd4427d52c3$var$attachPingListener(root, value, rootRenderLanes);
        $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($f394edd4427d52c3$var$isHydrating) return returnFiber = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $f394edd4427d52c3$var$HydrationMismatchException && (root = Error($f394edd4427d52c3$var$formatProdErrorMessage(422), {
        cause: value
    }), $f394edd4427d52c3$var$queueHydrationError($f394edd4427d52c3$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $f394edd4427d52c3$var$HydrationMismatchException && (returnFiber = Error($f394edd4427d52c3$var$formatProdErrorMessage(423), {
        cause: value
    }), $f394edd4427d52c3$var$queueHydrationError($f394edd4427d52c3$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $f394edd4427d52c3$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $f394edd4427d52c3$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $f394edd4427d52c3$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($f394edd4427d52c3$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $f394edd4427d52c3$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $f394edd4427d52c3$var$workInProgressRootConcurrentErrors ? $f394edd4427d52c3$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $f394edd4427d52c3$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $f394edd4427d52c3$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $f394edd4427d52c3$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $f394edd4427d52c3$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed || !$f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $f394edd4427d52c3$var$createClassErrorUpdate(rootRenderLanes), $f394edd4427d52c3$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $f394edd4427d52c3$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $f394edd4427d52c3$var$SelectiveHydrationException = Error($f394edd4427d52c3$var$formatProdErrorMessage(461)), $f394edd4427d52c3$var$didReceiveUpdate = !1;
function $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $f394edd4427d52c3$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $f394edd4427d52c3$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $f394edd4427d52c3$var$prepareToReadContext(workInProgress);
    nextProps = $f394edd4427d52c3$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $f394edd4427d52c3$var$checkDidRenderIdHook();
    if (null !== current && !$f394edd4427d52c3$var$didReceiveUpdate) return $f394edd4427d52c3$var$bailoutHooks(current, workInProgress, renderLanes), $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f394edd4427d52c3$var$isHydrating && key && $f394edd4427d52c3$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f394edd4427d52c3$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$f394edd4427d52c3$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $f394edd4427d52c3$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $f394edd4427d52c3$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$f394edd4427d52c3$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $f394edd4427d52c3$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $f394edd4427d52c3$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $f394edd4427d52c3$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($f394edd4427d52c3$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($f394edd4427d52c3$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $f394edd4427d52c3$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($f394edd4427d52c3$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $f394edd4427d52c3$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $f394edd4427d52c3$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $f394edd4427d52c3$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $f394edd4427d52c3$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $f394edd4427d52c3$var$pushHiddenContext(workInProgress, prevState) : $f394edd4427d52c3$var$reuseHiddenContextOnStack(), $f394edd4427d52c3$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $f394edd4427d52c3$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($f394edd4427d52c3$var$pushTransition(workInProgress, prevState.cachePool), $f394edd4427d52c3$var$pushHiddenContext(workInProgress, prevState), $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $f394edd4427d52c3$var$pushTransition(workInProgress, null), $f394edd4427d52c3$var$reuseHiddenContextOnStack(), $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress));
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $f394edd4427d52c3$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $f394edd4427d52c3$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $f394edd4427d52c3$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $f394edd4427d52c3$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $f394edd4427d52c3$var$pushTransition(workInProgress, null);
    $f394edd4427d52c3$var$reuseHiddenContextOnStack();
    $f394edd4427d52c3$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $f394edd4427d52c3$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $f394edd4427d52c3$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f394edd4427d52c3$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $f394edd4427d52c3$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($f394edd4427d52c3$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $f394edd4427d52c3$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $f394edd4427d52c3$var$bailoutOffscreenComponent(null, current);
            $f394edd4427d52c3$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $f394edd4427d52c3$var$nextHydratableInstance) ? (current = $f394edd4427d52c3$var$canHydrateHydrationBoundary(current, $f394edd4427d52c3$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $f394edd4427d52c3$var$treeContextProvider ? {
                    id: $f394edd4427d52c3$var$treeContextId,
                    overflow: $f394edd4427d52c3$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $f394edd4427d52c3$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $f394edd4427d52c3$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $f394edd4427d52c3$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $f394edd4427d52c3$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($f394edd4427d52c3$var$formatProdErrorMessage(558));
        } else if ($f394edd4427d52c3$var$didReceiveUpdate || $f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $f394edd4427d52c3$var$didReceiveUpdate || didSuspend) {
            nextProps = $f394edd4427d52c3$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $f394edd4427d52c3$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(current, dehydrated), $f394edd4427d52c3$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $f394edd4427d52c3$var$SelectiveHydrationException;
            $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f394edd4427d52c3$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(dehydrated.nextSibling), $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$isHydrating = !0, $f394edd4427d52c3$var$hydrationErrors = null, $f394edd4427d52c3$var$rootOrSingletonContext = !1, null !== current && $f394edd4427d52c3$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $f394edd4427d52c3$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $f394edd4427d52c3$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $f394edd4427d52c3$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $f394edd4427d52c3$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f394edd4427d52c3$var$prepareToReadContext(workInProgress);
    Component = $f394edd4427d52c3$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $f394edd4427d52c3$var$checkDidRenderIdHook();
    if (null !== current && !$f394edd4427d52c3$var$didReceiveUpdate) return $f394edd4427d52c3$var$bailoutHooks(current, workInProgress, renderLanes), $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f394edd4427d52c3$var$isHydrating && nextProps && $f394edd4427d52c3$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $f394edd4427d52c3$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $f394edd4427d52c3$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $f394edd4427d52c3$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $f394edd4427d52c3$var$finishRenderingHooks(current);
    Component = $f394edd4427d52c3$var$checkDidRenderIdHook();
    if (null !== current && !$f394edd4427d52c3$var$didReceiveUpdate) return $f394edd4427d52c3$var$bailoutHooks(current, workInProgress, renderLanes), $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f394edd4427d52c3$var$isHydrating && Component && $f394edd4427d52c3$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f394edd4427d52c3$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f394edd4427d52c3$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $f394edd4427d52c3$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $f394edd4427d52c3$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $f394edd4427d52c3$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $f394edd4427d52c3$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $f394edd4427d52c3$var$readContext(contextType) : $f394edd4427d52c3$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($f394edd4427d52c3$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $f394edd4427d52c3$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $f394edd4427d52c3$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $f394edd4427d52c3$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $f394edd4427d52c3$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $f394edd4427d52c3$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $f394edd4427d52c3$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $f394edd4427d52c3$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f394edd4427d52c3$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $f394edd4427d52c3$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($f394edd4427d52c3$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $f394edd4427d52c3$var$hasForceUpdate || $f394edd4427d52c3$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $f394edd4427d52c3$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $f394edd4427d52c3$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $f394edd4427d52c3$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $f394edd4427d52c3$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $f394edd4427d52c3$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $f394edd4427d52c3$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f394edd4427d52c3$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $f394edd4427d52c3$var$hasForceUpdate || null !== current && null !== current.dependencies && $f394edd4427d52c3$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($f394edd4427d52c3$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $f394edd4427d52c3$var$hasForceUpdate || $f394edd4427d52c3$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $f394edd4427d52c3$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $f394edd4427d52c3$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $f394edd4427d52c3$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $f394edd4427d52c3$var$resetHydrationState();
    workInProgress.flags |= 256;
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $f394edd4427d52c3$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $f394edd4427d52c3$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $f394edd4427d52c3$var$getSuspendedCache()
    };
}
function $f394edd4427d52c3$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $f394edd4427d52c3$var$workInProgressDeferredLane);
    return current;
}
function $f394edd4427d52c3$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($f394edd4427d52c3$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($f394edd4427d52c3$var$isHydrating) {
            showFallback ? $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $f394edd4427d52c3$var$nextHydratableInstance) ? (current = $f394edd4427d52c3$var$canHydrateHydrationBoundary(current, $f394edd4427d52c3$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $f394edd4427d52c3$var$treeContextProvider ? {
                    id: $f394edd4427d52c3$var$treeContextId,
                    overflow: $f394edd4427d52c3$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $f394edd4427d52c3$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress);
            $f394edd4427d52c3$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $f394edd4427d52c3$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $f394edd4427d52c3$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f394edd4427d52c3$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f394edd4427d52c3$var$SUSPENDED_MARKER, $f394edd4427d52c3$var$bailoutOffscreenComponent(null, nextProps);
        $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $f394edd4427d52c3$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $f394edd4427d52c3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $f394edd4427d52c3$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $f394edd4427d52c3$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f394edd4427d52c3$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f394edd4427d52c3$var$SUSPENDED_MARKER, workInProgress = $f394edd4427d52c3$var$bailoutOffscreenComponent(null, nextProps));
        else if ($f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress), $f394edd4427d52c3$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($f394edd4427d52c3$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $f394edd4427d52c3$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $f394edd4427d52c3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($f394edd4427d52c3$var$didReceiveUpdate || $f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $f394edd4427d52c3$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $f394edd4427d52c3$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $f394edd4427d52c3$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(current, nextProps), $f394edd4427d52c3$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $f394edd4427d52c3$var$SelectiveHydrationException;
            $f394edd4427d52c3$var$isSuspenseInstancePending(nextPrimaryChildren) || $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f394edd4427d52c3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $f394edd4427d52c3$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(nextPrimaryChildren.nextSibling), $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$isHydrating = !0, $f394edd4427d52c3$var$hydrationErrors = null, $f394edd4427d52c3$var$rootOrSingletonContext = !1, null !== current && $f394edd4427d52c3$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $f394edd4427d52c3$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $f394edd4427d52c3$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $f394edd4427d52c3$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $f394edd4427d52c3$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $f394edd4427d52c3$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $f394edd4427d52c3$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $f394edd4427d52c3$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $f394edd4427d52c3$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $f394edd4427d52c3$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f394edd4427d52c3$var$SUSPENDED_MARKER, $f394edd4427d52c3$var$bailoutOffscreenComponent(current.child, nextProps);
    $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $f394edd4427d52c3$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $f394edd4427d52c3$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $f394edd4427d52c3$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $f394edd4427d52c3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f394edd4427d52c3$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $f394edd4427d52c3$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $f394edd4427d52c3$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $f394edd4427d52c3$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $f394edd4427d52c3$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $f394edd4427d52c3$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, suspenseContext);
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $f394edd4427d52c3$var$isHydrating ? $f394edd4427d52c3$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $f394edd4427d52c3$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $f394edd4427d52c3$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $f394edd4427d52c3$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $f394edd4427d52c3$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $f394edd4427d52c3$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $f394edd4427d52c3$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $f394edd4427d52c3$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $f394edd4427d52c3$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $f394edd4427d52c3$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $f394edd4427d52c3$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $f394edd4427d52c3$var$checkIfContextChanged(current) ? !0 : !1;
}
function $f394edd4427d52c3$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $f394edd4427d52c3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, current.memoizedState.cache);
            $f394edd4427d52c3$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $f394edd4427d52c3$var$pushHostContext(workInProgress);
            break;
        case 4:
            $f394edd4427d52c3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $f394edd4427d52c3$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $f394edd4427d52c3$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $f394edd4427d52c3$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $f394edd4427d52c3$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $f394edd4427d52c3$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, current.memoizedState.cache);
    }
    return $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $f394edd4427d52c3$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $f394edd4427d52c3$var$didReceiveUpdate = !0;
        else {
            if (!$f394edd4427d52c3$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $f394edd4427d52c3$var$didReceiveUpdate = !1, $f394edd4427d52c3$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $f394edd4427d52c3$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $f394edd4427d52c3$var$didReceiveUpdate = !1, $f394edd4427d52c3$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $f394edd4427d52c3$var$pushTreeId(workInProgress, $f394edd4427d52c3$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $f394edd4427d52c3$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $f394edd4427d52c3$var$shouldConstruct(current) ? (props = $f394edd4427d52c3$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $f394edd4427d52c3$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $f394edd4427d52c3$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $f394edd4427d52c3$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $f394edd4427d52c3$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $f394edd4427d52c3$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $f394edd4427d52c3$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $f394edd4427d52c3$var$getComponentNameFromType(current) || current;
                    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $f394edd4427d52c3$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $f394edd4427d52c3$var$resolveClassComponentProps(props, workInProgress.pendingProps), $f394edd4427d52c3$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $f394edd4427d52c3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $f394edd4427d52c3$var$cloneUpdateQueue(current, workInProgress);
                $f394edd4427d52c3$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, props);
                props !== prevState.cache && $f394edd4427d52c3$var$propagateContextChanges(workInProgress, [
                    $f394edd4427d52c3$var$CacheContext
                ], renderLanes, !0);
                $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $f394edd4427d52c3$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $f394edd4427d52c3$var$createCapturedValueAtFiber(Error($f394edd4427d52c3$var$formatProdErrorMessage(424)), workInProgress);
                        $f394edd4427d52c3$var$queueHydrationError($$typeof);
                        workInProgress = $f394edd4427d52c3$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(current.firstChild);
                        $f394edd4427d52c3$var$hydrationParentFiber = workInProgress;
                        $f394edd4427d52c3$var$isHydrating = !0;
                        $f394edd4427d52c3$var$hydrationErrors = null;
                        $f394edd4427d52c3$var$rootOrSingletonContext = !0;
                        renderLanes = $f394edd4427d52c3$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $f394edd4427d52c3$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $f394edd4427d52c3$var$markRef(current, workInProgress), null === current ? (renderLanes = $f394edd4427d52c3$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $f394edd4427d52c3$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer($f394edd4427d52c3$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress, props[$f394edd4427d52c3$var$internalPropsKey] = current, $f394edd4427d52c3$var$setInitialProperties(props, renderLanes, current), $f394edd4427d52c3$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $f394edd4427d52c3$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $f394edd4427d52c3$var$pushHostContext(workInProgress), null === current && $f394edd4427d52c3$var$isHydrating && (props = workInProgress.stateNode = $f394edd4427d52c3$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $f394edd4427d52c3$var$rootInstanceStackCursor.current), $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$rootOrSingletonContext = !0, $$typeof = $f394edd4427d52c3$var$nextHydratableInstance, $f394edd4427d52c3$var$isSingletonScope(workInProgress.type) ? ($f394edd4427d52c3$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(props.firstChild)) : $f394edd4427d52c3$var$nextHydratableInstance = $$typeof), $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $f394edd4427d52c3$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $f394edd4427d52c3$var$isHydrating) {
                if ($$typeof = props = $f394edd4427d52c3$var$nextHydratableInstance) props = $f394edd4427d52c3$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $f394edd4427d52c3$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(props.firstChild), $f394edd4427d52c3$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress);
            }
            $f394edd4427d52c3$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $f394edd4427d52c3$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $f394edd4427d52c3$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $f394edd4427d52c3$var$renderWithHooks(current, workInProgress, $f394edd4427d52c3$var$TransitionAwareHostComponent, null, null, renderLanes), $f394edd4427d52c3$var$HostTransitionContext._currentValue = $$typeof);
            $f394edd4427d52c3$var$markRef(current, workInProgress);
            $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $f394edd4427d52c3$var$isHydrating) {
                if (current = renderLanes = $f394edd4427d52c3$var$nextHydratableInstance) renderLanes = $f394edd4427d52c3$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $f394edd4427d52c3$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $f394edd4427d52c3$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $f394edd4427d52c3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $f394edd4427d52c3$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $f394edd4427d52c3$var$pushProvider(workInProgress, workInProgress.type, props.value), $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $f394edd4427d52c3$var$prepareToReadContext(workInProgress), $$typeof = $f394edd4427d52c3$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $f394edd4427d52c3$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $f394edd4427d52c3$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $f394edd4427d52c3$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $f394edd4427d52c3$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $f394edd4427d52c3$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $f394edd4427d52c3$var$prepareToReadContext(workInProgress), props = $f394edd4427d52c3$var$readContext($f394edd4427d52c3$var$CacheContext), null === current ? ($$typeof = $f394edd4427d52c3$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $f394edd4427d52c3$var$workInProgressRoot, prevState = $f394edd4427d52c3$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $f394edd4427d52c3$var$initializeUpdateQueue(workInProgress), $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($f394edd4427d52c3$var$cloneUpdateQueue(current, workInProgress), $f394edd4427d52c3$var$processUpdateQueue(workInProgress, null, null, renderLanes), $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, props)) : (props = prevState.cache, $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, props), props !== $$typeof.cache && $f394edd4427d52c3$var$propagateContextChanges(workInProgress, [
                $f394edd4427d52c3$var$CacheContext
            ], renderLanes, !0))), $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f394edd4427d52c3$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $f394edd4427d52c3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($f394edd4427d52c3$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $f394edd4427d52c3$var$suspendedThenable = $f394edd4427d52c3$var$noopSuspenseyCommitThenable, $f394edd4427d52c3$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $f394edd4427d52c3$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$f394edd4427d52c3$var$preloadResource(resource)) {
        if ($f394edd4427d52c3$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $f394edd4427d52c3$var$suspendedThenable = $f394edd4427d52c3$var$noopSuspenseyCommitThenable, $f394edd4427d52c3$var$SuspenseyCommitException;
    }
}
function $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $f394edd4427d52c3$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $f394edd4427d52c3$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$f394edd4427d52c3$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $f394edd4427d52c3$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $f394edd4427d52c3$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $f394edd4427d52c3$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 1:
            return $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext);
            $f394edd4427d52c3$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $f394edd4427d52c3$var$popHydrationState(workInProgress) ? $f394edd4427d52c3$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $f394edd4427d52c3$var$upgradeHydrationErrorsToRecoverable());
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($f394edd4427d52c3$var$markUpdate(workInProgress), null !== nextResource ? ($f394edd4427d52c3$var$bubbleProperties(workInProgress), $f394edd4427d52c3$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($f394edd4427d52c3$var$bubbleProperties(workInProgress), $f394edd4427d52c3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($f394edd4427d52c3$var$markUpdate(workInProgress), $f394edd4427d52c3$var$bubbleProperties(workInProgress), $f394edd4427d52c3$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($f394edd4427d52c3$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $f394edd4427d52c3$var$markUpdate(workInProgress), $f394edd4427d52c3$var$bubbleProperties(workInProgress), $f394edd4427d52c3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $f394edd4427d52c3$var$popHostContext(workInProgress);
            renderLanes = $f394edd4427d52c3$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f394edd4427d52c3$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(166));
                    $f394edd4427d52c3$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $f394edd4427d52c3$var$contextStackCursor.current;
                $f394edd4427d52c3$var$popHydrationState(workInProgress) ? $f394edd4427d52c3$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $f394edd4427d52c3$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $f394edd4427d52c3$var$markUpdate(workInProgress));
            }
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $f394edd4427d52c3$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f394edd4427d52c3$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(166));
                    $f394edd4427d52c3$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $f394edd4427d52c3$var$contextStackCursor.current;
                if ($f394edd4427d52c3$var$popHydrationState(workInProgress)) $f394edd4427d52c3$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer($f394edd4427d52c3$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress;
                    nextResource[$f394edd4427d52c3$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($f394edd4427d52c3$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $f394edd4427d52c3$var$markUpdate(workInProgress);
                }
            }
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            $f394edd4427d52c3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f394edd4427d52c3$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(166));
                current = $f394edd4427d52c3$var$rootInstanceStackCursor.current;
                if ($f394edd4427d52c3$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $f394edd4427d52c3$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $f394edd4427d52c3$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $f394edd4427d52c3$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(557));
                        current[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress;
                    } else $f394edd4427d52c3$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f394edd4427d52c3$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $f394edd4427d52c3$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $f394edd4427d52c3$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(558));
            }
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $f394edd4427d52c3$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(317));
                        type[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress;
                    } else $f394edd4427d52c3$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f394edd4427d52c3$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $f394edd4427d52c3$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $f394edd4427d52c3$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $f394edd4427d52c3$var$popHostContainer(), null === current && $f394edd4427d52c3$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 10:
            return $f394edd4427d52c3$var$popProvider(workInProgress.type), $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 19:
            $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $f394edd4427d52c3$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $f394edd4427d52c3$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$f394edd4427d52c3$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current & 1 | 2);
                            $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $f394edd4427d52c3$var$now() > $f394edd4427d52c3$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $f394edd4427d52c3$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, current), $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$f394edd4427d52c3$var$isHydrating) return $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
                    } else 2 * $f394edd4427d52c3$var$now() - newProps.renderingStartTime > $f394edd4427d52c3$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $f394edd4427d52c3$var$now(), current.sibling = null, renderLanes = $f394edd4427d52c3$var$suspenseStackCursor.current, $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $f394edd4427d52c3$var$popSuspenseHandler(workInProgress), $f394edd4427d52c3$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($f394edd4427d52c3$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $f394edd4427d52c3$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext), $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f394edd4427d52c3$var$unwindWork(current, workInProgress) {
    $f394edd4427d52c3$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext), $f394edd4427d52c3$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $f394edd4427d52c3$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(340));
                $f394edd4427d52c3$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(340));
                $f394edd4427d52c3$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseStackCursor), null;
        case 4:
            return $f394edd4427d52c3$var$popHostContainer(), null;
        case 10:
            return $f394edd4427d52c3$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $f394edd4427d52c3$var$popSuspenseHandler(workInProgress), $f394edd4427d52c3$var$popHiddenContext(), null !== current && $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $f394edd4427d52c3$var$unwindInterruptedWork(current, interruptedWork) {
    $f394edd4427d52c3$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext);
            $f394edd4427d52c3$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $f394edd4427d52c3$var$popHostContext(interruptedWork);
            break;
        case 4:
            $f394edd4427d52c3$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $f394edd4427d52c3$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $f394edd4427d52c3$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseStackCursor);
            break;
        case 10:
            $f394edd4427d52c3$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $f394edd4427d52c3$var$popSuspenseHandler(interruptedWork);
            $f394edd4427d52c3$var$popHiddenContext();
            null !== current && $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$resumedCache);
            break;
        case 24:
            $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext);
    }
}
function $f394edd4427d52c3$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $f394edd4427d52c3$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $f394edd4427d52c3$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f394edd4427d52c3$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $f394edd4427d52c3$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f394edd4427d52c3$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f394edd4427d52c3$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $f394edd4427d52c3$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $f394edd4427d52c3$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $f394edd4427d52c3$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $f394edd4427d52c3$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$f394edd4427d52c3$var$internalPropsKey] = newProps;
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $f394edd4427d52c3$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $f394edd4427d52c3$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $f394edd4427d52c3$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $f394edd4427d52c3$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $f394edd4427d52c3$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $f394edd4427d52c3$var$noop$1));
    else if (4 !== tag && (27 === tag && $f394edd4427d52c3$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($f394edd4427d52c3$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$f394edd4427d52c3$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $f394edd4427d52c3$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $f394edd4427d52c3$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($f394edd4427d52c3$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$f394edd4427d52c3$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $f394edd4427d52c3$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $f394edd4427d52c3$var$setInitialProperties(singleton, type, props);
        singleton[$f394edd4427d52c3$var$internalInstanceKey] = finishedWork;
        singleton[$f394edd4427d52c3$var$internalPropsKey] = props;
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $f394edd4427d52c3$var$offscreenSubtreeIsHidden = !1, $f394edd4427d52c3$var$offscreenSubtreeWasHidden = !1, $f394edd4427d52c3$var$needsFormReset = !1, $f394edd4427d52c3$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $f394edd4427d52c3$var$nextEffect = null;
function $f394edd4427d52c3$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $f394edd4427d52c3$var$eventsEnabled = $f394edd4427d52c3$var$_enabled;
    root = $f394edd4427d52c3$var$getActiveElementDeep(root);
    if ($f394edd4427d52c3$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $f394edd4427d52c3$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $f394edd4427d52c3$var$_enabled = !1;
    for($f394edd4427d52c3$var$nextEffect = firstChild; null !== $f394edd4427d52c3$var$nextEffect;)if (firstChild = $f394edd4427d52c3$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $f394edd4427d52c3$var$nextEffect = root;
    else for(; null !== $f394edd4427d52c3$var$nextEffect;){
        firstChild = $f394edd4427d52c3$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $f394edd4427d52c3$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $f394edd4427d52c3$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $f394edd4427d52c3$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $f394edd4427d52c3$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $f394edd4427d52c3$var$nextEffect = root;
            break;
        }
        $f394edd4427d52c3$var$nextEffect = firstChild.return;
    }
}
function $f394edd4427d52c3$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f394edd4427d52c3$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $f394edd4427d52c3$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $f394edd4427d52c3$var$commitClassCallbacks(finishedWork);
            flags & 512 && $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $f394edd4427d52c3$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $f394edd4427d52c3$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $f394edd4427d52c3$var$commitHostMount(finishedWork);
            flags & 512 && $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f394edd4427d52c3$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f394edd4427d52c3$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $f394edd4427d52c3$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $f394edd4427d52c3$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $f394edd4427d52c3$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $f394edd4427d52c3$var$offscreenSubtreeWasHidden;
                prevProps = $f394edd4427d52c3$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $f394edd4427d52c3$var$offscreenSubtreeWasHidden;
                $f394edd4427d52c3$var$offscreenSubtreeIsHidden = flags;
                ($f394edd4427d52c3$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $f394edd4427d52c3$var$offscreenSubtreeIsHidden = prevProps;
                $f394edd4427d52c3$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $f394edd4427d52c3$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $f394edd4427d52c3$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $f394edd4427d52c3$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $f394edd4427d52c3$var$hostParent = null, $f394edd4427d52c3$var$hostParentIsContainer = !1;
function $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$f394edd4427d52c3$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $f394edd4427d52c3$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($f394edd4427d52c3$var$injectedHook && "function" === typeof $f394edd4427d52c3$var$injectedHook.onCommitFiberUnmount) try {
        $f394edd4427d52c3$var$injectedHook.onCommitFiberUnmount($f394edd4427d52c3$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $f394edd4427d52c3$var$hostParent, prevHostParentIsContainer = $f394edd4427d52c3$var$hostParentIsContainer;
            $f394edd4427d52c3$var$isSingletonScope(deletedFiber.type) && ($f394edd4427d52c3$var$hostParent = deletedFiber.stateNode, $f394edd4427d52c3$var$hostParentIsContainer = !1);
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f394edd4427d52c3$var$releaseSingletonInstance(deletedFiber.stateNode);
            $f394edd4427d52c3$var$hostParent = prevHostParent;
            $f394edd4427d52c3$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $f394edd4427d52c3$var$hostParent;
            prevHostParentIsContainer = $f394edd4427d52c3$var$hostParentIsContainer;
            $f394edd4427d52c3$var$hostParent = null;
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f394edd4427d52c3$var$hostParent = prevHostParent;
            $f394edd4427d52c3$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $f394edd4427d52c3$var$hostParent) {
                if ($f394edd4427d52c3$var$hostParentIsContainer) try {
                    (9 === $f394edd4427d52c3$var$hostParent.nodeType ? $f394edd4427d52c3$var$hostParent.body : "HTML" === $f394edd4427d52c3$var$hostParent.nodeName ? $f394edd4427d52c3$var$hostParent.ownerDocument.body : $f394edd4427d52c3$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $f394edd4427d52c3$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $f394edd4427d52c3$var$hostParent && ($f394edd4427d52c3$var$hostParentIsContainer ? (finishedRoot = $f394edd4427d52c3$var$hostParent, $f394edd4427d52c3$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $f394edd4427d52c3$var$retryIfBlockedOn(finishedRoot)) : $f394edd4427d52c3$var$clearHydrationBoundary($f394edd4427d52c3$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $f394edd4427d52c3$var$hostParent;
            prevHostParentIsContainer = $f394edd4427d52c3$var$hostParentIsContainer;
            $f394edd4427d52c3$var$hostParent = deletedFiber.stateNode.containerInfo;
            $f394edd4427d52c3$var$hostParentIsContainer = !0;
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f394edd4427d52c3$var$hostParent = prevHostParent;
            $f394edd4427d52c3$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $f394edd4427d52c3$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || ($f394edd4427d52c3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $f394edd4427d52c3$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden = (prevHostParent = $f394edd4427d52c3$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $f394edd4427d52c3$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $f394edd4427d52c3$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f394edd4427d52c3$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $f394edd4427d52c3$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $f394edd4427d52c3$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $f394edd4427d52c3$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $f394edd4427d52c3$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $f394edd4427d52c3$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($f394edd4427d52c3$var$isSingletonScope(parent.type)) {
                        $f394edd4427d52c3$var$hostParent = parent.stateNode;
                        $f394edd4427d52c3$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $f394edd4427d52c3$var$hostParent = parent.stateNode;
                    $f394edd4427d52c3$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $f394edd4427d52c3$var$hostParent = parent.stateNode.containerInfo;
                    $f394edd4427d52c3$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $f394edd4427d52c3$var$hostParent) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(160));
        $f394edd4427d52c3$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $f394edd4427d52c3$var$hostParent = null;
        $f394edd4427d52c3$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $f394edd4427d52c3$var$currentHoistableRoot = null;
function $f394edd4427d52c3$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($f394edd4427d52c3$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $f394edd4427d52c3$var$commitHookEffectListMount(3, finishedWork), $f394edd4427d52c3$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f394edd4427d52c3$var$offscreenSubtreeWasHidden || null === current || $f394edd4427d52c3$var$safelyDetachRef(current, current.return));
            flags & 64 && $f394edd4427d52c3$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $f394edd4427d52c3$var$currentHoistableRoot;
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f394edd4427d52c3$var$offscreenSubtreeWasHidden || null === current || $f394edd4427d52c3$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$f394edd4427d52c3$var$internalHoistableMarker] || currentResource[$f394edd4427d52c3$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $f394edd4427d52c3$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$f394edd4427d52c3$var$internalInstanceKey] = finishedWork;
                                        $f394edd4427d52c3$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $f394edd4427d52c3$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f394edd4427d52c3$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $f394edd4427d52c3$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f394edd4427d52c3$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$f394edd4427d52c3$var$internalInstanceKey] = finishedWork;
                                $f394edd4427d52c3$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $f394edd4427d52c3$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $f394edd4427d52c3$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $f394edd4427d52c3$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $f394edd4427d52c3$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $f394edd4427d52c3$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f394edd4427d52c3$var$offscreenSubtreeWasHidden || null === current || $f394edd4427d52c3$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $f394edd4427d52c3$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f394edd4427d52c3$var$offscreenSubtreeWasHidden || null === current || $f394edd4427d52c3$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $f394edd4427d52c3$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $f394edd4427d52c3$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($f394edd4427d52c3$var$needsFormReset = !0);
            break;
        case 6:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $f394edd4427d52c3$var$tagCaches = null;
            hoistableRoot = $f394edd4427d52c3$var$currentHoistableRoot;
            $f394edd4427d52c3$var$currentHoistableRoot = $f394edd4427d52c3$var$getHoistableRoot(root.containerInfo);
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$currentHoistableRoot = hoistableRoot;
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $f394edd4427d52c3$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $f394edd4427d52c3$var$needsFormReset && ($f394edd4427d52c3$var$needsFormReset = !1, $f394edd4427d52c3$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $f394edd4427d52c3$var$currentHoistableRoot;
            $f394edd4427d52c3$var$currentHoistableRoot = $f394edd4427d52c3$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            $f394edd4427d52c3$var$currentHoistableRoot = flags;
            break;
        case 12:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($f394edd4427d52c3$var$globalMostRecentFallbackTime = $f394edd4427d52c3$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $f394edd4427d52c3$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $f394edd4427d52c3$var$offscreenSubtreeWasHidden;
            $f394edd4427d52c3$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $f394edd4427d52c3$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $f394edd4427d52c3$var$offscreenSubtreeIsHidden || $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $f394edd4427d52c3$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $f394edd4427d52c3$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $f394edd4427d52c3$var$hideOrUnhideDehydratedBoundary(instance, !0) : $f394edd4427d52c3$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $f394edd4427d52c3$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork), $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
    }
}
function $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($f394edd4427d52c3$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $f394edd4427d52c3$var$getHostSibling(finishedWork);
                    $f394edd4427d52c3$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($f394edd4427d52c3$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $f394edd4427d52c3$var$getHostSibling(finishedWork);
                    $f394edd4427d52c3$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $f394edd4427d52c3$var$getHostSibling(finishedWork);
                    $f394edd4427d52c3$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $f394edd4427d52c3$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $f394edd4427d52c3$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $f394edd4427d52c3$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $f394edd4427d52c3$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $f394edd4427d52c3$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $f394edd4427d52c3$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $f394edd4427d52c3$var$safelyDetachRef(finishedWork, finishedWork.return);
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f394edd4427d52c3$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$f394edd4427d52c3$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $f394edd4427d52c3$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $f394edd4427d52c3$var$commitClassCallbacks(finishedWork);
                $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $f394edd4427d52c3$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $f394edd4427d52c3$var$commitHostMount(finishedWork);
                $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f394edd4427d52c3$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f394edd4427d52c3$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $f394edd4427d52c3$var$releaseCache(previousCache));
}
function $f394edd4427d52c3$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $f394edd4427d52c3$var$releaseCache(current));
}
function $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $f394edd4427d52c3$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f394edd4427d52c3$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $f394edd4427d52c3$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $f394edd4427d52c3$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f394edd4427d52c3$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $f394edd4427d52c3$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $f394edd4427d52c3$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $f394edd4427d52c3$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f394edd4427d52c3$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f394edd4427d52c3$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $f394edd4427d52c3$var$suspenseyCommitFlag = 8192;
function $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $f394edd4427d52c3$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $f394edd4427d52c3$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $f394edd4427d52c3$var$suspenseyCommitFlag && null !== fiber.memoizedState && $f394edd4427d52c3$var$suspendResource(suspendedState, $f394edd4427d52c3$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $f394edd4427d52c3$var$currentHoistableRoot;
            $f394edd4427d52c3$var$currentHoistableRoot = $f394edd4427d52c3$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $f394edd4427d52c3$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $f394edd4427d52c3$var$suspenseyCommitFlag, $f394edd4427d52c3$var$suspenseyCommitFlag = 16777216, $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $f394edd4427d52c3$var$suspenseyCommitFlag = previousHoistableRoot) : $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $f394edd4427d52c3$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f394edd4427d52c3$var$nextEffect = childToDelete;
            $f394edd4427d52c3$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f394edd4427d52c3$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $f394edd4427d52c3$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $f394edd4427d52c3$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f394edd4427d52c3$var$nextEffect = childToDelete;
            $f394edd4427d52c3$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f394edd4427d52c3$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $f394edd4427d52c3$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $f394edd4427d52c3$var$nextEffect;){
        var fiber = $f394edd4427d52c3$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $f394edd4427d52c3$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $f394edd4427d52c3$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $f394edd4427d52c3$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $f394edd4427d52c3$var$nextEffect;){
            cache = $f394edd4427d52c3$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $f394edd4427d52c3$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $f394edd4427d52c3$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $f394edd4427d52c3$var$nextEffect = sibling;
                break a;
            }
            $f394edd4427d52c3$var$nextEffect = returnFiber;
        }
    }
}
var $f394edd4427d52c3$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $f394edd4427d52c3$var$readContext($f394edd4427d52c3$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $f394edd4427d52c3$var$readContext($f394edd4427d52c3$var$CacheContext).controller.signal;
    }
}, $f394edd4427d52c3$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $f394edd4427d52c3$var$executionContext = 0, $f394edd4427d52c3$var$workInProgressRoot = null, $f394edd4427d52c3$var$workInProgress = null, $f394edd4427d52c3$var$workInProgressRootRenderLanes = 0, $f394edd4427d52c3$var$workInProgressSuspendedReason = 0, $f394edd4427d52c3$var$workInProgressThrownValue = null, $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings = !1, $f394edd4427d52c3$var$workInProgressRootIsPrerendering = !1, $f394edd4427d52c3$var$workInProgressRootDidAttachPingListener = !1, $f394edd4427d52c3$var$entangledRenderLanes = 0, $f394edd4427d52c3$var$workInProgressRootExitStatus = 0, $f394edd4427d52c3$var$workInProgressRootSkippedLanes = 0, $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes = 0, $f394edd4427d52c3$var$workInProgressRootPingedLanes = 0, $f394edd4427d52c3$var$workInProgressDeferredLane = 0, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes = 0, $f394edd4427d52c3$var$workInProgressRootConcurrentErrors = null, $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = null, $f394edd4427d52c3$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $f394edd4427d52c3$var$globalMostRecentFallbackTime = 0, $f394edd4427d52c3$var$globalMostRecentTransitionTime = 0, $f394edd4427d52c3$var$workInProgressRootRenderTargetTime = Infinity, $f394edd4427d52c3$var$workInProgressTransitions = null, $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed = null, $f394edd4427d52c3$var$pendingEffectsStatus = 0, $f394edd4427d52c3$var$pendingEffectsRoot = null, $f394edd4427d52c3$var$pendingFinishedWork = null, $f394edd4427d52c3$var$pendingEffectsLanes = 0, $f394edd4427d52c3$var$pendingEffectsRemainingLanes = 0, $f394edd4427d52c3$var$pendingPassiveTransitions = null, $f394edd4427d52c3$var$pendingRecoverableErrors = null, $f394edd4427d52c3$var$nestedUpdateCount = 0, $f394edd4427d52c3$var$rootWithNestedUpdates = null;
function $f394edd4427d52c3$var$requestUpdateLane() {
    return 0 !== ($f394edd4427d52c3$var$executionContext & 2) && 0 !== $f394edd4427d52c3$var$workInProgressRootRenderLanes ? $f394edd4427d52c3$var$workInProgressRootRenderLanes & -$f394edd4427d52c3$var$workInProgressRootRenderLanes : null !== $f394edd4427d52c3$var$ReactSharedInternals.T ? $f394edd4427d52c3$var$requestTransitionLane() : $f394edd4427d52c3$var$resolveUpdatePriority();
}
function $f394edd4427d52c3$var$requestDeferredLane() {
    if (0 === $f394edd4427d52c3$var$workInProgressDeferredLane) {
        if (0 === ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 536870912) || $f394edd4427d52c3$var$isHydrating) {
            var lane = $f394edd4427d52c3$var$nextTransitionDeferredLane;
            $f394edd4427d52c3$var$nextTransitionDeferredLane <<= 1;
            0 === ($f394edd4427d52c3$var$nextTransitionDeferredLane & 3932160) && ($f394edd4427d52c3$var$nextTransitionDeferredLane = 262144);
            $f394edd4427d52c3$var$workInProgressDeferredLane = lane;
        } else $f394edd4427d52c3$var$workInProgressDeferredLane = 536870912;
    }
    lane = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $f394edd4427d52c3$var$workInProgressDeferredLane;
}
function $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $f394edd4427d52c3$var$workInProgressRoot && (2 === $f394edd4427d52c3$var$workInProgressSuspendedReason || 9 === $f394edd4427d52c3$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $f394edd4427d52c3$var$prepareFreshStack(root, 0), $f394edd4427d52c3$var$markRootSuspended(root, $f394edd4427d52c3$var$workInProgressRootRenderLanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !1);
    $f394edd4427d52c3$var$markRootUpdated$1(root, lane);
    if (0 === ($f394edd4427d52c3$var$executionContext & 2) || root !== $f394edd4427d52c3$var$workInProgressRoot) root === $f394edd4427d52c3$var$workInProgressRoot && (0 === ($f394edd4427d52c3$var$executionContext & 2) && ($f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $f394edd4427d52c3$var$workInProgressRootExitStatus && $f394edd4427d52c3$var$markRootSuspended(root, $f394edd4427d52c3$var$workInProgressRootRenderLanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !1)), $f394edd4427d52c3$var$ensureRootIsScheduled(root);
}
function $f394edd4427d52c3$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($f394edd4427d52c3$var$executionContext & 6)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $f394edd4427d52c3$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $f394edd4427d52c3$var$renderRootConcurrent(root$jscomp$0, lanes) : $f394edd4427d52c3$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $f394edd4427d52c3$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $f394edd4427d52c3$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$f394edd4427d52c3$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $f394edd4427d52c3$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $f394edd4427d52c3$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($f394edd4427d52c3$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $f394edd4427d52c3$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($f394edd4427d52c3$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $f394edd4427d52c3$var$workInProgressRootRecoverableErrors;
                            $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $f394edd4427d52c3$var$workInProgressRootRecoverableErrors ? $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $f394edd4427d52c3$var$workInProgressRootRecoverableErrors.push.apply($f394edd4427d52c3$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $f394edd4427d52c3$var$prepareFreshStack(root$jscomp$0, 0);
                $f394edd4427d52c3$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $f394edd4427d52c3$var$markRootSuspended(shouldTimeSlice, lanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !$f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $f394edd4427d52c3$var$globalMostRecentFallbackTime + 300 - $f394edd4427d52c3$var$now(), 10 < exitStatus)) {
                    $f394edd4427d52c3$var$markRootSuspended(shouldTimeSlice, lanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !$f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $f394edd4427d52c3$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $f394edd4427d52c3$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $f394edd4427d52c3$var$scheduleTimeout($f394edd4427d52c3$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $f394edd4427d52c3$var$workInProgressRootRecoverableErrors, $f394edd4427d52c3$var$workInProgressTransitions, $f394edd4427d52c3$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f394edd4427d52c3$var$workInProgressDeferredLane, $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes, $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $f394edd4427d52c3$var$commitRootWhenReady(shouldTimeSlice, forceSync, $f394edd4427d52c3$var$workInProgressRootRecoverableErrors, $f394edd4427d52c3$var$workInProgressTransitions, $f394edd4427d52c3$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f394edd4427d52c3$var$workInProgressDeferredLane, $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes, $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $f394edd4427d52c3$var$ensureRootIsScheduled(root$jscomp$0);
}
function $f394edd4427d52c3$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $f394edd4427d52c3$var$noop$1
        };
        $f394edd4427d52c3$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $f394edd4427d52c3$var$globalMostRecentFallbackTime - $f394edd4427d52c3$var$now() : (lanes & 4194048) === lanes ? $f394edd4427d52c3$var$globalMostRecentTransitionTime - $f394edd4427d52c3$var$now() : 0;
        timeoutOffset = $f394edd4427d52c3$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $f394edd4427d52c3$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($f394edd4427d52c3$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $f394edd4427d52c3$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $f394edd4427d52c3$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $f394edd4427d52c3$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$f394edd4427d52c3$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $f394edd4427d52c3$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$f394edd4427d52c3$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $f394edd4427d52c3$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $f394edd4427d52c3$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $f394edd4427d52c3$var$flushSyncWork$1() {
    return 0 === ($f394edd4427d52c3$var$executionContext & 6) ? ($f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $f394edd4427d52c3$var$resetWorkInProgressStack() {
    if (null !== $f394edd4427d52c3$var$workInProgress) {
        if (0 === $f394edd4427d52c3$var$workInProgressSuspendedReason) var interruptedWork = $f394edd4427d52c3$var$workInProgress.return;
        else interruptedWork = $f394edd4427d52c3$var$workInProgress, $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null, $f394edd4427d52c3$var$resetHooksOnUnwind(interruptedWork), $f394edd4427d52c3$var$thenableState$1 = null, $f394edd4427d52c3$var$thenableIndexCounter$1 = 0, interruptedWork = $f394edd4427d52c3$var$workInProgress;
        for(; null !== interruptedWork;)$f394edd4427d52c3$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $f394edd4427d52c3$var$workInProgress = null;
    }
}
function $f394edd4427d52c3$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $f394edd4427d52c3$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $f394edd4427d52c3$var$pendingEffectsLanes = 0;
    $f394edd4427d52c3$var$resetWorkInProgressStack();
    $f394edd4427d52c3$var$workInProgressRoot = root;
    $f394edd4427d52c3$var$workInProgress = timeoutHandle = $f394edd4427d52c3$var$createWorkInProgress(root.current, null);
    $f394edd4427d52c3$var$workInProgressRootRenderLanes = lanes;
    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
    $f394edd4427d52c3$var$workInProgressThrownValue = null;
    $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $f394edd4427d52c3$var$workInProgressRootIsPrerendering = $f394edd4427d52c3$var$checkIfRootIsPrerendering(root, lanes);
    $f394edd4427d52c3$var$workInProgressRootDidAttachPingListener = !1;
    $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes = $f394edd4427d52c3$var$workInProgressDeferredLane = $f394edd4427d52c3$var$workInProgressRootPingedLanes = $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes = $f394edd4427d52c3$var$workInProgressRootSkippedLanes = $f394edd4427d52c3$var$workInProgressRootExitStatus = 0;
    $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = $f394edd4427d52c3$var$workInProgressRootConcurrentErrors = null;
    $f394edd4427d52c3$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $f394edd4427d52c3$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $f394edd4427d52c3$var$entangledRenderLanes = lanes;
    $f394edd4427d52c3$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $f394edd4427d52c3$var$handleThrow(root, thrownValue) {
    $f394edd4427d52c3$var$currentlyRenderingFiber = null;
    $f394edd4427d52c3$var$ReactSharedInternals.H = $f394edd4427d52c3$var$ContextOnlyDispatcher;
    thrownValue === $f394edd4427d52c3$var$SuspenseException || thrownValue === $f394edd4427d52c3$var$SuspenseActionException ? (thrownValue = $f394edd4427d52c3$var$getSuspendedThenable(), $f394edd4427d52c3$var$workInProgressSuspendedReason = 3) : thrownValue === $f394edd4427d52c3$var$SuspenseyCommitException ? (thrownValue = $f394edd4427d52c3$var$getSuspendedThenable(), $f394edd4427d52c3$var$workInProgressSuspendedReason = 4) : $f394edd4427d52c3$var$workInProgressSuspendedReason = thrownValue === $f394edd4427d52c3$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $f394edd4427d52c3$var$workInProgressThrownValue = thrownValue;
    null === $f394edd4427d52c3$var$workInProgress && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 1, $f394edd4427d52c3$var$logUncaughtError(root, $f394edd4427d52c3$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $f394edd4427d52c3$var$shouldRemainOnPreviousScreen() {
    var handler = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 4194048) === $f394edd4427d52c3$var$workInProgressRootRenderLanes ? null === $f394edd4427d52c3$var$shellBoundary ? !0 : !1 : ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 62914560) === $f394edd4427d52c3$var$workInProgressRootRenderLanes || 0 !== ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 536870912) ? handler === $f394edd4427d52c3$var$shellBoundary : !1;
}
function $f394edd4427d52c3$var$pushDispatcher() {
    var prevDispatcher = $f394edd4427d52c3$var$ReactSharedInternals.H;
    $f394edd4427d52c3$var$ReactSharedInternals.H = $f394edd4427d52c3$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $f394edd4427d52c3$var$ContextOnlyDispatcher : prevDispatcher;
}
function $f394edd4427d52c3$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $f394edd4427d52c3$var$ReactSharedInternals.A;
    $f394edd4427d52c3$var$ReactSharedInternals.A = $f394edd4427d52c3$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible() {
    $f394edd4427d52c3$var$workInProgressRootExitStatus = 4;
    $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings || ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 4194048) !== $f394edd4427d52c3$var$workInProgressRootRenderLanes && null !== $f394edd4427d52c3$var$suspenseHandlerStackCursor.current || ($f394edd4427d52c3$var$workInProgressRootIsPrerendering = !0);
    0 === ($f394edd4427d52c3$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $f394edd4427d52c3$var$workInProgressRoot || $f394edd4427d52c3$var$markRootSuspended($f394edd4427d52c3$var$workInProgressRoot, $f394edd4427d52c3$var$workInProgressRootRenderLanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !1);
}
function $f394edd4427d52c3$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
    $f394edd4427d52c3$var$executionContext |= 2;
    var prevDispatcher = $f394edd4427d52c3$var$pushDispatcher(), prevAsyncDispatcher = $f394edd4427d52c3$var$pushAsyncDispatcher();
    if ($f394edd4427d52c3$var$workInProgressRoot !== root || $f394edd4427d52c3$var$workInProgressRootRenderLanes !== lanes) $f394edd4427d52c3$var$workInProgressTransitions = null, $f394edd4427d52c3$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $f394edd4427d52c3$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $f394edd4427d52c3$var$workInProgressSuspendedReason && null !== $f394edd4427d52c3$var$workInProgress) {
            var unitOfWork = $f394edd4427d52c3$var$workInProgress, thrownValue = $f394edd4427d52c3$var$workInProgressThrownValue;
            switch($f394edd4427d52c3$var$workInProgressSuspendedReason){
                case 8:
                    $f394edd4427d52c3$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $f394edd4427d52c3$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $f394edd4427d52c3$var$workInProgressSuspendedReason;
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                    $f394edd4427d52c3$var$workInProgressThrownValue = null;
                    $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $f394edd4427d52c3$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $f394edd4427d52c3$var$workInProgressSuspendedReason, $f394edd4427d52c3$var$workInProgressSuspendedReason = 0, $f394edd4427d52c3$var$workInProgressThrownValue = null, $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $f394edd4427d52c3$var$workLoopSync();
        exitStatus = $f394edd4427d52c3$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $f394edd4427d52c3$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null;
    $f394edd4427d52c3$var$executionContext = prevExecutionContext;
    $f394edd4427d52c3$var$ReactSharedInternals.H = prevDispatcher;
    $f394edd4427d52c3$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $f394edd4427d52c3$var$workInProgress && ($f394edd4427d52c3$var$workInProgressRoot = null, $f394edd4427d52c3$var$workInProgressRootRenderLanes = 0, $f394edd4427d52c3$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $f394edd4427d52c3$var$workLoopSync() {
    for(; null !== $f394edd4427d52c3$var$workInProgress;)$f394edd4427d52c3$var$performUnitOfWork($f394edd4427d52c3$var$workInProgress);
}
function $f394edd4427d52c3$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
    $f394edd4427d52c3$var$executionContext |= 2;
    var prevDispatcher = $f394edd4427d52c3$var$pushDispatcher(), prevAsyncDispatcher = $f394edd4427d52c3$var$pushAsyncDispatcher();
    $f394edd4427d52c3$var$workInProgressRoot !== root || $f394edd4427d52c3$var$workInProgressRootRenderLanes !== lanes ? ($f394edd4427d52c3$var$workInProgressTransitions = null, $f394edd4427d52c3$var$workInProgressRootRenderTargetTime = $f394edd4427d52c3$var$now() + 500, $f394edd4427d52c3$var$prepareFreshStack(root, lanes)) : $f394edd4427d52c3$var$workInProgressRootIsPrerendering = $f394edd4427d52c3$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $f394edd4427d52c3$var$workInProgressSuspendedReason && null !== $f394edd4427d52c3$var$workInProgress) {
            lanes = $f394edd4427d52c3$var$workInProgress;
            var thrownValue = $f394edd4427d52c3$var$workInProgressThrownValue;
            b: switch($f394edd4427d52c3$var$workInProgressSuspendedReason){
                case 1:
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                    $f394edd4427d52c3$var$workInProgressThrownValue = null;
                    $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($f394edd4427d52c3$var$isThenableResolved(thrownValue)) {
                        $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                        $f394edd4427d52c3$var$workInProgressThrownValue = null;
                        $f394edd4427d52c3$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $f394edd4427d52c3$var$workInProgressSuspendedReason && 9 !== $f394edd4427d52c3$var$workInProgressSuspendedReason || $f394edd4427d52c3$var$workInProgressRoot !== root || ($f394edd4427d52c3$var$workInProgressSuspendedReason = 7);
                        $f394edd4427d52c3$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $f394edd4427d52c3$var$isThenableResolved(thrownValue) ? ($f394edd4427d52c3$var$workInProgressSuspendedReason = 0, $f394edd4427d52c3$var$workInProgressThrownValue = null, $f394edd4427d52c3$var$replaySuspendedUnitOfWork(lanes)) : ($f394edd4427d52c3$var$workInProgressSuspendedReason = 0, $f394edd4427d52c3$var$workInProgressThrownValue = null, $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($f394edd4427d52c3$var$workInProgress.tag){
                        case 26:
                            resource = $f394edd4427d52c3$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $f394edd4427d52c3$var$workInProgress;
                            if (resource ? $f394edd4427d52c3$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                                $f394edd4427d52c3$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $f394edd4427d52c3$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($f394edd4427d52c3$var$workInProgress = returnFiber, $f394edd4427d52c3$var$completeUnitOfWork(returnFiber)) : $f394edd4427d52c3$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                    $f394edd4427d52c3$var$workInProgressThrownValue = null;
                    $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                    $f394edd4427d52c3$var$workInProgressThrownValue = null;
                    $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $f394edd4427d52c3$var$resetWorkInProgressStack();
                    $f394edd4427d52c3$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(462));
            }
        }
        $f394edd4427d52c3$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $f394edd4427d52c3$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null;
    $f394edd4427d52c3$var$ReactSharedInternals.H = prevDispatcher;
    $f394edd4427d52c3$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $f394edd4427d52c3$var$executionContext = prevExecutionContext;
    if (null !== $f394edd4427d52c3$var$workInProgress) return 0;
    $f394edd4427d52c3$var$workInProgressRoot = null;
    $f394edd4427d52c3$var$workInProgressRootRenderLanes = 0;
    $f394edd4427d52c3$var$finishQueueingConcurrentUpdates();
    return $f394edd4427d52c3$var$workInProgressRootExitStatus;
}
function $f394edd4427d52c3$var$workLoopConcurrentByScheduler() {
    for(; null !== $f394edd4427d52c3$var$workInProgress && !$f394edd4427d52c3$var$shouldYield();)$f394edd4427d52c3$var$performUnitOfWork($f394edd4427d52c3$var$workInProgress);
}
function $f394edd4427d52c3$var$performUnitOfWork(unitOfWork) {
    var next = $f394edd4427d52c3$var$beginWork(unitOfWork.alternate, unitOfWork, $f394edd4427d52c3$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f394edd4427d52c3$var$completeUnitOfWork(unitOfWork) : $f394edd4427d52c3$var$workInProgress = next;
}
function $f394edd4427d52c3$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $f394edd4427d52c3$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $f394edd4427d52c3$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $f394edd4427d52c3$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $f394edd4427d52c3$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $f394edd4427d52c3$var$resetHooksOnUnwind(next);
        default:
            $f394edd4427d52c3$var$unwindInterruptedWork(current, next), next = $f394edd4427d52c3$var$workInProgress = $f394edd4427d52c3$var$resetWorkInProgress(next, $f394edd4427d52c3$var$entangledRenderLanes), next = $f394edd4427d52c3$var$beginWork(current, next, $f394edd4427d52c3$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f394edd4427d52c3$var$completeUnitOfWork(unitOfWork) : $f394edd4427d52c3$var$workInProgress = next;
}
function $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null;
    $f394edd4427d52c3$var$resetHooksOnUnwind(unitOfWork);
    $f394edd4427d52c3$var$thenableState$1 = null;
    $f394edd4427d52c3$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($f394edd4427d52c3$var$throwException(root, returnFiber, unitOfWork, thrownValue, $f394edd4427d52c3$var$workInProgressRootRenderLanes)) {
            $f394edd4427d52c3$var$workInProgressRootExitStatus = 1;
            $f394edd4427d52c3$var$logUncaughtError(root, $f394edd4427d52c3$var$createCapturedValueAtFiber(thrownValue, root.current));
            $f394edd4427d52c3$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $f394edd4427d52c3$var$workInProgress = returnFiber, error;
        $f394edd4427d52c3$var$workInProgressRootExitStatus = 1;
        $f394edd4427d52c3$var$logUncaughtError(root, $f394edd4427d52c3$var$createCapturedValueAtFiber(thrownValue, root.current));
        $f394edd4427d52c3$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($f394edd4427d52c3$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($f394edd4427d52c3$var$workInProgressRootIsPrerendering || 0 !== ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $f394edd4427d52c3$var$unwindUnitOfWork(unitOfWork, root);
    } else $f394edd4427d52c3$var$completeUnitOfWork(unitOfWork);
}
function $f394edd4427d52c3$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $f394edd4427d52c3$var$unwindUnitOfWork(completedWork, $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $f394edd4427d52c3$var$completeWork(completedWork.alternate, completedWork, $f394edd4427d52c3$var$entangledRenderLanes);
        if (null !== next) {
            $f394edd4427d52c3$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $f394edd4427d52c3$var$workInProgress = completedWork;
            return;
        }
        $f394edd4427d52c3$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 5);
}
function $f394edd4427d52c3$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $f394edd4427d52c3$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $f394edd4427d52c3$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $f394edd4427d52c3$var$workInProgress = unitOfWork;
            return;
        }
        $f394edd4427d52c3$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $f394edd4427d52c3$var$workInProgressRootExitStatus = 6;
    $f394edd4427d52c3$var$workInProgress = null;
}
function $f394edd4427d52c3$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $f394edd4427d52c3$var$flushPendingEffects();
    while (0 !== $f394edd4427d52c3$var$pendingEffectsStatus);
    if (0 !== ($f394edd4427d52c3$var$executionContext & 6)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $f394edd4427d52c3$var$concurrentlyUpdatedLanes;
        $f394edd4427d52c3$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $f394edd4427d52c3$var$workInProgressRoot && ($f394edd4427d52c3$var$workInProgress = $f394edd4427d52c3$var$workInProgressRoot = null, $f394edd4427d52c3$var$workInProgressRootRenderLanes = 0);
        $f394edd4427d52c3$var$pendingFinishedWork = finishedWork;
        $f394edd4427d52c3$var$pendingEffectsRoot = root;
        $f394edd4427d52c3$var$pendingEffectsLanes = lanes;
        $f394edd4427d52c3$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $f394edd4427d52c3$var$pendingPassiveTransitions = transitions;
        $f394edd4427d52c3$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $f394edd4427d52c3$var$scheduleCallback$1($f394edd4427d52c3$var$NormalPriority$1, function() {
            $f394edd4427d52c3$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $f394edd4427d52c3$var$ReactSharedInternals.T;
            $f394edd4427d52c3$var$ReactSharedInternals.T = null;
            transitions = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
            $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $f394edd4427d52c3$var$executionContext;
            $f394edd4427d52c3$var$executionContext |= 4;
            try {
                $f394edd4427d52c3$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $f394edd4427d52c3$var$executionContext = spawnedLane, $f394edd4427d52c3$var$ReactDOMSharedInternals.p = transitions, $f394edd4427d52c3$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $f394edd4427d52c3$var$pendingEffectsStatus = 1;
        $f394edd4427d52c3$var$flushMutationEffects();
        $f394edd4427d52c3$var$flushLayoutEffects();
        $f394edd4427d52c3$var$flushSpawnedWork();
    }
}
function $f394edd4427d52c3$var$flushMutationEffects() {
    if (1 === $f394edd4427d52c3$var$pendingEffectsStatus) {
        $f394edd4427d52c3$var$pendingEffectsStatus = 0;
        var root = $f394edd4427d52c3$var$pendingEffectsRoot, finishedWork = $f394edd4427d52c3$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $f394edd4427d52c3$var$ReactSharedInternals.T;
            $f394edd4427d52c3$var$ReactSharedInternals.T = null;
            var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
            $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
            $f394edd4427d52c3$var$executionContext |= 4;
            try {
                $f394edd4427d52c3$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $f394edd4427d52c3$var$selectionInformation, curFocusedElem = $f394edd4427d52c3$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $f394edd4427d52c3$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $f394edd4427d52c3$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $f394edd4427d52c3$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $f394edd4427d52c3$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $f394edd4427d52c3$var$_enabled = !!$f394edd4427d52c3$var$eventsEnabled;
                $f394edd4427d52c3$var$selectionInformation = $f394edd4427d52c3$var$eventsEnabled = null;
            } finally{
                $f394edd4427d52c3$var$executionContext = prevExecutionContext, $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $f394edd4427d52c3$var$pendingEffectsStatus = 2;
    }
}
function $f394edd4427d52c3$var$flushLayoutEffects() {
    if (2 === $f394edd4427d52c3$var$pendingEffectsStatus) {
        $f394edd4427d52c3$var$pendingEffectsStatus = 0;
        var root = $f394edd4427d52c3$var$pendingEffectsRoot, finishedWork = $f394edd4427d52c3$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $f394edd4427d52c3$var$ReactSharedInternals.T;
            $f394edd4427d52c3$var$ReactSharedInternals.T = null;
            var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
            $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
            $f394edd4427d52c3$var$executionContext |= 4;
            try {
                $f394edd4427d52c3$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $f394edd4427d52c3$var$executionContext = prevExecutionContext, $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $f394edd4427d52c3$var$pendingEffectsStatus = 3;
    }
}
function $f394edd4427d52c3$var$flushSpawnedWork() {
    if (4 === $f394edd4427d52c3$var$pendingEffectsStatus || 3 === $f394edd4427d52c3$var$pendingEffectsStatus) {
        $f394edd4427d52c3$var$pendingEffectsStatus = 0;
        $f394edd4427d52c3$var$requestPaint();
        var root = $f394edd4427d52c3$var$pendingEffectsRoot, finishedWork = $f394edd4427d52c3$var$pendingFinishedWork, lanes = $f394edd4427d52c3$var$pendingEffectsLanes, recoverableErrors = $f394edd4427d52c3$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $f394edd4427d52c3$var$pendingEffectsStatus = 5 : ($f394edd4427d52c3$var$pendingEffectsStatus = 0, $f394edd4427d52c3$var$pendingFinishedWork = $f394edd4427d52c3$var$pendingEffectsRoot = null, $f394edd4427d52c3$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $f394edd4427d52c3$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($f394edd4427d52c3$var$injectedHook && "function" === typeof $f394edd4427d52c3$var$injectedHook.onCommitFiberRoot) try {
            $f394edd4427d52c3$var$injectedHook.onCommitFiberRoot($f394edd4427d52c3$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $f394edd4427d52c3$var$ReactSharedInternals.T;
            remainingLanes = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
            $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2;
            $f394edd4427d52c3$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $f394edd4427d52c3$var$ReactSharedInternals.T = finishedWork, $f394edd4427d52c3$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($f394edd4427d52c3$var$pendingEffectsLanes & 3) && $f394edd4427d52c3$var$flushPendingEffects();
        $f394edd4427d52c3$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $f394edd4427d52c3$var$rootWithNestedUpdates ? $f394edd4427d52c3$var$nestedUpdateCount++ : ($f394edd4427d52c3$var$nestedUpdateCount = 0, $f394edd4427d52c3$var$rootWithNestedUpdates = root) : $f394edd4427d52c3$var$nestedUpdateCount = 0;
        $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $f394edd4427d52c3$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $f394edd4427d52c3$var$releaseCache(remainingLanes)));
}
function $f394edd4427d52c3$var$flushPendingEffects() {
    $f394edd4427d52c3$var$flushMutationEffects();
    $f394edd4427d52c3$var$flushLayoutEffects();
    $f394edd4427d52c3$var$flushSpawnedWork();
    return $f394edd4427d52c3$var$flushPassiveEffects();
}
function $f394edd4427d52c3$var$flushPassiveEffects() {
    if (5 !== $f394edd4427d52c3$var$pendingEffectsStatus) return !1;
    var root = $f394edd4427d52c3$var$pendingEffectsRoot, remainingLanes = $f394edd4427d52c3$var$pendingEffectsRemainingLanes;
    $f394edd4427d52c3$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $f394edd4427d52c3$var$lanesToEventPriority($f394edd4427d52c3$var$pendingEffectsLanes), prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T, previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    try {
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $f394edd4427d52c3$var$ReactSharedInternals.T = null;
        renderPriority = $f394edd4427d52c3$var$pendingPassiveTransitions;
        $f394edd4427d52c3$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $f394edd4427d52c3$var$pendingEffectsRoot, lanes = $f394edd4427d52c3$var$pendingEffectsLanes;
        $f394edd4427d52c3$var$pendingEffectsStatus = 0;
        $f394edd4427d52c3$var$pendingFinishedWork = $f394edd4427d52c3$var$pendingEffectsRoot = null;
        $f394edd4427d52c3$var$pendingEffectsLanes = 0;
        if (0 !== ($f394edd4427d52c3$var$executionContext & 6)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(331));
        var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
        $f394edd4427d52c3$var$executionContext |= 4;
        $f394edd4427d52c3$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $f394edd4427d52c3$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $f394edd4427d52c3$var$executionContext = prevExecutionContext;
        $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($f394edd4427d52c3$var$injectedHook && "function" === typeof $f394edd4427d52c3$var$injectedHook.onPostCommitFiberRoot) try {
            $f394edd4427d52c3$var$injectedHook.onPostCommitFiberRoot($f394edd4427d52c3$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition, $f394edd4427d52c3$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $f394edd4427d52c3$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $f394edd4427d52c3$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $f394edd4427d52c3$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $f394edd4427d52c3$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($f394edd4427d52c3$var$markRootUpdated$1(rootFiber, 2), $f394edd4427d52c3$var$ensureRootIsScheduled(rootFiber));
}
function $f394edd4427d52c3$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $f394edd4427d52c3$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $f394edd4427d52c3$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed || !$f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $f394edd4427d52c3$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $f394edd4427d52c3$var$createClassErrorUpdate(2);
                instance = $f394edd4427d52c3$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($f394edd4427d52c3$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $f394edd4427d52c3$var$markRootUpdated$1(instance, 2), $f394edd4427d52c3$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $f394edd4427d52c3$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $f394edd4427d52c3$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($f394edd4427d52c3$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $f394edd4427d52c3$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $f394edd4427d52c3$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $f394edd4427d52c3$var$workInProgressRoot === root && ($f394edd4427d52c3$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $f394edd4427d52c3$var$workInProgressRootExitStatus || 3 === $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 62914560) === $f394edd4427d52c3$var$workInProgressRootRenderLanes && 300 > $f394edd4427d52c3$var$now() - $f394edd4427d52c3$var$globalMostRecentFallbackTime ? 0 === ($f394edd4427d52c3$var$executionContext & 2) && $f394edd4427d52c3$var$prepareFreshStack(root, 0) : $f394edd4427d52c3$var$workInProgressRootPingedLanes |= pingedLanes, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes === $f394edd4427d52c3$var$workInProgressRootRenderLanes && ($f394edd4427d52c3$var$workInProgressSuspendedRetryLanes = 0));
    $f394edd4427d52c3$var$ensureRootIsScheduled(root);
}
function $f394edd4427d52c3$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $f394edd4427d52c3$var$claimNextRetryLane());
    boundaryFiber = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($f394edd4427d52c3$var$markRootUpdated$1(boundaryFiber, retryLane), $f394edd4427d52c3$var$ensureRootIsScheduled(boundaryFiber));
}
function $f394edd4427d52c3$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $f394edd4427d52c3$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f394edd4427d52c3$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $f394edd4427d52c3$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f394edd4427d52c3$var$scheduleCallback$1(priorityLevel, callback) {
    return $f394edd4427d52c3$var$scheduleCallback$3(priorityLevel, callback);
}
var $f394edd4427d52c3$var$firstScheduledRoot = null, $f394edd4427d52c3$var$lastScheduledRoot = null, $f394edd4427d52c3$var$didScheduleMicrotask = !1, $f394edd4427d52c3$var$mightHavePendingSyncWork = !1, $f394edd4427d52c3$var$isFlushingWork = !1, $f394edd4427d52c3$var$currentEventTransitionLane = 0;
function $f394edd4427d52c3$var$ensureRootIsScheduled(root) {
    root !== $f394edd4427d52c3$var$lastScheduledRoot && null === root.next && (null === $f394edd4427d52c3$var$lastScheduledRoot ? $f394edd4427d52c3$var$firstScheduledRoot = $f394edd4427d52c3$var$lastScheduledRoot = root : $f394edd4427d52c3$var$lastScheduledRoot = $f394edd4427d52c3$var$lastScheduledRoot.next = root);
    $f394edd4427d52c3$var$mightHavePendingSyncWork = !0;
    $f394edd4427d52c3$var$didScheduleMicrotask || ($f394edd4427d52c3$var$didScheduleMicrotask = !0, $f394edd4427d52c3$var$scheduleImmediateRootScheduleTask());
}
function $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$f394edd4427d52c3$var$isFlushingWork && $f394edd4427d52c3$var$mightHavePendingSyncWork) {
        $f394edd4427d52c3$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $f394edd4427d52c3$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $f394edd4427d52c3$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $f394edd4427d52c3$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $f394edd4427d52c3$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $f394edd4427d52c3$var$getNextLanes(root$170, root$170 === $f394edd4427d52c3$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $f394edd4427d52c3$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $f394edd4427d52c3$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $f394edd4427d52c3$var$isFlushingWork = !1;
    }
}
function $f394edd4427d52c3$var$processRootScheduleInImmediateTask() {
    $f394edd4427d52c3$var$processRootScheduleInMicrotask();
}
function $f394edd4427d52c3$var$processRootScheduleInMicrotask() {
    $f394edd4427d52c3$var$mightHavePendingSyncWork = $f394edd4427d52c3$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $f394edd4427d52c3$var$currentEventTransitionLane && $f394edd4427d52c3$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $f394edd4427d52c3$var$currentEventTransitionLane);
    for(var currentTime = $f394edd4427d52c3$var$now(), prev = null, root = $f394edd4427d52c3$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $f394edd4427d52c3$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $f394edd4427d52c3$var$firstScheduledRoot = next : prev.next = next, null === next && ($f394edd4427d52c3$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $f394edd4427d52c3$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $f394edd4427d52c3$var$pendingEffectsStatus && 5 !== $f394edd4427d52c3$var$pendingEffectsStatus || $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $f394edd4427d52c3$var$currentEventTransitionLane && ($f394edd4427d52c3$var$currentEventTransitionLane = 0);
}
function $f394edd4427d52c3$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $f394edd4427d52c3$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $f394edd4427d52c3$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $f394edd4427d52c3$var$workInProgressRoot;
    suspendedLanes = $f394edd4427d52c3$var$workInProgressRootRenderLanes;
    suspendedLanes = $f394edd4427d52c3$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $f394edd4427d52c3$var$workInProgressSuspendedReason || 9 === $f394edd4427d52c3$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $f394edd4427d52c3$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $f394edd4427d52c3$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $f394edd4427d52c3$var$cancelCallback$1(pingedLanes);
        switch($f394edd4427d52c3$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $f394edd4427d52c3$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $f394edd4427d52c3$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $f394edd4427d52c3$var$IdlePriority;
                break;
            default:
                suspendedLanes = $f394edd4427d52c3$var$NormalPriority$1;
        }
        pingedLanes = $f394edd4427d52c3$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $f394edd4427d52c3$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $f394edd4427d52c3$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $f394edd4427d52c3$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $f394edd4427d52c3$var$pendingEffectsStatus && 5 !== $f394edd4427d52c3$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($f394edd4427d52c3$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $f394edd4427d52c3$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $f394edd4427d52c3$var$getNextLanes(root, root === $f394edd4427d52c3$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $f394edd4427d52c3$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $f394edd4427d52c3$var$scheduleTaskForRootDuringMicrotask(root, $f394edd4427d52c3$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $f394edd4427d52c3$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $f394edd4427d52c3$var$performSyncWorkOnRoot(root, lanes) {
    if ($f394edd4427d52c3$var$flushPendingEffects()) return null;
    $f394edd4427d52c3$var$performWorkOnRoot(root, lanes, !0);
}
function $f394edd4427d52c3$var$scheduleImmediateRootScheduleTask() {
    $f394edd4427d52c3$var$scheduleMicrotask(function() {
        0 !== ($f394edd4427d52c3$var$executionContext & 6) ? $f394edd4427d52c3$var$scheduleCallback$3($f394edd4427d52c3$var$ImmediatePriority, $f394edd4427d52c3$var$processRootScheduleInImmediateTask) : $f394edd4427d52c3$var$processRootScheduleInMicrotask();
    });
}
function $f394edd4427d52c3$var$requestTransitionLane() {
    if (0 === $f394edd4427d52c3$var$currentEventTransitionLane) {
        var actionScopeLane = $f394edd4427d52c3$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $f394edd4427d52c3$var$nextTransitionUpdateLane, $f394edd4427d52c3$var$nextTransitionUpdateLane <<= 1, 0 === ($f394edd4427d52c3$var$nextTransitionUpdateLane & 261888) && ($f394edd4427d52c3$var$nextTransitionUpdateLane = 256));
        $f394edd4427d52c3$var$currentEventTransitionLane = actionScopeLane;
    }
    return $f394edd4427d52c3$var$currentEventTransitionLane;
}
function $f394edd4427d52c3$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $f394edd4427d52c3$var$sanitizeURL("" + actionProp);
}
function $f394edd4427d52c3$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $f394edd4427d52c3$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $f394edd4427d52c3$var$coerceFormActionProp((nativeEventTarget[$f394edd4427d52c3$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$f394edd4427d52c3$var$internalPropsKey] || null) ? $f394edd4427d52c3$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $f394edd4427d52c3$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $f394edd4427d52c3$var$currentEventTransitionLane) {
                                var formData = submitter ? $f394edd4427d52c3$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $f394edd4427d52c3$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $f394edd4427d52c3$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $f394edd4427d52c3$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $f394edd4427d52c3$var$i$jscomp$inline_1577 = 0; $f394edd4427d52c3$var$i$jscomp$inline_1577 < $f394edd4427d52c3$var$simpleEventPluginEvents.length; $f394edd4427d52c3$var$i$jscomp$inline_1577++){
    var $f394edd4427d52c3$var$eventName$jscomp$inline_1578 = $f394edd4427d52c3$var$simpleEventPluginEvents[$f394edd4427d52c3$var$i$jscomp$inline_1577], $f394edd4427d52c3$var$domEventName$jscomp$inline_1579 = $f394edd4427d52c3$var$eventName$jscomp$inline_1578.toLowerCase(), $f394edd4427d52c3$var$capitalizedEvent$jscomp$inline_1580 = $f394edd4427d52c3$var$eventName$jscomp$inline_1578[0].toUpperCase() + $f394edd4427d52c3$var$eventName$jscomp$inline_1578.slice(1);
    $f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$domEventName$jscomp$inline_1579, "on" + $f394edd4427d52c3$var$capitalizedEvent$jscomp$inline_1580);
}
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$ANIMATION_END, "onAnimationEnd");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$ANIMATION_ITERATION, "onAnimationIteration");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$ANIMATION_START, "onAnimationStart");
$f394edd4427d52c3$var$registerSimpleEvent("dblclick", "onDoubleClick");
$f394edd4427d52c3$var$registerSimpleEvent("focusin", "onFocus");
$f394edd4427d52c3$var$registerSimpleEvent("focusout", "onBlur");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$TRANSITION_RUN, "onTransitionRun");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$TRANSITION_START, "onTransitionStart");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$TRANSITION_CANCEL, "onTransitionCancel");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$TRANSITION_END, "onTransitionEnd");
$f394edd4427d52c3$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f394edd4427d52c3$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f394edd4427d52c3$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f394edd4427d52c3$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f394edd4427d52c3$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f394edd4427d52c3$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f394edd4427d52c3$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f394edd4427d52c3$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f394edd4427d52c3$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f394edd4427d52c3$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f394edd4427d52c3$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f394edd4427d52c3$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($f394edd4427d52c3$var$mediaEventTypes));
function $f394edd4427d52c3$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f394edd4427d52c3$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f394edd4427d52c3$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $f394edd4427d52c3$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$f394edd4427d52c3$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$f394edd4427d52c3$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($f394edd4427d52c3$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $f394edd4427d52c3$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $f394edd4427d52c3$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $f394edd4427d52c3$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $f394edd4427d52c3$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$f394edd4427d52c3$var$listeningMarker]) {
        rootContainerElement[$f394edd4427d52c3$var$listeningMarker] = !0;
        $f394edd4427d52c3$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($f394edd4427d52c3$var$nonDelegatedEvents.has(domEventName) || $f394edd4427d52c3$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $f394edd4427d52c3$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$f394edd4427d52c3$var$listeningMarker] || (ownerDocument[$f394edd4427d52c3$var$listeningMarker] = !0, $f394edd4427d52c3$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $f394edd4427d52c3$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($f394edd4427d52c3$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $f394edd4427d52c3$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $f394edd4427d52c3$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $f394edd4427d52c3$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$f394edd4427d52c3$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $f394edd4427d52c3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $f394edd4427d52c3$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $f394edd4427d52c3$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $f394edd4427d52c3$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $f394edd4427d52c3$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $f394edd4427d52c3$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticTouchEvent;
                        break;
                    case $f394edd4427d52c3$var$ANIMATION_END:
                    case $f394edd4427d52c3$var$ANIMATION_ITERATION:
                    case $f394edd4427d52c3$var$ANIMATION_START:
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticAnimationEvent;
                        break;
                    case $f394edd4427d52c3$var$TRANSITION_END:
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $f394edd4427d52c3$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($f394edd4427d52c3$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $f394edd4427d52c3$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($f394edd4427d52c3$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$f394edd4427d52c3$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $f394edd4427d52c3$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $f394edd4427d52c3$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $f394edd4427d52c3$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $f394edd4427d52c3$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $f394edd4427d52c3$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $f394edd4427d52c3$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $f394edd4427d52c3$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $f394edd4427d52c3$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $f394edd4427d52c3$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $f394edd4427d52c3$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $f394edd4427d52c3$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForChangeEvent;
                else if ($f394edd4427d52c3$var$isTextInputElement(reactName)) {
                    if ($f394edd4427d52c3$var$isInputEventSupported) getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $f394edd4427d52c3$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $f394edd4427d52c3$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForChangeEvent) : getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $f394edd4427d52c3$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $f394edd4427d52c3$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $f394edd4427d52c3$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($f394edd4427d52c3$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $f394edd4427d52c3$var$activeElement = handleEventFunc, $f394edd4427d52c3$var$activeElementInst = targetInst, $f394edd4427d52c3$var$lastSelection = null;
                    break;
                case "focusout":
                    $f394edd4427d52c3$var$lastSelection = $f394edd4427d52c3$var$activeElementInst = $f394edd4427d52c3$var$activeElement = null;
                    break;
                case "mousedown":
                    $f394edd4427d52c3$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f394edd4427d52c3$var$mouseDown = !1;
                    $f394edd4427d52c3$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($f394edd4427d52c3$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $f394edd4427d52c3$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($f394edd4427d52c3$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $f394edd4427d52c3$var$isComposing ? $f394edd4427d52c3$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($f394edd4427d52c3$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($f394edd4427d52c3$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $f394edd4427d52c3$var$isComposing && (fallbackData = $f394edd4427d52c3$var$getData()) : ($f394edd4427d52c3$var$root = nativeEventTarget, $f394edd4427d52c3$var$startText = "value" in $f394edd4427d52c3$var$root ? $f394edd4427d52c3$var$root.value : $f394edd4427d52c3$var$root.textContent, $f394edd4427d52c3$var$isComposing = !0)), handleEventFunc = $f394edd4427d52c3$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $f394edd4427d52c3$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $f394edd4427d52c3$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $f394edd4427d52c3$var$canUseTextInputEvent ? $f394edd4427d52c3$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $f394edd4427d52c3$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $f394edd4427d52c3$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $f394edd4427d52c3$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $f394edd4427d52c3$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $f394edd4427d52c3$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $f394edd4427d52c3$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $f394edd4427d52c3$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $f394edd4427d52c3$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($f394edd4427d52c3$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $f394edd4427d52c3$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($f394edd4427d52c3$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $f394edd4427d52c3$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $f394edd4427d52c3$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $f394edd4427d52c3$var$getListener(target, registrationName), null != stateNode && listeners.unshift($f394edd4427d52c3$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $f394edd4427d52c3$var$getListener(target, registrationName), null != stateNode && listeners.push($f394edd4427d52c3$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $f394edd4427d52c3$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $f394edd4427d52c3$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $f394edd4427d52c3$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($f394edd4427d52c3$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($f394edd4427d52c3$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $f394edd4427d52c3$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $f394edd4427d52c3$var$normalizeMarkupForTextOrAttribute(clientText);
    return $f394edd4427d52c3$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $f394edd4427d52c3$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $f394edd4427d52c3$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $f394edd4427d52c3$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $f394edd4427d52c3$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $f394edd4427d52c3$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $f394edd4427d52c3$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $f394edd4427d52c3$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $f394edd4427d52c3$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f394edd4427d52c3$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $f394edd4427d52c3$var$setProp(domElement, tag, "name", props.name, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($f394edd4427d52c3$var$setProp(domElement, tag, "encType", props.encType, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "method", props.method, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f394edd4427d52c3$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f394edd4427d52c3$var$noop$1);
            break;
        case "onScroll":
            null != value && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $f394edd4427d52c3$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", domElement);
            $f394edd4427d52c3$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $f394edd4427d52c3$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $f394edd4427d52c3$var$aliases.get(key) || key, $f394edd4427d52c3$var$setValueForAttribute(domElement, key, value);
    }
}
function $f394edd4427d52c3$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $f394edd4427d52c3$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $f394edd4427d52c3$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $f394edd4427d52c3$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f394edd4427d52c3$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$f394edd4427d52c3$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$f394edd4427d52c3$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $f394edd4427d52c3$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $f394edd4427d52c3$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                    default:
                        $f394edd4427d52c3$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $f394edd4427d52c3$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $f394edd4427d52c3$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $f394edd4427d52c3$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $f394edd4427d52c3$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $f394edd4427d52c3$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $f394edd4427d52c3$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(91));
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $f394edd4427d52c3$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("cancel", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $f394edd4427d52c3$var$mediaEventTypes.length; hasSrc++)$f394edd4427d52c3$var$listenToNonDelegatedEvent($f394edd4427d52c3$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", domElement), $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($f394edd4427d52c3$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $f394edd4427d52c3$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $f394edd4427d52c3$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $f394edd4427d52c3$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $f394edd4427d52c3$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $f394edd4427d52c3$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $f394edd4427d52c3$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $f394edd4427d52c3$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $f394edd4427d52c3$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $f394edd4427d52c3$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $f394edd4427d52c3$var$updateOptions(domElement, !!lastProps, tag, !0) : $f394edd4427d52c3$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $f394edd4427d52c3$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $f394edd4427d52c3$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $f394edd4427d52c3$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($f394edd4427d52c3$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $f394edd4427d52c3$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $f394edd4427d52c3$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $f394edd4427d52c3$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $f394edd4427d52c3$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $f394edd4427d52c3$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $f394edd4427d52c3$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $f394edd4427d52c3$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $f394edd4427d52c3$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $f394edd4427d52c3$var$eventsEnabled = null, $f394edd4427d52c3$var$selectionInformation = null;
function $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $f394edd4427d52c3$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $f394edd4427d52c3$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $f394edd4427d52c3$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $f394edd4427d52c3$var$currentPopstateTransitionEvent = null;
function $f394edd4427d52c3$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $f394edd4427d52c3$var$currentPopstateTransitionEvent) return !1;
        $f394edd4427d52c3$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $f394edd4427d52c3$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $f394edd4427d52c3$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $f394edd4427d52c3$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $f394edd4427d52c3$var$localPromise = "function" === typeof Promise ? Promise : void 0, $f394edd4427d52c3$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f394edd4427d52c3$var$localPromise ? function(callback) {
    return $f394edd4427d52c3$var$localPromise.resolve(null).then(callback).catch($f394edd4427d52c3$var$handleErrorInNextTick);
} : $f394edd4427d52c3$var$scheduleTimeout;
function $f394edd4427d52c3$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $f394edd4427d52c3$var$isSingletonScope(type) {
    return "head" === type;
}
function $f394edd4427d52c3$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $f394edd4427d52c3$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $f394edd4427d52c3$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $f394edd4427d52c3$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$f394edd4427d52c3$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $f394edd4427d52c3$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $f394edd4427d52c3$var$retryIfBlockedOn(hydrationInstance);
}
function $f394edd4427d52c3$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $f394edd4427d52c3$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $f394edd4427d52c3$var$clearContainerSparingly(node);
                $f394edd4427d52c3$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $f394edd4427d52c3$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$f394edd4427d52c3$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $f394edd4427d52c3$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $f394edd4427d52c3$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f394edd4427d52c3$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f394edd4427d52c3$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f394edd4427d52c3$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f394edd4427d52c3$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $f394edd4427d52c3$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $f394edd4427d52c3$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $f394edd4427d52c3$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $f394edd4427d52c3$var$previousHydratableOnEnteringScopedSingleton = null;
function $f394edd4427d52c3$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $f394edd4427d52c3$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $f394edd4427d52c3$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $f394edd4427d52c3$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(451));
    }
}
function $f394edd4427d52c3$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $f394edd4427d52c3$var$detachDeletedInstance(instance);
}
var $f394edd4427d52c3$var$preloadPropsMap = new Map(), $f394edd4427d52c3$var$preconnectsSet = new Set();
function $f394edd4427d52c3$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $f394edd4427d52c3$var$previousDispatcher = $f394edd4427d52c3$var$ReactDOMSharedInternals.d;
$f394edd4427d52c3$var$ReactDOMSharedInternals.d = {
    f: $f394edd4427d52c3$var$flushSyncWork,
    r: $f394edd4427d52c3$var$requestFormReset,
    D: $f394edd4427d52c3$var$prefetchDNS,
    C: $f394edd4427d52c3$var$preconnect,
    L: $f394edd4427d52c3$var$preload,
    m: $f394edd4427d52c3$var$preloadModule,
    X: $f394edd4427d52c3$var$preinitScript,
    S: $f394edd4427d52c3$var$preinitStyle,
    M: $f394edd4427d52c3$var$preinitModuleScript
};
function $f394edd4427d52c3$var$flushSyncWork() {
    var previousWasRendering = $f394edd4427d52c3$var$previousDispatcher.f(), wasRendering = $f394edd4427d52c3$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $f394edd4427d52c3$var$requestFormReset(form) {
    var formInst = $f394edd4427d52c3$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $f394edd4427d52c3$var$requestFormReset$1(formInst) : $f394edd4427d52c3$var$previousDispatcher.r(form);
}
var $f394edd4427d52c3$var$globalDocument = "undefined" === typeof document ? null : document;
function $f394edd4427d52c3$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $f394edd4427d52c3$var$preconnectsSet.has(limitedEscapedHref) || ($f394edd4427d52c3$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $f394edd4427d52c3$var$setInitialProperties(href, "link", rel), $f394edd4427d52c3$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $f394edd4427d52c3$var$prefetchDNS(href) {
    $f394edd4427d52c3$var$previousDispatcher.D(href);
    $f394edd4427d52c3$var$preconnectAs("dns-prefetch", href, null);
}
function $f394edd4427d52c3$var$preconnect(href, crossOrigin) {
    $f394edd4427d52c3$var$previousDispatcher.C(href, crossOrigin);
    $f394edd4427d52c3$var$preconnectAs("preconnect", href, crossOrigin);
}
function $f394edd4427d52c3$var$preload(href, as, options) {
    $f394edd4427d52c3$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $f394edd4427d52c3$var$getStyleKey(href);
                break;
            case "script":
                key = $f394edd4427d52c3$var$getScriptKey(href);
        }
        $f394edd4427d52c3$var$preloadPropsMap.has(key) || (href = $f394edd4427d52c3$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $f394edd4427d52c3$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $f394edd4427d52c3$var$setInitialProperties(as, "link", href), $f394edd4427d52c3$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $f394edd4427d52c3$var$preloadModule(href, options) {
    $f394edd4427d52c3$var$previousDispatcher.m(href, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $f394edd4427d52c3$var$getScriptKey(href);
        }
        if (!$f394edd4427d52c3$var$preloadPropsMap.has(key) && (href = $f394edd4427d52c3$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $f394edd4427d52c3$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $f394edd4427d52c3$var$setInitialProperties(as, "link", href);
            $f394edd4427d52c3$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $f394edd4427d52c3$var$preinitStyle(href, precedence, options) {
    $f394edd4427d52c3$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $f394edd4427d52c3$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $f394edd4427d52c3$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $f394edd4427d52c3$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $f394edd4427d52c3$var$preloadPropsMap.get(key)) && $f394edd4427d52c3$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $f394edd4427d52c3$var$markNodeAsHoistable(link);
                $f394edd4427d52c3$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $f394edd4427d52c3$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $f394edd4427d52c3$var$preinitScript(src, options) {
    $f394edd4427d52c3$var$previousDispatcher.X(src, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f394edd4427d52c3$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f394edd4427d52c3$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(key)), resource || (src = $f394edd4427d52c3$var$assign({
            src: src,
            async: !0
        }, options), (options = $f394edd4427d52c3$var$preloadPropsMap.get(key)) && $f394edd4427d52c3$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f394edd4427d52c3$var$markNodeAsHoistable(resource), $f394edd4427d52c3$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f394edd4427d52c3$var$preinitModuleScript(src, options) {
    $f394edd4427d52c3$var$previousDispatcher.M(src, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f394edd4427d52c3$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f394edd4427d52c3$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(key)), resource || (src = $f394edd4427d52c3$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $f394edd4427d52c3$var$preloadPropsMap.get(key)) && $f394edd4427d52c3$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f394edd4427d52c3$var$markNodeAsHoistable(resource), $f394edd4427d52c3$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f394edd4427d52c3$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $f394edd4427d52c3$var$rootInstanceStackCursor.current) ? $f394edd4427d52c3$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $f394edd4427d52c3$var$getStyleKey(pendingProps.href), pendingProps = $f394edd4427d52c3$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $f394edd4427d52c3$var$getStyleKey(pendingProps.href);
                var styles$243 = $f394edd4427d52c3$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $f394edd4427d52c3$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $f394edd4427d52c3$var$preloadPropsMap.set(type, pendingProps), styles$243 || $f394edd4427d52c3$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $f394edd4427d52c3$var$getScriptKey(pendingProps), pendingProps = $f394edd4427d52c3$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(444, type));
    }
}
function $f394edd4427d52c3$var$getStyleKey(href) {
    return 'href="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $f394edd4427d52c3$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $f394edd4427d52c3$var$stylesheetPropsFromRawProps(rawProps) {
    return $f394edd4427d52c3$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $f394edd4427d52c3$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $f394edd4427d52c3$var$setInitialProperties(key, "link", preloadProps), $f394edd4427d52c3$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $f394edd4427d52c3$var$getScriptKey(src) {
    return '[src="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $f394edd4427d52c3$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $f394edd4427d52c3$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $f394edd4427d52c3$var$markNodeAsHoistable(instance), instance;
            var styleProps = $f394edd4427d52c3$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $f394edd4427d52c3$var$markNodeAsHoistable(instance);
            $f394edd4427d52c3$var$setInitialProperties(instance, "style", styleProps);
            $f394edd4427d52c3$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $f394edd4427d52c3$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $f394edd4427d52c3$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $f394edd4427d52c3$var$stylesheetPropsFromRawProps(props);
            (styleProps = $f394edd4427d52c3$var$preloadPropsMap.get(styleProps)) && $f394edd4427d52c3$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $f394edd4427d52c3$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f394edd4427d52c3$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $f394edd4427d52c3$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $f394edd4427d52c3$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $f394edd4427d52c3$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $f394edd4427d52c3$var$preloadPropsMap.get(instance$249)) instance = $f394edd4427d52c3$var$assign({}, props), $f394edd4427d52c3$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $f394edd4427d52c3$var$markNodeAsHoistable(styleProps);
            $f394edd4427d52c3$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $f394edd4427d52c3$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $f394edd4427d52c3$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $f394edd4427d52c3$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $f394edd4427d52c3$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $f394edd4427d52c3$var$tagCaches = null;
function $f394edd4427d52c3$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $f394edd4427d52c3$var$tagCaches) {
        var cache = new Map();
        var caches = $f394edd4427d52c3$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $f394edd4427d52c3$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$f394edd4427d52c3$var$internalHoistableMarker] || node[$f394edd4427d52c3$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $f394edd4427d52c3$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $f394edd4427d52c3$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $f394edd4427d52c3$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $f394edd4427d52c3$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $f394edd4427d52c3$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $f394edd4427d52c3$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $f394edd4427d52c3$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $f394edd4427d52c3$var$stylesheetPropsFromRawProps(props);
            (key = $f394edd4427d52c3$var$preloadPropsMap.get(key)) && $f394edd4427d52c3$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $f394edd4427d52c3$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f394edd4427d52c3$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $f394edd4427d52c3$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $f394edd4427d52c3$var$estimatedBytesWithinLimit = 0;
function $f394edd4427d52c3$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $f394edd4427d52c3$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $f394edd4427d52c3$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $f394edd4427d52c3$var$estimatedBytesWithinLimit && ($f394edd4427d52c3$var$estimatedBytesWithinLimit = 62500 * $f394edd4427d52c3$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $f394edd4427d52c3$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $f394edd4427d52c3$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $f394edd4427d52c3$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $f394edd4427d52c3$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $f394edd4427d52c3$var$precedencesByRoot = null;
function $f394edd4427d52c3$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $f394edd4427d52c3$var$precedencesByRoot = new Map(), resources.forEach($f394edd4427d52c3$var$insertStylesheetIntoRoot, state), $f394edd4427d52c3$var$precedencesByRoot = null, $f394edd4427d52c3$var$onUnsuspend.call(state));
}
function $f394edd4427d52c3$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $f394edd4427d52c3$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $f394edd4427d52c3$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $f394edd4427d52c3$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $f394edd4427d52c3$var$HostTransitionContext = {
    $$typeof: $f394edd4427d52c3$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $f394edd4427d52c3$var$sharedNotPendingObject,
    _currentValue2: $f394edd4427d52c3$var$sharedNotPendingObject,
    _threadCount: 0
};
function $f394edd4427d52c3$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $f394edd4427d52c3$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f394edd4427d52c3$var$createLaneMap(0);
    this.hiddenUpdates = $f394edd4427d52c3$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $f394edd4427d52c3$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $f394edd4427d52c3$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $f394edd4427d52c3$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $f394edd4427d52c3$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $f394edd4427d52c3$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $f394edd4427d52c3$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $f394edd4427d52c3$var$emptyContextObject;
    parentComponent = $f394edd4427d52c3$var$emptyContextObject;
    return parentComponent;
}
function $f394edd4427d52c3$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $f394edd4427d52c3$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $f394edd4427d52c3$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $f394edd4427d52c3$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(element, rootFiber, lane), $f394edd4427d52c3$var$entangleTransitions(element, rootFiber, lane));
}
function $f394edd4427d52c3$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $f394edd4427d52c3$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $f394edd4427d52c3$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $f394edd4427d52c3$var$markRetryLaneImpl(fiber, retryLane);
}
function $f394edd4427d52c3$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $f394edd4427d52c3$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $f394edd4427d52c3$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $f394edd4427d52c3$var$requestUpdateLane();
        lane = $f394edd4427d52c3$var$getBumpedLaneForHydrationByLane(lane);
        var root = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, lane);
        $f394edd4427d52c3$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $f394edd4427d52c3$var$_enabled = !0;
function $f394edd4427d52c3$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T;
    $f394edd4427d52c3$var$ReactSharedInternals.T = null;
    var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    try {
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2, $f394edd4427d52c3$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f394edd4427d52c3$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T;
    $f394edd4427d52c3$var$ReactSharedInternals.T = null;
    var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    try {
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 8, $f394edd4427d52c3$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f394edd4427d52c3$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($f394edd4427d52c3$var$_enabled) {
        var blockedOn = $f394edd4427d52c3$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $f394edd4427d52c3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f394edd4427d52c3$var$return_targetInst, targetContainer), $f394edd4427d52c3$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($f394edd4427d52c3$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($f394edd4427d52c3$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $f394edd4427d52c3$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $f394edd4427d52c3$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $f394edd4427d52c3$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $f394edd4427d52c3$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $f394edd4427d52c3$var$ensureRootIsScheduled(fiber);
                                0 === ($f394edd4427d52c3$var$executionContext & 6) && ($f394edd4427d52c3$var$workInProgressRootRenderTargetTime = $f394edd4427d52c3$var$now() + 500, $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, 2), $f394edd4427d52c3$var$flushSyncWork$1(), $f394edd4427d52c3$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $f394edd4427d52c3$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $f394edd4427d52c3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f394edd4427d52c3$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $f394edd4427d52c3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $f394edd4427d52c3$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $f394edd4427d52c3$var$getEventTarget(nativeEvent);
    return $f394edd4427d52c3$var$findInstanceBlockingTarget(nativeEvent);
}
var $f394edd4427d52c3$var$return_targetInst = null;
function $f394edd4427d52c3$var$findInstanceBlockingTarget(targetNode) {
    $f394edd4427d52c3$var$return_targetInst = null;
    targetNode = $f394edd4427d52c3$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $f394edd4427d52c3$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $f394edd4427d52c3$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $f394edd4427d52c3$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $f394edd4427d52c3$var$return_targetInst = targetNode;
    return null;
}
function $f394edd4427d52c3$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($f394edd4427d52c3$var$getCurrentPriorityLevel()){
                case $f394edd4427d52c3$var$ImmediatePriority:
                    return 2;
                case $f394edd4427d52c3$var$UserBlockingPriority:
                    return 8;
                case $f394edd4427d52c3$var$NormalPriority$1:
                case $f394edd4427d52c3$var$LowPriority:
                    return 32;
                case $f394edd4427d52c3$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $f394edd4427d52c3$var$hasScheduledReplayAttempt = !1, $f394edd4427d52c3$var$queuedFocus = null, $f394edd4427d52c3$var$queuedDrag = null, $f394edd4427d52c3$var$queuedMouse = null, $f394edd4427d52c3$var$queuedPointers = new Map(), $f394edd4427d52c3$var$queuedPointerCaptures = new Map(), $f394edd4427d52c3$var$queuedExplicitHydrationTargets = [], $f394edd4427d52c3$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $f394edd4427d52c3$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $f394edd4427d52c3$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $f394edd4427d52c3$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $f394edd4427d52c3$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $f394edd4427d52c3$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f394edd4427d52c3$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $f394edd4427d52c3$var$getInstanceFromNode(blockedOn), null !== blockedOn && $f394edd4427d52c3$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $f394edd4427d52c3$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $f394edd4427d52c3$var$queuedFocus = $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $f394edd4427d52c3$var$queuedDrag = $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $f394edd4427d52c3$var$queuedMouse = $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $f394edd4427d52c3$var$queuedPointers.set(pointerId, $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $f394edd4427d52c3$var$queuedPointerCaptures.set(pointerId, $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $f394edd4427d52c3$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $f394edd4427d52c3$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $f394edd4427d52c3$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $f394edd4427d52c3$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f394edd4427d52c3$var$runWithPriority(queuedTarget.priority, function() {
                        $f394edd4427d52c3$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $f394edd4427d52c3$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f394edd4427d52c3$var$runWithPriority(queuedTarget.priority, function() {
                        $f394edd4427d52c3$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $f394edd4427d52c3$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $f394edd4427d52c3$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $f394edd4427d52c3$var$currentReplayingEvent = null;
        } else return targetContainers = $f394edd4427d52c3$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $f394edd4427d52c3$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $f394edd4427d52c3$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $f394edd4427d52c3$var$replayUnblockedEvents() {
    $f394edd4427d52c3$var$hasScheduledReplayAttempt = !1;
    null !== $f394edd4427d52c3$var$queuedFocus && $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent($f394edd4427d52c3$var$queuedFocus) && ($f394edd4427d52c3$var$queuedFocus = null);
    null !== $f394edd4427d52c3$var$queuedDrag && $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent($f394edd4427d52c3$var$queuedDrag) && ($f394edd4427d52c3$var$queuedDrag = null);
    null !== $f394edd4427d52c3$var$queuedMouse && $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent($f394edd4427d52c3$var$queuedMouse) && ($f394edd4427d52c3$var$queuedMouse = null);
    $f394edd4427d52c3$var$queuedPointers.forEach($f394edd4427d52c3$var$attemptReplayContinuousQueuedEventInMap);
    $f394edd4427d52c3$var$queuedPointerCaptures.forEach($f394edd4427d52c3$var$attemptReplayContinuousQueuedEventInMap);
}
function $f394edd4427d52c3$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $f394edd4427d52c3$var$hasScheduledReplayAttempt || ($f394edd4427d52c3$var$hasScheduledReplayAttempt = !0, $kkkYV.unstable_scheduleCallback($kkkYV.unstable_NormalPriority, $f394edd4427d52c3$var$replayUnblockedEvents)));
}
var $f394edd4427d52c3$var$lastScheduledReplayQueue = null;
function $f394edd4427d52c3$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $f394edd4427d52c3$var$lastScheduledReplayQueue !== formReplayingQueue && ($f394edd4427d52c3$var$lastScheduledReplayQueue = formReplayingQueue, $kkkYV.unstable_scheduleCallback($kkkYV.unstable_NormalPriority, function() {
        $f394edd4427d52c3$var$lastScheduledReplayQueue === formReplayingQueue && ($f394edd4427d52c3$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $f394edd4427d52c3$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $f394edd4427d52c3$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $f394edd4427d52c3$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $f394edd4427d52c3$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $f394edd4427d52c3$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $f394edd4427d52c3$var$queuedFocus && $f394edd4427d52c3$var$scheduleCallbackIfUnblocked($f394edd4427d52c3$var$queuedFocus, unblocked);
    null !== $f394edd4427d52c3$var$queuedDrag && $f394edd4427d52c3$var$scheduleCallbackIfUnblocked($f394edd4427d52c3$var$queuedDrag, unblocked);
    null !== $f394edd4427d52c3$var$queuedMouse && $f394edd4427d52c3$var$scheduleCallbackIfUnblocked($f394edd4427d52c3$var$queuedMouse, unblocked);
    $f394edd4427d52c3$var$queuedPointers.forEach(unblock);
    $f394edd4427d52c3$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $f394edd4427d52c3$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $f394edd4427d52c3$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $f394edd4427d52c3$var$queuedExplicitHydrationTargets.length && (i = $f394edd4427d52c3$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$f394edd4427d52c3$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $f394edd4427d52c3$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$f394edd4427d52c3$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $f394edd4427d52c3$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$f394edd4427d52c3$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $f394edd4427d52c3$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $f394edd4427d52c3$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $f394edd4427d52c3$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $f394edd4427d52c3$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f394edd4427d52c3$var$ReactDOMHydrationRoot.prototype.render = $f394edd4427d52c3$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(409));
    var current = root.current, lane = $f394edd4427d52c3$var$requestUpdateLane();
    $f394edd4427d52c3$var$updateContainerImpl(current, lane, children, root, null, null);
};
$f394edd4427d52c3$var$ReactDOMHydrationRoot.prototype.unmount = $f394edd4427d52c3$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $f394edd4427d52c3$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $f394edd4427d52c3$var$flushSyncWork$1();
        container[$f394edd4427d52c3$var$internalContainerInstanceKey] = null;
    }
};
function $f394edd4427d52c3$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f394edd4427d52c3$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $f394edd4427d52c3$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $f394edd4427d52c3$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $f394edd4427d52c3$var$queuedExplicitHydrationTargets[i].priority; i++);
        $f394edd4427d52c3$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $f394edd4427d52c3$var$attemptExplicitHydrationTarget(target);
    }
};
var $f394edd4427d52c3$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $7pfQ9.version;
if ("19.2.6" !== $f394edd4427d52c3$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(527, $f394edd4427d52c3$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.6"));
$f394edd4427d52c3$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $f394edd4427d52c3$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $f394edd4427d52c3$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $f394edd4427d52c3$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $f394edd4427d52c3$var$ReactSharedInternals,
    reconcilerVersion: "19.2.6"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f394edd4427d52c3$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f394edd4427d52c3$var$hook$jscomp$inline_2348.isDisabled && $f394edd4427d52c3$var$hook$jscomp$inline_2348.supportsFiber) try {
        $f394edd4427d52c3$var$rendererID = $f394edd4427d52c3$var$hook$jscomp$inline_2348.inject($f394edd4427d52c3$var$internals$jscomp$inline_2347), $f394edd4427d52c3$var$injectedHook = $f394edd4427d52c3$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$f394edd4427d52c3$export$882461b6382ed46c = function(container, options) {
    if (!$f394edd4427d52c3$var$isValidContainer(container)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f394edd4427d52c3$var$defaultOnUncaughtError, onCaughtError = $f394edd4427d52c3$var$defaultOnCaughtError, onRecoverableError = $f394edd4427d52c3$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $f394edd4427d52c3$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $f394edd4427d52c3$var$defaultOnDefaultTransitionIndicator);
    container[$f394edd4427d52c3$var$internalContainerInstanceKey] = options.current;
    $f394edd4427d52c3$var$listenToAllSupportedEvents(container);
    return new $f394edd4427d52c3$var$ReactDOMRoot(options);
};
$f394edd4427d52c3$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$f394edd4427d52c3$var$isValidContainer(container)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f394edd4427d52c3$var$defaultOnUncaughtError, onCaughtError = $f394edd4427d52c3$var$defaultOnCaughtError, onRecoverableError = $f394edd4427d52c3$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $f394edd4427d52c3$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $f394edd4427d52c3$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $f394edd4427d52c3$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $f394edd4427d52c3$var$requestUpdateLane();
    isStrictMode = $f394edd4427d52c3$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $f394edd4427d52c3$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $f394edd4427d52c3$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $f394edd4427d52c3$var$markRootUpdated$1(initialChildren, options);
    $f394edd4427d52c3$var$ensureRootIsScheduled(initialChildren);
    container[$f394edd4427d52c3$var$internalContainerInstanceKey] = initialChildren.current;
    $f394edd4427d52c3$var$listenToAllSupportedEvents(container);
    return new $f394edd4427d52c3$var$ReactDOMHydrationRoot(initialChildren);
};
$f394edd4427d52c3$export$83d89fbfd8236492 = "19.2.6";

});
parcelRegister("kkkYV", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3g8IH"));

});
parcelRegister("3g8IH", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $25f9a152cbcfee8e$export$c4744153514ff05d, (v) => $25f9a152cbcfee8e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $25f9a152cbcfee8e$export$3e506c1ccc9cc1a7, (v) => $25f9a152cbcfee8e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $25f9a152cbcfee8e$export$e26fe2ed2fa76875, (v) => $25f9a152cbcfee8e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $25f9a152cbcfee8e$export$502329bbf4b505b1, (v) => $25f9a152cbcfee8e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $25f9a152cbcfee8e$export$6e3807111c4874c4, (v) => $25f9a152cbcfee8e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $25f9a152cbcfee8e$export$c27134553091fb3a, (v) => $25f9a152cbcfee8e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $25f9a152cbcfee8e$export$33ee1acdc04fd2a2, (v) => $25f9a152cbcfee8e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $25f9a152cbcfee8e$export$b00a404bbd5edef2, (v) => $25f9a152cbcfee8e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $25f9a152cbcfee8e$export$d66a1c1c77bd778b, (v) => $25f9a152cbcfee8e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $25f9a152cbcfee8e$export$d3dfb8e4810cb555, (v) => $25f9a152cbcfee8e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $25f9a152cbcfee8e$export$72fdf0e06517287b, (v) => $25f9a152cbcfee8e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $25f9a152cbcfee8e$export$816d2913ae6b83b1, (v) => $25f9a152cbcfee8e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $25f9a152cbcfee8e$export$61bcfe829111a1d0, (v) => $25f9a152cbcfee8e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $25f9a152cbcfee8e$export$7ee8c9beb337bc3f, (v) => $25f9a152cbcfee8e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $25f9a152cbcfee8e$export$b5836b71941fa3ed, (v) => $25f9a152cbcfee8e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $25f9a152cbcfee8e$export$cf845f2c119da08a, (v) => $25f9a152cbcfee8e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $25f9a152cbcfee8e$export$c4744153514ff05d;
var $25f9a152cbcfee8e$export$3e506c1ccc9cc1a7;
var $25f9a152cbcfee8e$export$e26fe2ed2fa76875;
var $25f9a152cbcfee8e$export$502329bbf4b505b1;
var $25f9a152cbcfee8e$export$6e3807111c4874c4;
var $25f9a152cbcfee8e$export$c27134553091fb3a;
var $25f9a152cbcfee8e$export$33ee1acdc04fd2a2;
var $25f9a152cbcfee8e$export$b00a404bbd5edef2;
var $25f9a152cbcfee8e$export$d66a1c1c77bd778b;
var $25f9a152cbcfee8e$export$d3dfb8e4810cb555;
var $25f9a152cbcfee8e$export$72fdf0e06517287b;
var $25f9a152cbcfee8e$export$816d2913ae6b83b1;
var $25f9a152cbcfee8e$export$61bcfe829111a1d0;
var $25f9a152cbcfee8e$export$7ee8c9beb337bc3f;
var $25f9a152cbcfee8e$export$b5836b71941fa3ed;
var $25f9a152cbcfee8e$export$cf845f2c119da08a;
"use strict";
function $25f9a152cbcfee8e$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $25f9a152cbcfee8e$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $25f9a152cbcfee8e$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $25f9a152cbcfee8e$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $25f9a152cbcfee8e$var$compare(left, last)) rightIndex < length && 0 > $25f9a152cbcfee8e$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $25f9a152cbcfee8e$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $25f9a152cbcfee8e$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$25f9a152cbcfee8e$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $25f9a152cbcfee8e$var$localPerformance = performance;
    $25f9a152cbcfee8e$export$c4744153514ff05d = function() {
        return $25f9a152cbcfee8e$var$localPerformance.now();
    };
} else {
    var $25f9a152cbcfee8e$var$localDate = Date, $25f9a152cbcfee8e$var$initialTime = $25f9a152cbcfee8e$var$localDate.now();
    $25f9a152cbcfee8e$export$c4744153514ff05d = function() {
        return $25f9a152cbcfee8e$var$localDate.now() - $25f9a152cbcfee8e$var$initialTime;
    };
}
var $25f9a152cbcfee8e$var$taskQueue = [], $25f9a152cbcfee8e$var$timerQueue = [], $25f9a152cbcfee8e$var$taskIdCounter = 1, $25f9a152cbcfee8e$var$currentTask = null, $25f9a152cbcfee8e$var$currentPriorityLevel = 3, $25f9a152cbcfee8e$var$isPerformingWork = !1, $25f9a152cbcfee8e$var$isHostCallbackScheduled = !1, $25f9a152cbcfee8e$var$isHostTimeoutScheduled = !1, $25f9a152cbcfee8e$var$needsPaint = !1, $25f9a152cbcfee8e$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $25f9a152cbcfee8e$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $25f9a152cbcfee8e$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $25f9a152cbcfee8e$var$advanceTimers(currentTime) {
    for(var timer = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue); null !== timer;){
        if (null === timer.callback) $25f9a152cbcfee8e$var$pop($25f9a152cbcfee8e$var$timerQueue);
        else if (timer.startTime <= currentTime) $25f9a152cbcfee8e$var$pop($25f9a152cbcfee8e$var$timerQueue), timer.sortIndex = timer.expirationTime, $25f9a152cbcfee8e$var$push($25f9a152cbcfee8e$var$taskQueue, timer);
        else break;
        timer = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue);
    }
}
function $25f9a152cbcfee8e$var$handleTimeout(currentTime) {
    $25f9a152cbcfee8e$var$isHostTimeoutScheduled = !1;
    $25f9a152cbcfee8e$var$advanceTimers(currentTime);
    if (!$25f9a152cbcfee8e$var$isHostCallbackScheduled) {
        if (null !== $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue)) $25f9a152cbcfee8e$var$isHostCallbackScheduled = !0, $25f9a152cbcfee8e$var$isMessageLoopRunning || ($25f9a152cbcfee8e$var$isMessageLoopRunning = !0, $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue);
            null !== firstTimer && $25f9a152cbcfee8e$var$requestHostTimeout($25f9a152cbcfee8e$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $25f9a152cbcfee8e$var$isMessageLoopRunning = !1, $25f9a152cbcfee8e$var$taskTimeoutID = -1, $25f9a152cbcfee8e$var$frameInterval = 5, $25f9a152cbcfee8e$var$startTime = -1;
function $25f9a152cbcfee8e$var$shouldYieldToHost() {
    return $25f9a152cbcfee8e$var$needsPaint ? !0 : $25f9a152cbcfee8e$export$c4744153514ff05d() - $25f9a152cbcfee8e$var$startTime < $25f9a152cbcfee8e$var$frameInterval ? !1 : !0;
}
function $25f9a152cbcfee8e$var$performWorkUntilDeadline() {
    $25f9a152cbcfee8e$var$needsPaint = !1;
    if ($25f9a152cbcfee8e$var$isMessageLoopRunning) {
        var currentTime = $25f9a152cbcfee8e$export$c4744153514ff05d();
        $25f9a152cbcfee8e$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $25f9a152cbcfee8e$var$isHostCallbackScheduled = !1;
                $25f9a152cbcfee8e$var$isHostTimeoutScheduled && ($25f9a152cbcfee8e$var$isHostTimeoutScheduled = !1, $25f9a152cbcfee8e$var$localClearTimeout($25f9a152cbcfee8e$var$taskTimeoutID), $25f9a152cbcfee8e$var$taskTimeoutID = -1);
                $25f9a152cbcfee8e$var$isPerformingWork = !0;
                var previousPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
                try {
                    b: {
                        $25f9a152cbcfee8e$var$advanceTimers(currentTime);
                        for($25f9a152cbcfee8e$var$currentTask = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue); null !== $25f9a152cbcfee8e$var$currentTask && !($25f9a152cbcfee8e$var$currentTask.expirationTime > currentTime && $25f9a152cbcfee8e$var$shouldYieldToHost());){
                            var callback = $25f9a152cbcfee8e$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $25f9a152cbcfee8e$var$currentTask.callback = null;
                                $25f9a152cbcfee8e$var$currentPriorityLevel = $25f9a152cbcfee8e$var$currentTask.priorityLevel;
                                var continuationCallback = callback($25f9a152cbcfee8e$var$currentTask.expirationTime <= currentTime);
                                currentTime = $25f9a152cbcfee8e$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $25f9a152cbcfee8e$var$currentTask.callback = continuationCallback;
                                    $25f9a152cbcfee8e$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $25f9a152cbcfee8e$var$currentTask === $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue) && $25f9a152cbcfee8e$var$pop($25f9a152cbcfee8e$var$taskQueue);
                                $25f9a152cbcfee8e$var$advanceTimers(currentTime);
                            } else $25f9a152cbcfee8e$var$pop($25f9a152cbcfee8e$var$taskQueue);
                            $25f9a152cbcfee8e$var$currentTask = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue);
                        }
                        if (null !== $25f9a152cbcfee8e$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue);
                            null !== firstTimer && $25f9a152cbcfee8e$var$requestHostTimeout($25f9a152cbcfee8e$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $25f9a152cbcfee8e$var$currentTask = null, $25f9a152cbcfee8e$var$currentPriorityLevel = previousPriorityLevel, $25f9a152cbcfee8e$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline() : $25f9a152cbcfee8e$var$isMessageLoopRunning = !1;
        }
    }
}
var $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $25f9a152cbcfee8e$var$localSetImmediate) $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline = function() {
    $25f9a152cbcfee8e$var$localSetImmediate($25f9a152cbcfee8e$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $25f9a152cbcfee8e$var$channel = new MessageChannel(), $25f9a152cbcfee8e$var$port = $25f9a152cbcfee8e$var$channel.port2;
    $25f9a152cbcfee8e$var$channel.port1.onmessage = $25f9a152cbcfee8e$var$performWorkUntilDeadline;
    $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline = function() {
        $25f9a152cbcfee8e$var$port.postMessage(null);
    };
} else $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline = function() {
    $25f9a152cbcfee8e$var$localSetTimeout($25f9a152cbcfee8e$var$performWorkUntilDeadline, 0);
};
function $25f9a152cbcfee8e$var$requestHostTimeout(callback, ms) {
    $25f9a152cbcfee8e$var$taskTimeoutID = $25f9a152cbcfee8e$var$localSetTimeout(function() {
        callback($25f9a152cbcfee8e$export$c4744153514ff05d());
    }, ms);
}
$25f9a152cbcfee8e$export$3e506c1ccc9cc1a7 = 5;
$25f9a152cbcfee8e$export$e26fe2ed2fa76875 = 1;
$25f9a152cbcfee8e$export$502329bbf4b505b1 = 4;
$25f9a152cbcfee8e$export$6e3807111c4874c4 = 3;
$25f9a152cbcfee8e$export$c27134553091fb3a = null;
$25f9a152cbcfee8e$export$33ee1acdc04fd2a2 = 2;
$25f9a152cbcfee8e$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$25f9a152cbcfee8e$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $25f9a152cbcfee8e$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$25f9a152cbcfee8e$export$d3dfb8e4810cb555 = function() {
    return $25f9a152cbcfee8e$var$currentPriorityLevel;
};
$25f9a152cbcfee8e$export$72fdf0e06517287b = function(eventHandler) {
    switch($25f9a152cbcfee8e$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
    $25f9a152cbcfee8e$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $25f9a152cbcfee8e$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$25f9a152cbcfee8e$export$816d2913ae6b83b1 = function() {
    $25f9a152cbcfee8e$var$needsPaint = !0;
};
$25f9a152cbcfee8e$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
    $25f9a152cbcfee8e$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $25f9a152cbcfee8e$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$25f9a152cbcfee8e$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $25f9a152cbcfee8e$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $25f9a152cbcfee8e$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $25f9a152cbcfee8e$var$push($25f9a152cbcfee8e$var$timerQueue, priorityLevel), null === $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue) && priorityLevel === $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue) && ($25f9a152cbcfee8e$var$isHostTimeoutScheduled ? ($25f9a152cbcfee8e$var$localClearTimeout($25f9a152cbcfee8e$var$taskTimeoutID), $25f9a152cbcfee8e$var$taskTimeoutID = -1) : $25f9a152cbcfee8e$var$isHostTimeoutScheduled = !0, $25f9a152cbcfee8e$var$requestHostTimeout($25f9a152cbcfee8e$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $25f9a152cbcfee8e$var$push($25f9a152cbcfee8e$var$taskQueue, priorityLevel), $25f9a152cbcfee8e$var$isHostCallbackScheduled || $25f9a152cbcfee8e$var$isPerformingWork || ($25f9a152cbcfee8e$var$isHostCallbackScheduled = !0, $25f9a152cbcfee8e$var$isMessageLoopRunning || ($25f9a152cbcfee8e$var$isMessageLoopRunning = !0, $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$25f9a152cbcfee8e$export$b5836b71941fa3ed = $25f9a152cbcfee8e$var$shouldYieldToHost;
$25f9a152cbcfee8e$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
        $25f9a152cbcfee8e$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $25f9a152cbcfee8e$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("7pfQ9", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3WPYT"));

});

parcelRegister("3G714", function(module, exports) {
'use strict';
function $2adabca53da00ad0$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2adabca53da00ad0$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2adabca53da00ad0$var$checkDCE();

module.exports = (parcelRequire("5a5ch"));

});
parcelRegister("5a5ch", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $3c21eaf68ad38b13$export$69ce8ef3fe5cead0, (v) => $3c21eaf68ad38b13$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $3c21eaf68ad38b13$export$d39a5bbd09211389, (v) => $3c21eaf68ad38b13$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $3c21eaf68ad38b13$export$cd75ccfd720a3cd4, (v) => $3c21eaf68ad38b13$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $3c21eaf68ad38b13$export$a0816fa17a9e79be, (v) => $3c21eaf68ad38b13$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $3c21eaf68ad38b13$export$7292efcadded39f3, (v) => $3c21eaf68ad38b13$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $3c21eaf68ad38b13$export$da407abadb9b8f86, (v) => $3c21eaf68ad38b13$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $3c21eaf68ad38b13$export$314cfea32580671c, (v) => $3c21eaf68ad38b13$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $3c21eaf68ad38b13$export$513ccb98c53b8039, (v) => $3c21eaf68ad38b13$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $3c21eaf68ad38b13$export$dbca993bc2d264a, (v) => $3c21eaf68ad38b13$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $3c21eaf68ad38b13$export$4797a8006f0655d0, (v) => $3c21eaf68ad38b13$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $3c21eaf68ad38b13$export$c78a37762a8d58e1, (v) => $3c21eaf68ad38b13$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $3c21eaf68ad38b13$export$606f11b2eb45ecc6, (v) => $3c21eaf68ad38b13$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $3c21eaf68ad38b13$export$f7e8a0bf92324b1e, (v) => $3c21eaf68ad38b13$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $3c21eaf68ad38b13$export$83d89fbfd8236492, (v) => $3c21eaf68ad38b13$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c21eaf68ad38b13$export$69ce8ef3fe5cead0;
var $3c21eaf68ad38b13$export$d39a5bbd09211389;
var $3c21eaf68ad38b13$export$cd75ccfd720a3cd4;
var $3c21eaf68ad38b13$export$a0816fa17a9e79be;
var $3c21eaf68ad38b13$export$7292efcadded39f3;
var $3c21eaf68ad38b13$export$da407abadb9b8f86;
var $3c21eaf68ad38b13$export$314cfea32580671c;
var $3c21eaf68ad38b13$export$513ccb98c53b8039;
var $3c21eaf68ad38b13$export$dbca993bc2d264a;
var $3c21eaf68ad38b13$export$4797a8006f0655d0;
var $3c21eaf68ad38b13$export$c78a37762a8d58e1;
var $3c21eaf68ad38b13$export$606f11b2eb45ecc6;
var $3c21eaf68ad38b13$export$f7e8a0bf92324b1e;
var $3c21eaf68ad38b13$export$83d89fbfd8236492;
"use strict";

var $7pfQ9 = parcelRequire("7pfQ9");
function $3c21eaf68ad38b13$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $3c21eaf68ad38b13$var$noop() {}
var $3c21eaf68ad38b13$var$Internals = {
    d: {
        f: $3c21eaf68ad38b13$var$noop,
        r: function() {
            throw Error($3c21eaf68ad38b13$var$formatProdErrorMessage(522));
        },
        D: $3c21eaf68ad38b13$var$noop,
        C: $3c21eaf68ad38b13$var$noop,
        L: $3c21eaf68ad38b13$var$noop,
        m: $3c21eaf68ad38b13$var$noop,
        X: $3c21eaf68ad38b13$var$noop,
        S: $3c21eaf68ad38b13$var$noop,
        M: $3c21eaf68ad38b13$var$noop
    },
    p: 0,
    findDOMNode: null
}, $3c21eaf68ad38b13$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $3c21eaf68ad38b13$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3c21eaf68ad38b13$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $3c21eaf68ad38b13$var$ReactSharedInternals = $7pfQ9.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $3c21eaf68ad38b13$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$3c21eaf68ad38b13$export$69ce8ef3fe5cead0 = $3c21eaf68ad38b13$var$Internals;
$3c21eaf68ad38b13$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($3c21eaf68ad38b13$var$formatProdErrorMessage(299));
    return $3c21eaf68ad38b13$var$createPortal$1(children, container, null, key);
};
$3c21eaf68ad38b13$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $3c21eaf68ad38b13$var$ReactSharedInternals.T, previousUpdatePriority = $3c21eaf68ad38b13$var$Internals.p;
    try {
        if ($3c21eaf68ad38b13$var$ReactSharedInternals.T = null, $3c21eaf68ad38b13$var$Internals.p = 2, fn) return fn();
    } finally{
        $3c21eaf68ad38b13$var$ReactSharedInternals.T = previousTransition, $3c21eaf68ad38b13$var$Internals.p = previousUpdatePriority, $3c21eaf68ad38b13$var$Internals.d.f();
    }
};
$3c21eaf68ad38b13$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $3c21eaf68ad38b13$var$Internals.d.C(href, options));
};
$3c21eaf68ad38b13$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $3c21eaf68ad38b13$var$Internals.d.D(href);
};
$3c21eaf68ad38b13$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $3c21eaf68ad38b13$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $3c21eaf68ad38b13$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $3c21eaf68ad38b13$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$3c21eaf68ad38b13$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $3c21eaf68ad38b13$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $3c21eaf68ad38b13$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $3c21eaf68ad38b13$var$Internals.d.M(href);
    }
};
$3c21eaf68ad38b13$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $3c21eaf68ad38b13$var$getCrossOriginStringAs(as, options.crossOrigin);
        $3c21eaf68ad38b13$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$3c21eaf68ad38b13$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $3c21eaf68ad38b13$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $3c21eaf68ad38b13$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $3c21eaf68ad38b13$var$Internals.d.m(href);
    }
};
$3c21eaf68ad38b13$export$4797a8006f0655d0 = function(form) {
    $3c21eaf68ad38b13$var$Internals.d.r(form);
};
$3c21eaf68ad38b13$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$3c21eaf68ad38b13$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $3c21eaf68ad38b13$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$3c21eaf68ad38b13$export$f7e8a0bf92324b1e = function() {
    return $3c21eaf68ad38b13$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$3c21eaf68ad38b13$export$83d89fbfd8236492 = "19.2.6";

});



var $39a601ce4590a47e$exports = {};
'use strict';

$39a601ce4590a47e$exports = (parcelRequire("kQfpd"));



var $7pfQ9 = parcelRequire("7pfQ9");
var $9b36b21436e51e50$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $9b36b21436e51e50$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $9b36b21436e51e50$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $9b36b21436e51e50$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$9b36b21436e51e50$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($9b36b21436e51e50$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $9b36b21436e51e50$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $f606114e0294917e$export$71ad59f2e432cfe8 = "-ms-";
var $f606114e0294917e$export$2c0f367103c8d01c = "-moz-";
var $f606114e0294917e$export$39dfd62a25e0fe93 = "-webkit-";
var $f606114e0294917e$export$a29989082612d0d9 = "comm";
var $f606114e0294917e$export$aa3a2e812ca8570d = "rule";
var $f606114e0294917e$export$527d108ccf083c2b = "decl";
var $f606114e0294917e$export$d3d35020fa5b54f0 = "@page";
var $f606114e0294917e$export$500415a86c544f73 = "@media";
var $f606114e0294917e$export$a763edbf796b780a = "@import";
var $f606114e0294917e$export$2790aeb8b4e5c826 = "@charset";
var $f606114e0294917e$export$1cc683e23b84b133 = "@viewport";
var $f606114e0294917e$export$9447a5efea57e862 = "@supports";
var $f606114e0294917e$export$ef011b4e114b1fba = "@document";
var $f606114e0294917e$export$6aad947bda0f3f46 = "@namespace";
var $f606114e0294917e$export$b44a8529a35fcb60 = "@keyframes";
var $f606114e0294917e$export$2c16de31893252e6 = "@font-face";
var $f606114e0294917e$export$3d846dd52e150c6f = "@counter-style";
var $f606114e0294917e$export$22314bfbb57653fe = "@font-feature-values";
var $f606114e0294917e$export$d773506282b3cfe6 = "@layer";
var $f606114e0294917e$export$2335f513bbd82c6d = Math.abs;
var $f606114e0294917e$export$6788812c4e6611e6 = String.fromCharCode;
var $f606114e0294917e$export$e6e34fd1f2686227 = Object.assign;
function $f606114e0294917e$export$d6af199866bfb566(e, r) {
    return $f606114e0294917e$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $f606114e0294917e$export$a9db5e087081082d(e, 0)) << 2 ^ $f606114e0294917e$export$a9db5e087081082d(e, 1)) << 2 ^ $f606114e0294917e$export$a9db5e087081082d(e, 2)) << 2 ^ $f606114e0294917e$export$a9db5e087081082d(e, 3) : 0;
}
function $f606114e0294917e$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $f606114e0294917e$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $f606114e0294917e$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $f606114e0294917e$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $f606114e0294917e$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $f606114e0294917e$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $f606114e0294917e$export$36776f635604f274(e) {
    return e.length;
}
function $f606114e0294917e$export$f9084667e487ed46(e) {
    return e.length;
}
function $f606114e0294917e$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $f606114e0294917e$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $f606114e0294917e$export$53f1d5ea8de3d7c = 1;
var $f606114e0294917e$export$4e0c71f277ca26b3 = 1;
var $f606114e0294917e$export$f24224f1c91d8156 = 0;
var $f606114e0294917e$export$5880b8b5730aff45 = 0;
var $f606114e0294917e$export$c0306caf338ac095 = 0;
var $f606114e0294917e$export$30a86d91af8ff6e6 = "";
function $f606114e0294917e$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $f606114e0294917e$export$53f1d5ea8de3d7c,
        column: $f606114e0294917e$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $f606114e0294917e$export$784d13d8ee351f07(e, r) {
    return $f606114e0294917e$export$e6e34fd1f2686227($f606114e0294917e$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $f606114e0294917e$export$eba6f6f03b0a92e7() {
    return $f606114e0294917e$export$c0306caf338ac095;
}
function $f606114e0294917e$export$232faf9add678146() {
    $f606114e0294917e$export$c0306caf338ac095 = $f606114e0294917e$export$5880b8b5730aff45 > 0 ? $f606114e0294917e$export$a9db5e087081082d($f606114e0294917e$export$30a86d91af8ff6e6, --$f606114e0294917e$export$5880b8b5730aff45) : 0;
    if ($f606114e0294917e$export$4e0c71f277ca26b3--, $f606114e0294917e$export$c0306caf338ac095 === 10) $f606114e0294917e$export$4e0c71f277ca26b3 = 1, $f606114e0294917e$export$53f1d5ea8de3d7c--;
    return $f606114e0294917e$export$c0306caf338ac095;
}
function $f606114e0294917e$export$48cfd1e771a65c4f() {
    $f606114e0294917e$export$c0306caf338ac095 = $f606114e0294917e$export$5880b8b5730aff45 < $f606114e0294917e$export$f24224f1c91d8156 ? $f606114e0294917e$export$a9db5e087081082d($f606114e0294917e$export$30a86d91af8ff6e6, $f606114e0294917e$export$5880b8b5730aff45++) : 0;
    if ($f606114e0294917e$export$4e0c71f277ca26b3++, $f606114e0294917e$export$c0306caf338ac095 === 10) $f606114e0294917e$export$4e0c71f277ca26b3 = 1, $f606114e0294917e$export$53f1d5ea8de3d7c++;
    return $f606114e0294917e$export$c0306caf338ac095;
}
function $f606114e0294917e$export$4d3fb11e950abb9e() {
    return $f606114e0294917e$export$a9db5e087081082d($f606114e0294917e$export$30a86d91af8ff6e6, $f606114e0294917e$export$5880b8b5730aff45);
}
function $f606114e0294917e$export$e88cb2efb12ae807() {
    return $f606114e0294917e$export$5880b8b5730aff45;
}
function $f606114e0294917e$export$58adb3bec8346d0f(e, r) {
    return $f606114e0294917e$export$2f35ab04d2335697($f606114e0294917e$export$30a86d91af8ff6e6, e, r);
}
function $f606114e0294917e$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f606114e0294917e$export$2de70f21292aac9e(e) {
    return $f606114e0294917e$export$53f1d5ea8de3d7c = $f606114e0294917e$export$4e0c71f277ca26b3 = 1, $f606114e0294917e$export$f24224f1c91d8156 = $f606114e0294917e$export$36776f635604f274($f606114e0294917e$export$30a86d91af8ff6e6 = e), $f606114e0294917e$export$5880b8b5730aff45 = 0, [];
}
function $f606114e0294917e$export$45918ac1574455b1(e) {
    return $f606114e0294917e$export$30a86d91af8ff6e6 = "", e;
}
function $f606114e0294917e$export$410ac95b9ec204b8(e) {
    return $f606114e0294917e$export$87c2784dc9fc4ab($f606114e0294917e$export$58adb3bec8346d0f($f606114e0294917e$export$5880b8b5730aff45 - 1, $f606114e0294917e$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $f606114e0294917e$export$660b2ee2d4fb4eff(e) {
    return $f606114e0294917e$export$45918ac1574455b1($f606114e0294917e$export$5f8c09e3ae6f64e1($f606114e0294917e$export$2de70f21292aac9e(e)));
}
function $f606114e0294917e$export$7af1228ff777d175(e) {
    while($f606114e0294917e$export$c0306caf338ac095 = $f606114e0294917e$export$4d3fb11e950abb9e())if ($f606114e0294917e$export$c0306caf338ac095 < 33) $f606114e0294917e$export$48cfd1e771a65c4f();
    else break;
    return $f606114e0294917e$export$9e1725a4cfeada27(e) > 2 || $f606114e0294917e$export$9e1725a4cfeada27($f606114e0294917e$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f606114e0294917e$export$5f8c09e3ae6f64e1(e) {
    while($f606114e0294917e$export$48cfd1e771a65c4f())switch($f606114e0294917e$export$9e1725a4cfeada27($f606114e0294917e$export$c0306caf338ac095)){
        case 0:
            $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$c2ab62c7bf24634($f606114e0294917e$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$410ac95b9ec204b8($f606114e0294917e$export$c0306caf338ac095), e);
            break;
        default:
            $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$6788812c4e6611e6($f606114e0294917e$export$c0306caf338ac095), e);
    }
    return e;
}
function $f606114e0294917e$export$955ba06d119e085e(e, r) {
    while(--r && $f606114e0294917e$export$48cfd1e771a65c4f())if ($f606114e0294917e$export$c0306caf338ac095 < 48 || $f606114e0294917e$export$c0306caf338ac095 > 102 || $f606114e0294917e$export$c0306caf338ac095 > 57 && $f606114e0294917e$export$c0306caf338ac095 < 65 || $f606114e0294917e$export$c0306caf338ac095 > 70 && $f606114e0294917e$export$c0306caf338ac095 < 97) break;
    return $f606114e0294917e$export$58adb3bec8346d0f(e, $f606114e0294917e$export$e88cb2efb12ae807() + (r < 6 && $f606114e0294917e$export$4d3fb11e950abb9e() == 32 && $f606114e0294917e$export$48cfd1e771a65c4f() == 32));
}
function $f606114e0294917e$export$c889f2fcc19dbf12(e) {
    while($f606114e0294917e$export$48cfd1e771a65c4f())switch($f606114e0294917e$export$c0306caf338ac095){
        case e:
            return $f606114e0294917e$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $f606114e0294917e$export$c889f2fcc19dbf12($f606114e0294917e$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $f606114e0294917e$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $f606114e0294917e$export$48cfd1e771a65c4f();
            break;
    }
    return $f606114e0294917e$export$5880b8b5730aff45;
}
function $f606114e0294917e$export$4254d4e2b3745c4c(e, r) {
    while($f606114e0294917e$export$48cfd1e771a65c4f())if (e + $f606114e0294917e$export$c0306caf338ac095 === 57) break;
    else if (e + $f606114e0294917e$export$c0306caf338ac095 === 84 && $f606114e0294917e$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f606114e0294917e$export$58adb3bec8346d0f(r, $f606114e0294917e$export$5880b8b5730aff45 - 1) + "*" + $f606114e0294917e$export$6788812c4e6611e6(e === 47 ? e : $f606114e0294917e$export$48cfd1e771a65c4f());
}
function $f606114e0294917e$export$c2ab62c7bf24634(e) {
    while(!$f606114e0294917e$export$9e1725a4cfeada27($f606114e0294917e$export$4d3fb11e950abb9e()))$f606114e0294917e$export$48cfd1e771a65c4f();
    return $f606114e0294917e$export$58adb3bec8346d0f(e, $f606114e0294917e$export$5880b8b5730aff45);
}
function $f606114e0294917e$export$ef7acd7185315e22(e) {
    return $f606114e0294917e$export$45918ac1574455b1($f606114e0294917e$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $f606114e0294917e$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $f606114e0294917e$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $f606114e0294917e$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $f606114e0294917e$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($f606114e0294917e$export$f8e21b1e77979a08(j += $f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $f606114e0294917e$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $f606114e0294917e$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $f606114e0294917e$export$955ba06d119e085e($f606114e0294917e$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($f606114e0294917e$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$4a34f930e789283c($f606114e0294917e$export$4254d4e2b3745c4c($f606114e0294917e$export$48cfd1e771a65c4f(), $f606114e0294917e$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $f606114e0294917e$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $f606114e0294917e$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $f606114e0294917e$export$36776f635604f274(j) - l) $f606114e0294917e$export$10d8903dec122b9d(p > 32 ? $f606114e0294917e$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $f606114e0294917e$export$f8483753829ec8f3($f606114e0294917e$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $f606114e0294917e$export$10d8903dec122b9d(y = $f606114e0294917e$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $f606114e0294917e$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $f606114e0294917e$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $f606114e0294917e$export$98e6a39c04603d36(e, y, y, n && $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $f606114e0294917e$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $f606114e0294917e$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $f606114e0294917e$export$232faf9add678146() == 125) continue;
            }
            switch(j += $f606114e0294917e$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($f606114e0294917e$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($f606114e0294917e$export$4d3fb11e950abb9e() === 45) j += $f606114e0294917e$export$410ac95b9ec204b8($f606114e0294917e$export$48cfd1e771a65c4f());
                    v = $f606114e0294917e$export$4d3fb11e950abb9e(), o = l = $f606114e0294917e$export$36776f635604f274(g = j += $f606114e0294917e$export$c2ab62c7bf24634($f606114e0294917e$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $f606114e0294917e$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $f606114e0294917e$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $f606114e0294917e$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $f606114e0294917e$export$2f35ab04d2335697(e, v + 1, v = $f606114e0294917e$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $f606114e0294917e$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $f606114e0294917e$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $f606114e0294917e$export$35059013cd4a06db(e, r, a, s === 0 ? $f606114e0294917e$export$aa3a2e812ca8570d : i, f, o, l);
}
function $f606114e0294917e$export$4a34f930e789283c(e, r, a) {
    return $f606114e0294917e$export$35059013cd4a06db(e, r, a, $f606114e0294917e$export$a29989082612d0d9, $f606114e0294917e$export$6788812c4e6611e6($f606114e0294917e$export$eba6f6f03b0a92e7()), $f606114e0294917e$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $f606114e0294917e$export$f8483753829ec8f3(e, r, a, n) {
    return $f606114e0294917e$export$35059013cd4a06db(e, r, a, $f606114e0294917e$export$527d108ccf083c2b, $f606114e0294917e$export$2f35ab04d2335697(e, 0, n), $f606114e0294917e$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $f606114e0294917e$export$82e9f45cca5ba907(n, c, s) {
    switch($f606114e0294917e$export$d6af199866bfb566(n, c)){
        case 5103:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $f606114e0294917e$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$2c0f367103c8d01c + n + $f606114e0294917e$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($f606114e0294917e$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "box-$1$2" + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-item-" + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$f606114e0294917e$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $f606114e0294917e$export$71ad59f2e432cfe8 + "grid-row-" + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-line-pack" + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + "box-" + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "-grow", "") + $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $f606114e0294917e$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "box-pack:$3" + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $f606114e0294917e$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$f606114e0294917e$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $f606114e0294917e$export$71ad59f2e432cfe8 + "grid-column-align" + $f606114e0294917e$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $f606114e0294917e$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$f606114e0294917e$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $f606114e0294917e$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$f606114e0294917e$export$f8e21b1e77979a08(s, "span") ? $f606114e0294917e$export$4659b591c19bdf3d(s, /\d+/) : +$f606114e0294917e$export$4659b591c19bdf3d(s, /\d+/) - +$f606114e0294917e$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $f606114e0294917e$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($f606114e0294917e$export$36776f635604f274(n) - 1 - c > 6) switch($f606114e0294917e$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($f606114e0294917e$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $f606114e0294917e$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $f606114e0294917e$export$2c0f367103c8d01c + ($f606114e0294917e$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$f606114e0294917e$export$f8e21b1e77979a08(n, "stretch") ? $f606114e0294917e$export$82e9f45cca5ba907($f606114e0294917e$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $f606114e0294917e$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $f606114e0294917e$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($f606114e0294917e$export$a9db5e087081082d(n, c + 6) === 121) return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, ":", ":" + $f606114e0294917e$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($f606114e0294917e$export$a9db5e087081082d(n, $f606114e0294917e$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $f606114e0294917e$export$39dfd62a25e0fe93 + ($f606114e0294917e$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $f606114e0294917e$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $f606114e0294917e$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, ":", ":" + $f606114e0294917e$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $f606114e0294917e$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $f606114e0294917e$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $f606114e0294917e$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $f606114e0294917e$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $f606114e0294917e$export$a763edbf796b780a:
        case $f606114e0294917e$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $f606114e0294917e$export$a29989082612d0d9:
            return "";
        case $f606114e0294917e$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $f606114e0294917e$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $f606114e0294917e$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $f606114e0294917e$export$36776f635604f274(a = $f606114e0294917e$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $f606114e0294917e$export$5a7767152ae0305f(e) {
    var r = $f606114e0294917e$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $f606114e0294917e$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $f606114e0294917e$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $f606114e0294917e$export$527d108ccf083c2b:
                n.return = $f606114e0294917e$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $f606114e0294917e$export$b44a8529a35fcb60:
                return $f606114e0294917e$export$dfdc1655ccc5b9cb([
                    $f606114e0294917e$export$784d13d8ee351f07(n, {
                        value: $f606114e0294917e$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $f606114e0294917e$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $f606114e0294917e$export$aa3a2e812ca8570d:
                if (n.length) return $f606114e0294917e$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($f606114e0294917e$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $f606114e0294917e$export$dfdc1655ccc5b9cb([
                                $f606114e0294917e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f606114e0294917e$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $f606114e0294917e$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $f606114e0294917e$export$dfdc1655ccc5b9cb([
                                $f606114e0294917e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f606114e0294917e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f606114e0294917e$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $f606114e0294917e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f606114e0294917e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f606114e0294917e$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $f606114e0294917e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f606114e0294917e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $f606114e0294917e$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $f606114e0294917e$export$76a88f7de6507443(e) {
    switch(e.type){
        case $f606114e0294917e$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $f606114e0294917e$export$1be1fc439b849fdf($f606114e0294917e$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($f606114e0294917e$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $f606114e0294917e$export$2f35ab04d2335697(r, 1, $f606114e0294917e$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $f606114e0294917e$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $f606114e0294917e$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $f606114e0294917e$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $383a16c0af63619a$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $9af28dbc4ff027aa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $56efb59e443286cf$var$isBrowser = typeof document !== 'undefined';
var $56efb59e443286cf$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $f606114e0294917e$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $f606114e0294917e$export$9e1725a4cfeada27)(character)) break;
        (0, $f606114e0294917e$export$48cfd1e771a65c4f)();
    }
    return (0, $f606114e0294917e$export$58adb3bec8346d0f)(begin, (0, $f606114e0294917e$export$5880b8b5730aff45));
};
var $56efb59e443286cf$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $f606114e0294917e$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $f606114e0294917e$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $56efb59e443286cf$var$identifierWithPointTracking((0, $f606114e0294917e$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $f606114e0294917e$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $f606114e0294917e$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $f606114e0294917e$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $f606114e0294917e$export$48cfd1e771a65c4f)());
    return parsed;
};
var $56efb59e443286cf$var$getRules = function getRules(value, points) {
    return (0, $f606114e0294917e$export$45918ac1574455b1)($56efb59e443286cf$var$toRules((0, $f606114e0294917e$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $56efb59e443286cf$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $56efb59e443286cf$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$56efb59e443286cf$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $56efb59e443286cf$var$fixedElements.set(element, true);
    var points = [];
    var rules = $56efb59e443286cf$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $56efb59e443286cf$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $56efb59e443286cf$var$prefix(value, length) {
    switch((0, $f606114e0294917e$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$2c0f367103c8d01c) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'box-' + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)((0, $f606114e0294917e$export$77ad94ebf1c2b9ed)((0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)((0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $f606114e0294917e$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $f606114e0294917e$export$2c0f367103c8d01c) + ((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $f606114e0294917e$export$f8e21b1e77979a08)(value, 'stretch') ? $56efb59e443286cf$var$prefix((0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $f606114e0294917e$export$a9db5e087081082d)(value, (0, $f606114e0294917e$export$36776f635604f274)(value) - 3 - (~(0, $f606114e0294917e$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $f606114e0294917e$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + ((0, $f606114e0294917e$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $56efb59e443286cf$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $f606114e0294917e$export$527d108ccf083c2b:
                element["return"] = $56efb59e443286cf$var$prefix(element.value, element.length);
                break;
            case 0, $f606114e0294917e$export$b44a8529a35fcb60:
                return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)([
                    (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                        value: (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $f606114e0294917e$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $f606114e0294917e$export$aa3a2e812ca8570d:
                if (element.length) return (0, $f606114e0294917e$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $f606114e0294917e$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)([
                                (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $f606114e0294917e$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)([
                                (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f606114e0294917e$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $56efb59e443286cf$var$getServerStylisCache = $56efb59e443286cf$var$isBrowser ? undefined : (0, $383a16c0af63619a$export$2e2bcd8739ae039)(function() {
    return (0, $9af28dbc4ff027aa$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $56efb59e443286cf$var$defaultStylisPlugins = [
    $56efb59e443286cf$var$prefixer
];
var $56efb59e443286cf$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($56efb59e443286cf$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $56efb59e443286cf$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($56efb59e443286cf$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $56efb59e443286cf$var$compat,
        $56efb59e443286cf$var$removeLabel
    ];
    if (!$56efb59e443286cf$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $f606114e0294917e$export$fac44ee5b035f737),
            (0, $f606114e0294917e$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $f606114e0294917e$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)((0, $f606114e0294917e$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $f606114e0294917e$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $f606114e0294917e$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)((0, $f606114e0294917e$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $56efb59e443286cf$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $9b36b21436e51e50$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $433b84e4025fc999$export$2e2bcd8739ae039() {
    return $433b84e4025fc999$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $433b84e4025fc999$export$2e2bcd8739ae039.apply(null, arguments);
}



var $04d7b12b010888af$exports = {};
'use strict';
var $d15216aaf08bc3c3$exports = {};
'use strict';

$d15216aaf08bc3c3$exports = (parcelRequire("hoNSH"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $04d7b12b010888af$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $04d7b12b010888af$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $04d7b12b010888af$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $04d7b12b010888af$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $04d7b12b010888af$var$TYPE_STATICS = {};
$04d7b12b010888af$var$TYPE_STATICS[$d15216aaf08bc3c3$exports.ForwardRef] = $04d7b12b010888af$var$FORWARD_REF_STATICS;
$04d7b12b010888af$var$TYPE_STATICS[$d15216aaf08bc3c3$exports.Memo] = $04d7b12b010888af$var$MEMO_STATICS;
function $04d7b12b010888af$var$getStatics(component) {
    // React v16.11 and below
    if ($d15216aaf08bc3c3$exports.isMemo(component)) return $04d7b12b010888af$var$MEMO_STATICS;
     // React v16.12 and above
    return $04d7b12b010888af$var$TYPE_STATICS[component['$$typeof']] || $04d7b12b010888af$var$REACT_STATICS;
}
var $04d7b12b010888af$var$defineProperty = Object.defineProperty;
var $04d7b12b010888af$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $04d7b12b010888af$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $04d7b12b010888af$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $04d7b12b010888af$var$getPrototypeOf = Object.getPrototypeOf;
var $04d7b12b010888af$var$objectPrototype = Object.prototype;
function $04d7b12b010888af$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($04d7b12b010888af$var$objectPrototype) {
            var inheritedComponent = $04d7b12b010888af$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $04d7b12b010888af$var$objectPrototype) $04d7b12b010888af$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $04d7b12b010888af$var$getOwnPropertyNames(sourceComponent);
        if ($04d7b12b010888af$var$getOwnPropertySymbols) keys = keys.concat($04d7b12b010888af$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $04d7b12b010888af$var$getStatics(targetComponent);
        var sourceStatics = $04d7b12b010888af$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$04d7b12b010888af$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $04d7b12b010888af$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $04d7b12b010888af$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$04d7b12b010888af$exports = $04d7b12b010888af$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $9bdfad1d9a53b75c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($04d7b12b010888af$exports)))(targetComponent, sourceComponent);
};


var $335a9ebca9ef05c6$var$isBrowser = typeof document !== 'undefined';
function $335a9ebca9ef05c6$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $335a9ebca9ef05c6$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $335a9ebca9ef05c6$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $335a9ebca9ef05c6$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $335a9ebca9ef05c6$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$335a9ebca9ef05c6$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$335a9ebca9ef05c6$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $cb67a2560fdadc97$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $df02772e6ff9e6f1$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $bc26ff461060f8a8$var$isDevelopment = false;
var $bc26ff461060f8a8$var$hyphenateRegex = /[A-Z]|^ms/g;
var $bc26ff461060f8a8$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $bc26ff461060f8a8$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $bc26ff461060f8a8$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $bc26ff461060f8a8$var$processStyleName = /* #__PURE__ */ (0, $9af28dbc4ff027aa$export$2e2bcd8739ae039)(function(styleName) {
    return $bc26ff461060f8a8$var$isCustomProperty(styleName) ? styleName : styleName.replace($bc26ff461060f8a8$var$hyphenateRegex, '-$&').toLowerCase();
});
var $bc26ff461060f8a8$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($bc26ff461060f8a8$var$animationRegex, function(match, p1, p2) {
                $bc26ff461060f8a8$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $bc26ff461060f8a8$var$cursor
                };
                return p1;
            });
    }
    if ((0, $df02772e6ff9e6f1$export$2e2bcd8739ae039)[key] !== 1 && !$bc26ff461060f8a8$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $bc26ff461060f8a8$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $bc26ff461060f8a8$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $bc26ff461060f8a8$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $bc26ff461060f8a8$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $bc26ff461060f8a8$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $bc26ff461060f8a8$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $bc26ff461060f8a8$var$cursor;
                var result = interpolation(mergedProps);
                $bc26ff461060f8a8$var$cursor = previousCursor;
                return $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $bc26ff461060f8a8$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($bc26ff461060f8a8$var$isProcessableValue(asString)) string += $bc26ff461060f8a8$var$processStyleName(key) + ":" + $bc26ff461060f8a8$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $bc26ff461060f8a8$var$isDevelopment) throw new Error($bc26ff461060f8a8$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($bc26ff461060f8a8$var$isProcessableValue(value[_i])) string += $bc26ff461060f8a8$var$processStyleName(key) + ":" + $bc26ff461060f8a8$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $bc26ff461060f8a8$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $bc26ff461060f8a8$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $bc26ff461060f8a8$var$cursor;
function $bc26ff461060f8a8$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $bc26ff461060f8a8$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $bc26ff461060f8a8$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $bc26ff461060f8a8$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $cb67a2560fdadc97$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $bc26ff461060f8a8$var$cursor
    };
}



var $7pfQ9 = parcelRequire("7pfQ9");
var $f888194713c25944$var$isBrowser = typeof document !== 'undefined';
var $f888194713c25944$var$syncFallback = function syncFallback(create) {
    return create();
};
var $f888194713c25944$var$useInsertionEffect = $7pfQ9.useInsertionEffect ? $7pfQ9.useInsertionEffect : false;
var $f888194713c25944$export$db21c7ffa21794e7 = !$f888194713c25944$var$isBrowser ? $f888194713c25944$var$syncFallback : $f888194713c25944$var$useInsertionEffect || $f888194713c25944$var$syncFallback;
var $f888194713c25944$export$811a713a7276cb9d = $f888194713c25944$var$useInsertionEffect || $7pfQ9.useLayoutEffect;


var $7b858e3eb153e419$export$407448d2b89b1813 = false;
var $7b858e3eb153e419$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $7b858e3eb153e419$var$EmotionCacheContext = /* #__PURE__ */ $7pfQ9.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $56efb59e443286cf$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $7b858e3eb153e419$export$e7094788287c5e9b = $7b858e3eb153e419$var$EmotionCacheContext.Provider;
var $7b858e3eb153e419$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7pfQ9.useContext)($7b858e3eb153e419$var$EmotionCacheContext);
};
var $7b858e3eb153e419$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7pfQ9.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7pfQ9.useContext)($7b858e3eb153e419$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$7b858e3eb153e419$export$23f2a1d2818174ef) $7b858e3eb153e419$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7pfQ9.useContext)($7b858e3eb153e419$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $56efb59e443286cf$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $7pfQ9.createElement($7b858e3eb153e419$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $7b858e3eb153e419$export$971d5caa766a69d7 = /* #__PURE__ */ $7pfQ9.createContext({});
var $7b858e3eb153e419$export$3b14a55fb2447963 = function useTheme() {
    return $7pfQ9.useContext($7b858e3eb153e419$export$971d5caa766a69d7);
};
var $7b858e3eb153e419$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $433b84e4025fc999$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $7b858e3eb153e419$var$createCacheWithTheme = /* #__PURE__ */ (0, $383a16c0af63619a$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $383a16c0af63619a$export$2e2bcd8739ae039)(function(theme) {
        return $7b858e3eb153e419$var$getTheme(outerTheme, theme);
    });
});
var $7b858e3eb153e419$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $7pfQ9.useContext($7b858e3eb153e419$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $7b858e3eb153e419$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7pfQ9.createElement($7b858e3eb153e419$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $7b858e3eb153e419$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7pfQ9.forwardRef(function render(props, ref) {
        var theme = $7pfQ9.useContext($7b858e3eb153e419$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7pfQ9.createElement(Component, (0, $433b84e4025fc999$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $9bdfad1d9a53b75c$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $7b858e3eb153e419$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $7b858e3eb153e419$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $7b858e3eb153e419$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($7b858e3eb153e419$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$7b858e3eb153e419$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $7b858e3eb153e419$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $335a9ebca9ef05c6$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $f888194713c25944$export$db21c7ffa21794e7)(function() {
        return (0, $335a9ebca9ef05c6$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$7b858e3eb153e419$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7pfQ9.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $7b858e3eb153e419$var$Emotion = /* #__PURE__ */ $7b858e3eb153e419$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$7b858e3eb153e419$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $335a9ebca9ef05c6$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $bc26ff461060f8a8$export$6321afa313b251b5)(registeredStyles, undefined, $7pfQ9.useContext($7b858e3eb153e419$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($7b858e3eb153e419$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $7b858e3eb153e419$var$typePropName && !$7b858e3eb153e419$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7pfQ9.createElement($7pfQ9.Fragment, null, /*#__PURE__*/ $7pfQ9.createElement($7b858e3eb153e419$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7pfQ9.createElement(WrappedComponent, newProps));
});
var $7b858e3eb153e419$export$a9c23c6ac3fc3eca = $7b858e3eb153e419$var$Emotion;


parcelRequire("7pfQ9");

var $07d605927ce9b919$exports = {};
function $07d605927ce9b919$var$_extends() {
    return $07d605927ce9b919$exports = $07d605927ce9b919$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $07d605927ce9b919$exports.__esModule = true, $07d605927ce9b919$exports["default"] = $07d605927ce9b919$exports, $07d605927ce9b919$var$_extends.apply(null, arguments);
}
$07d605927ce9b919$exports = $07d605927ce9b919$var$_extends, $07d605927ce9b919$exports.__esModule = true, $07d605927ce9b919$exports["default"] = $07d605927ce9b919$exports;








var $ee37356223c3448b$export$ffb0004e005737fa = $39a601ce4590a47e$exports.Fragment;
var $ee37356223c3448b$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $7b858e3eb153e419$export$dda1d9f60106f0e9).call(props, 'css')) return $39a601ce4590a47e$exports.jsx(type, props, key);
    return $39a601ce4590a47e$exports.jsx((0, $7b858e3eb153e419$export$a9c23c6ac3fc3eca), (0, $7b858e3eb153e419$export$db3b6bfb95261072)(type, props), key);
};
var $ee37356223c3448b$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $7b858e3eb153e419$export$dda1d9f60106f0e9).call(props, 'css')) return $39a601ce4590a47e$exports.jsxs(type, props, key);
    return $39a601ce4590a47e$exports.jsxs((0, $7b858e3eb153e419$export$a9c23c6ac3fc3eca), (0, $7b858e3eb153e419$export$db3b6bfb95261072)(type, props), key);
};


var $f8a33d11906b9b49$exports = {};
'use strict';
function $f8a33d11906b9b49$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f8a33d11906b9b49$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f8a33d11906b9b49$var$checkDCE();

$f8a33d11906b9b49$exports = (parcelRequire("kUzXm"));


/**
 * react-router v7.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7pfQ9 = parcelRequire("7pfQ9");
var $690f0550d25c36bf$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-4N6VE7H7.mjs"
});
var $690f0550d25c36bf$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $690f0550d25c36bf$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $690f0550d25c36bf$var$__typeError("Cannot " + msg);
var $690f0550d25c36bf$var$__privateGet = (obj, member, getter)=>($690f0550d25c36bf$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $690f0550d25c36bf$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $690f0550d25c36bf$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $690f0550d25c36bf$var$__privateSet = (obj, member, value, setter)=>($690f0550d25c36bf$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/history.ts
var $690f0550d25c36bf$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($690f0550d25c36bf$export$e19cd5f9376f8cee || {});
var $690f0550d25c36bf$var$PopStateEventType = "popstate";
function $690f0550d25c36bf$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $690f0550d25c36bf$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $690f0550d25c36bf$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $690f0550d25c36bf$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $690f0550d25c36bf$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $690f0550d25c36bf$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $690f0550d25c36bf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $690f0550d25c36bf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $690f0550d25c36bf$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $690f0550d25c36bf$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $690f0550d25c36bf$export$fe53371bee54353d(to);
    }
    return $690f0550d25c36bf$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $690f0550d25c36bf$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $690f0550d25c36bf$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $690f0550d25c36bf$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $690f0550d25c36bf$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $690f0550d25c36bf$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $690f0550d25c36bf$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $690f0550d25c36bf$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $690f0550d25c36bf$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $690f0550d25c36bf$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $690f0550d25c36bf$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $690f0550d25c36bf$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $690f0550d25c36bf$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $690f0550d25c36bf$var$createKey(),
        mask: mask
    };
    return location;
}
function $690f0550d25c36bf$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $690f0550d25c36bf$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $690f0550d25c36bf$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $690f0550d25c36bf$var$isLocation(to) ? to : $690f0550d25c36bf$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $690f0550d25c36bf$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $690f0550d25c36bf$var$isLocation(to) ? to : $690f0550d25c36bf$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $690f0550d25c36bf$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $690f0550d25c36bf$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($690f0550d25c36bf$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($690f0550d25c36bf$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $690f0550d25c36bf$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $690f0550d25c36bf$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $690f0550d25c36bf$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $690f0550d25c36bf$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $690f0550d25c36bf$var$_map;
var $690f0550d25c36bf$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $690f0550d25c36bf$var$__privateAdd(this, $690f0550d25c36bf$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_map).has(context)) return $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_map).set(context, value);
    }
};
$690f0550d25c36bf$var$_map = new WeakMap();
var $690f0550d25c36bf$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $690f0550d25c36bf$var$isUnsupportedLazyRouteObjectKey(key) {
    return $690f0550d25c36bf$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $690f0550d25c36bf$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $690f0550d25c36bf$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $690f0550d25c36bf$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $690f0550d25c36bf$var$isIndexRoute(route) {
    return route.index === true;
}
function $690f0550d25c36bf$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $690f0550d25c36bf$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $690f0550d25c36bf$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($690f0550d25c36bf$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $690f0550d25c36bf$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $690f0550d25c36bf$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $690f0550d25c36bf$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $690f0550d25c36bf$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $690f0550d25c36bf$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $690f0550d25c36bf$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $690f0550d25c36bf$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $690f0550d25c36bf$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $690f0550d25c36bf$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $690f0550d25c36bf$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $690f0550d25c36bf$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $690f0550d25c36bf$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $690f0550d25c36bf$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $690f0550d25c36bf$var$flattenAndRankRoutes(routes) {
    let branches = $690f0550d25c36bf$var$flattenRoutes(routes);
    $690f0550d25c36bf$var$rankRouteBranches(branches);
    return branches;
}
function $690f0550d25c36bf$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $690f0550d25c36bf$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $690f0550d25c36bf$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $690f0550d25c36bf$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $690f0550d25c36bf$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $690f0550d25c36bf$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $690f0550d25c36bf$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $690f0550d25c36bf$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $690f0550d25c36bf$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $690f0550d25c36bf$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $690f0550d25c36bf$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $690f0550d25c36bf$var$paramRe = /^:[\w-]+$/;
var $690f0550d25c36bf$var$dynamicSegmentValue = 3;
var $690f0550d25c36bf$var$indexRouteValue = 2;
var $690f0550d25c36bf$var$emptySegmentValue = 1;
var $690f0550d25c36bf$var$staticSegmentValue = 10;
var $690f0550d25c36bf$var$splatPenalty = -2;
var $690f0550d25c36bf$var$isSplat = (s)=>s === "*";
function $690f0550d25c36bf$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($690f0550d25c36bf$var$isSplat)) initialScore += $690f0550d25c36bf$var$splatPenalty;
    if (index) initialScore += $690f0550d25c36bf$var$indexRouteValue;
    return segments.filter((s)=>!$690f0550d25c36bf$var$isSplat(s)).reduce((score, segment)=>score + ($690f0550d25c36bf$var$paramRe.test(segment) ? $690f0550d25c36bf$var$dynamicSegmentValue : segment === "" ? $690f0550d25c36bf$var$emptySegmentValue : $690f0550d25c36bf$var$staticSegmentValue), initialScore);
}
function $690f0550d25c36bf$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $690f0550d25c36bf$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $690f0550d25c36bf$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $690f0550d25c36bf$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $690f0550d25c36bf$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $690f0550d25c36bf$var$normalizePathname($690f0550d25c36bf$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $690f0550d25c36bf$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $690f0550d25c36bf$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $690f0550d25c36bf$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $690f0550d25c36bf$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $690f0550d25c36bf$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $690f0550d25c36bf$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $690f0550d25c36bf$var$compilePath(path, caseSensitive = false, end = true) {
    $690f0550d25c36bf$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $690f0550d25c36bf$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $690f0550d25c36bf$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $690f0550d25c36bf$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $690f0550d25c36bf$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $690f0550d25c36bf$var$joinPaths([
        basename,
        pathname
    ]);
}
var $690f0550d25c36bf$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $690f0550d25c36bf$var$isAbsoluteUrl = (url)=>$690f0550d25c36bf$var$ABSOLUTE_URL_REGEX.test(url);
function $690f0550d25c36bf$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $690f0550d25c36bf$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $690f0550d25c36bf$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $690f0550d25c36bf$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $690f0550d25c36bf$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $690f0550d25c36bf$var$normalizeSearch(search),
        hash: $690f0550d25c36bf$var$normalizeHash(hash)
    };
}
function $690f0550d25c36bf$var$resolvePathname(relativePath, fromPathname) {
    let segments = $690f0550d25c36bf$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $690f0550d25c36bf$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $690f0550d25c36bf$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $690f0550d25c36bf$var$getResolveToMatches(matches) {
    let pathMatches = $690f0550d25c36bf$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $690f0550d25c36bf$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $690f0550d25c36bf$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $690f0550d25c36bf$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $690f0550d25c36bf$var$getInvalidPathError("?", "pathname", "search", to));
        $690f0550d25c36bf$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $690f0550d25c36bf$var$getInvalidPathError("#", "pathname", "hash", to));
        $690f0550d25c36bf$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $690f0550d25c36bf$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $690f0550d25c36bf$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $690f0550d25c36bf$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
var $690f0550d25c36bf$var$joinPaths = (paths)=>$690f0550d25c36bf$var$removeDoubleSlashes(paths.join("/"));
var $690f0550d25c36bf$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $690f0550d25c36bf$var$normalizePathname = (pathname)=>$690f0550d25c36bf$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $690f0550d25c36bf$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $690f0550d25c36bf$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $690f0550d25c36bf$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $690f0550d25c36bf$export$4051a07651545597(data2, init) {
    return new $690f0550d25c36bf$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $690f0550d25c36bf$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $690f0550d25c36bf$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $690f0550d25c36bf$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $690f0550d25c36bf$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $690f0550d25c36bf$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $690f0550d25c36bf$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $690f0550d25c36bf$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $690f0550d25c36bf$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $690f0550d25c36bf$var$joinPaths(parts) || "/";
}
var $690f0550d25c36bf$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $690f0550d25c36bf$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$690f0550d25c36bf$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($690f0550d25c36bf$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $690f0550d25c36bf$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $690f0550d25c36bf$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $690f0550d25c36bf$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $690f0550d25c36bf$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $690f0550d25c36bf$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $690f0550d25c36bf$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$690f0550d25c36bf$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $690f0550d25c36bf$var$wrapImpl(aggregated[key], original, (...args)=>$690f0550d25c36bf$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$690f0550d25c36bf$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$690f0550d25c36bf$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $690f0550d25c36bf$var$wrapImpl(aggregated.middleware, original, (...args)=>$690f0550d25c36bf$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$690f0550d25c36bf$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $690f0550d25c36bf$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$690f0550d25c36bf$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $690f0550d25c36bf$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $690f0550d25c36bf$export$fe53371bee54353d(to) : ".",
                ...$690f0550d25c36bf$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$690f0550d25c36bf$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$690f0550d25c36bf$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $690f0550d25c36bf$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$690f0550d25c36bf$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$690f0550d25c36bf$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $690f0550d25c36bf$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $690f0550d25c36bf$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $690f0550d25c36bf$var$getReadonlyRequest(request),
            context: context != null ? $690f0550d25c36bf$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $690f0550d25c36bf$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $690f0550d25c36bf$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $690f0550d25c36bf$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $690f0550d25c36bf$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $690f0550d25c36bf$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $690f0550d25c36bf$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $690f0550d25c36bf$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $690f0550d25c36bf$var$getReadonlyContext(context)
    };
}
function $690f0550d25c36bf$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $690f0550d25c36bf$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $690f0550d25c36bf$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $690f0550d25c36bf$var$getReadonlyContext(context) {
    if ($690f0550d25c36bf$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $690f0550d25c36bf$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $690f0550d25c36bf$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $690f0550d25c36bf$var$objectProtoNames;
}
// lib/router/router.ts
var $690f0550d25c36bf$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $690f0550d25c36bf$var$validMutationMethods = new Set($690f0550d25c36bf$var$validMutationMethodsArr);
var $690f0550d25c36bf$var$validRequestMethodsArr = [
    "GET",
    ...$690f0550d25c36bf$var$validMutationMethodsArr
];
var $690f0550d25c36bf$var$validRequestMethods = new Set($690f0550d25c36bf$var$validRequestMethodsArr);
var $690f0550d25c36bf$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $690f0550d25c36bf$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $690f0550d25c36bf$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $690f0550d25c36bf$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $690f0550d25c36bf$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $690f0550d25c36bf$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $690f0550d25c36bf$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $690f0550d25c36bf$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $690f0550d25c36bf$var$_routes, $690f0550d25c36bf$var$_branches, $690f0550d25c36bf$var$_hmrRoutes, $690f0550d25c36bf$var$_hmrBranches;
var $690f0550d25c36bf$var$DataRoutes = class {
    constructor(routes){
        $690f0550d25c36bf$var$__privateAdd(this, $690f0550d25c36bf$var$_routes);
        $690f0550d25c36bf$var$__privateAdd(this, $690f0550d25c36bf$var$_branches);
        $690f0550d25c36bf$var$__privateAdd(this, $690f0550d25c36bf$var$_hmrRoutes);
        $690f0550d25c36bf$var$__privateAdd(this, $690f0550d25c36bf$var$_hmrBranches);
        $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_routes, routes);
        $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_branches, $690f0550d25c36bf$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_hmrRoutes) ?? $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_hmrBranches) ?? $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_branches);
    }
    get hasHMRRoutes() {
        return $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_routes, routes);
        $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_branches, $690f0550d25c36bf$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_hmrRoutes, routes);
        $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_hmrBranches, $690f0550d25c36bf$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_hmrRoutes)) {
            $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_routes, $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_hmrRoutes));
            $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_branches, $690f0550d25c36bf$var$__privateGet(this, $690f0550d25c36bf$var$_hmrBranches));
            $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_hmrRoutes, void 0);
            $690f0550d25c36bf$var$__privateSet(this, $690f0550d25c36bf$var$_hmrBranches, void 0);
        }
    }
};
$690f0550d25c36bf$var$_routes = new WeakMap();
$690f0550d25c36bf$var$_branches = new WeakMap();
$690f0550d25c36bf$var$_hmrRoutes = new WeakMap();
$690f0550d25c36bf$var$_hmrBranches = new WeakMap();
function $690f0550d25c36bf$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $690f0550d25c36bf$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $690f0550d25c36bf$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$690f0550d25c36bf$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $690f0550d25c36bf$var$DataRoutes($690f0550d25c36bf$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $690f0550d25c36bf$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $690f0550d25c36bf$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $690f0550d25c36bf$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $690f0550d25c36bf$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$690f0550d25c36bf$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $690f0550d25c36bf$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $690f0550d25c36bf$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $690f0550d25c36bf$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $690f0550d25c36bf$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $690f0550d25c36bf$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$690f0550d25c36bf$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $690f0550d25c36bf$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $690f0550d25c36bf$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $690f0550d25c36bf$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $690f0550d25c36bf$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $690f0550d25c36bf$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $690f0550d25c36bf$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $690f0550d25c36bf$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $690f0550d25c36bf$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $690f0550d25c36bf$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $690f0550d25c36bf$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $690f0550d25c36bf$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $690f0550d25c36bf$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $690f0550d25c36bf$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $690f0550d25c36bf$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $690f0550d25c36bf$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $690f0550d25c36bf$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $690f0550d25c36bf$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $690f0550d25c36bf$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $690f0550d25c36bf$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $690f0550d25c36bf$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($690f0550d25c36bf$var$isErrorResult(result) && $690f0550d25c36bf$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $690f0550d25c36bf$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $690f0550d25c36bf$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$690f0550d25c36bf$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $690f0550d25c36bf$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $690f0550d25c36bf$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $690f0550d25c36bf$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $690f0550d25c36bf$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $690f0550d25c36bf$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $690f0550d25c36bf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($690f0550d25c36bf$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $690f0550d25c36bf$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($690f0550d25c36bf$var$isErrorResult(result)) {
            let boundaryMatch = $690f0550d25c36bf$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $690f0550d25c36bf$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $690f0550d25c36bf$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $690f0550d25c36bf$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $690f0550d25c36bf$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $690f0550d25c36bf$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $690f0550d25c36bf$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$690f0550d25c36bf$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $690f0550d25c36bf$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $690f0550d25c36bf$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $690f0550d25c36bf$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$690f0550d25c36bf$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $690f0550d25c36bf$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $690f0550d25c36bf$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $690f0550d25c36bf$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $690f0550d25c36bf$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $690f0550d25c36bf$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $690f0550d25c36bf$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $690f0550d25c36bf$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $690f0550d25c36bf$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $690f0550d25c36bf$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $690f0550d25c36bf$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $690f0550d25c36bf$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $690f0550d25c36bf$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $690f0550d25c36bf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($690f0550d25c36bf$var$isRedirectResult(actionResult) || $690f0550d25c36bf$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $690f0550d25c36bf$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($690f0550d25c36bf$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $690f0550d25c36bf$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $690f0550d25c36bf$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($690f0550d25c36bf$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $690f0550d25c36bf$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $690f0550d25c36bf$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $690f0550d25c36bf$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $690f0550d25c36bf$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $690f0550d25c36bf$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $690f0550d25c36bf$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $690f0550d25c36bf$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $690f0550d25c36bf$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $690f0550d25c36bf$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $690f0550d25c36bf$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $690f0550d25c36bf$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $690f0550d25c36bf$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $690f0550d25c36bf$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $690f0550d25c36bf$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $690f0550d25c36bf$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $690f0550d25c36bf$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $690f0550d25c36bf$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $690f0550d25c36bf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $690f0550d25c36bf$var$getDoneFetcher(void 0));
            return;
        }
        if ($690f0550d25c36bf$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $690f0550d25c36bf$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($690f0550d25c36bf$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $690f0550d25c36bf$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $690f0550d25c36bf$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $690f0550d25c36bf$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $690f0550d25c36bf$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($690f0550d25c36bf$var$isAbsoluteUrl(location)) {
                const url = $690f0550d25c36bf$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $690f0550d25c36bf$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $690f0550d25c36bf$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($690f0550d25c36bf$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $690f0550d25c36bf$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $690f0550d25c36bf$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $690f0550d25c36bf$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$690f0550d25c36bf$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($690f0550d25c36bf$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $690f0550d25c36bf$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $690f0550d25c36bf$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $690f0550d25c36bf$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $690f0550d25c36bf$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $690f0550d25c36bf$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $690f0550d25c36bf$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $690f0550d25c36bf$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $690f0550d25c36bf$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $690f0550d25c36bf$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $690f0550d25c36bf$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $690f0550d25c36bf$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $690f0550d25c36bf$export$386d57f03f0b2883;
        $690f0550d25c36bf$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $690f0550d25c36bf$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $690f0550d25c36bf$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $690f0550d25c36bf$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $690f0550d25c36bf$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$690f0550d25c36bf$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $690f0550d25c36bf$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $690f0550d25c36bf$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $690f0550d25c36bf$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $690f0550d25c36bf$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $690f0550d25c36bf$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $690f0550d25c36bf$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($690f0550d25c36bf$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $690f0550d25c36bf$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $690f0550d25c36bf$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $690f0550d25c36bf$export$3336b097a6fbc59a(routes, opts) {
    $690f0550d25c36bf$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $690f0550d25c36bf$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$690f0550d25c36bf$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $690f0550d25c36bf$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $690f0550d25c36bf$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $690f0550d25c36bf$var$defaultNormalizePath;
        let method = request.method;
        let location = $690f0550d25c36bf$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $690f0550d25c36bf$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $690f0550d25c36bf$export$b8d3e69d4b3eff04();
        if (!$690f0550d25c36bf$var$isValidMethod(method) && method !== "HEAD") {
            let error = $690f0550d25c36bf$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $690f0550d25c36bf$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $690f0550d25c36bf$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $690f0550d25c36bf$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $690f0550d25c36bf$export$f5708dca728d7177(requestContext instanceof $690f0550d25c36bf$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $690f0550d25c36bf$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $690f0550d25c36bf$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $690f0550d25c36bf$var$createDataFunctionUrl(request, location),
                    pattern: $690f0550d25c36bf$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($690f0550d25c36bf$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($690f0550d25c36bf$export$6e80290866a84dd4(error)) return error;
                    if ($690f0550d25c36bf$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $690f0550d25c36bf$export$f2680fa305b734ca(error.status, error.statusText, await $690f0550d25c36bf$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($690f0550d25c36bf$export$e0163cfdf7bc9cfa(error)) error = $690f0550d25c36bf$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $690f0550d25c36bf$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $690f0550d25c36bf$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $690f0550d25c36bf$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $690f0550d25c36bf$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $690f0550d25c36bf$export$f5708dca728d7177($690f0550d25c36bf$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($690f0550d25c36bf$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($690f0550d25c36bf$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $690f0550d25c36bf$var$defaultNormalizePath;
        let method = request.method;
        let location = $690f0550d25c36bf$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $690f0550d25c36bf$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $690f0550d25c36bf$export$b8d3e69d4b3eff04();
        if (!$690f0550d25c36bf$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $690f0550d25c36bf$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $690f0550d25c36bf$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $690f0550d25c36bf$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $690f0550d25c36bf$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $690f0550d25c36bf$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $690f0550d25c36bf$export$f5708dca728d7177(requestContext instanceof $690f0550d25c36bf$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $690f0550d25c36bf$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $690f0550d25c36bf$var$runServerMiddlewarePipeline({
                request: request,
                url: $690f0550d25c36bf$var$createDataFunctionUrl(request, location),
                pattern: $690f0550d25c36bf$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $690f0550d25c36bf$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($690f0550d25c36bf$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($690f0550d25c36bf$var$dataWithResponseInitToResponse(error));
                if ($690f0550d25c36bf$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($690f0550d25c36bf$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $690f0550d25c36bf$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($690f0550d25c36bf$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $690f0550d25c36bf$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $690f0550d25c36bf$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($690f0550d25c36bf$var$isDataStrategyResult(e) && $690f0550d25c36bf$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($690f0550d25c36bf$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $690f0550d25c36bf$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $690f0550d25c36bf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $690f0550d25c36bf$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($690f0550d25c36bf$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($690f0550d25c36bf$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($690f0550d25c36bf$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $690f0550d25c36bf$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $690f0550d25c36bf$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($690f0550d25c36bf$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $690f0550d25c36bf$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $690f0550d25c36bf$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $690f0550d25c36bf$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $690f0550d25c36bf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $690f0550d25c36bf$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $690f0550d25c36bf$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $690f0550d25c36bf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $690f0550d25c36bf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $690f0550d25c36bf$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $690f0550d25c36bf$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $690f0550d25c36bf$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $690f0550d25c36bf$var$callDataStrategyImpl(dataStrategy || $690f0550d25c36bf$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($690f0550d25c36bf$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $690f0550d25c36bf$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($690f0550d25c36bf$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($690f0550d25c36bf$export$e0163cfdf7bc9cfa(result.result)) throw $690f0550d25c36bf$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $690f0550d25c36bf$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $690f0550d25c36bf$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $690f0550d25c36bf$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $690f0550d25c36bf$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $690f0550d25c36bf$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $690f0550d25c36bf$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $690f0550d25c36bf$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $690f0550d25c36bf$var$resolveTo(to ? to : ".", $690f0550d25c36bf$var$getResolveToMatches(contextualMatches), $690f0550d25c36bf$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $690f0550d25c36bf$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $690f0550d25c36bf$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $690f0550d25c36bf$export$fe53371bee54353d(path);
}
function $690f0550d25c36bf$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$690f0550d25c36bf$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$690f0550d25c36bf$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $690f0550d25c36bf$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $690f0550d25c36bf$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $690f0550d25c36bf$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$690f0550d25c36bf$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$690f0550d25c36bf$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $690f0550d25c36bf$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $690f0550d25c36bf$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $690f0550d25c36bf$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $690f0550d25c36bf$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $690f0550d25c36bf$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($690f0550d25c36bf$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $690f0550d25c36bf$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $690f0550d25c36bf$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $690f0550d25c36bf$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $690f0550d25c36bf$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $690f0550d25c36bf$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $690f0550d25c36bf$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $690f0550d25c36bf$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$690f0550d25c36bf$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $690f0550d25c36bf$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($690f0550d25c36bf$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $690f0550d25c36bf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($690f0550d25c36bf$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $690f0550d25c36bf$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $690f0550d25c36bf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $690f0550d25c36bf$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $690f0550d25c36bf$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $690f0550d25c36bf$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $690f0550d25c36bf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $690f0550d25c36bf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($690f0550d25c36bf$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $690f0550d25c36bf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $690f0550d25c36bf$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $690f0550d25c36bf$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$690f0550d25c36bf$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $690f0550d25c36bf$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $690f0550d25c36bf$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $690f0550d25c36bf$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $690f0550d25c36bf$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $690f0550d25c36bf$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$690f0550d25c36bf$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $690f0550d25c36bf$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $690f0550d25c36bf$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $690f0550d25c36bf$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$690f0550d25c36bf$var$isSameRoute(aChild, bChild))) ?? false;
}
var $690f0550d25c36bf$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $690f0550d25c36bf$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $690f0550d25c36bf$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $690f0550d25c36bf$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $690f0550d25c36bf$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $690f0550d25c36bf$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $690f0550d25c36bf$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $690f0550d25c36bf$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $690f0550d25c36bf$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $690f0550d25c36bf$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $690f0550d25c36bf$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $690f0550d25c36bf$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $690f0550d25c36bf$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $690f0550d25c36bf$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $690f0550d25c36bf$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $690f0550d25c36bf$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $690f0550d25c36bf$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $690f0550d25c36bf$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $690f0550d25c36bf$var$isNonNullable(value) {
    return value !== void 0;
}
function $690f0550d25c36bf$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $690f0550d25c36bf$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($690f0550d25c36bf$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $690f0550d25c36bf$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $690f0550d25c36bf$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $690f0550d25c36bf$var$defaultDataStrategy(args);
    return $690f0550d25c36bf$var$runClientMiddlewarePipeline(args, ()=>$690f0550d25c36bf$var$defaultDataStrategy(args));
}
function $690f0550d25c36bf$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $690f0550d25c36bf$var$runMiddlewarePipeline(args, handler, processResult, $690f0550d25c36bf$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $690f0550d25c36bf$export$e0163cfdf7bc9cfa(result) ? $690f0550d25c36bf$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $690f0550d25c36bf$var$runClientMiddlewarePipeline(args, handler) {
    return $690f0550d25c36bf$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($690f0550d25c36bf$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $690f0550d25c36bf$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $690f0550d25c36bf$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $690f0550d25c36bf$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $690f0550d25c36bf$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $690f0550d25c36bf$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $690f0550d25c36bf$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $690f0550d25c36bf$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $690f0550d25c36bf$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $690f0550d25c36bf$var$loadLazyRoute(match.route, $690f0550d25c36bf$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $690f0550d25c36bf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $690f0550d25c36bf$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $690f0550d25c36bf$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $690f0550d25c36bf$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $690f0550d25c36bf$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$690f0550d25c36bf$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($690f0550d25c36bf$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $690f0550d25c36bf$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $690f0550d25c36bf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $690f0550d25c36bf$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $690f0550d25c36bf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $690f0550d25c36bf$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $690f0550d25c36bf$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $690f0550d25c36bf$var$createDataFunctionUrl(request, path),
        pattern: $690f0550d25c36bf$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $690f0550d25c36bf$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $690f0550d25c36bf$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $690f0550d25c36bf$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $690f0550d25c36bf$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $690f0550d25c36bf$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $690f0550d25c36bf$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $690f0550d25c36bf$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $690f0550d25c36bf$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($690f0550d25c36bf$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $690f0550d25c36bf$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $690f0550d25c36bf$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($690f0550d25c36bf$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $690f0550d25c36bf$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $690f0550d25c36bf$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $690f0550d25c36bf$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($690f0550d25c36bf$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $690f0550d25c36bf$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $690f0550d25c36bf$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$690f0550d25c36bf$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $690f0550d25c36bf$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $690f0550d25c36bf$export$30ab200a1a0a2def = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $690f0550d25c36bf$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($690f0550d25c36bf$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if ($690f0550d25c36bf$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $690f0550d25c36bf$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $690f0550d25c36bf$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($690f0550d25c36bf$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $690f0550d25c36bf$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($690f0550d25c36bf$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $690f0550d25c36bf$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $690f0550d25c36bf$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $690f0550d25c36bf$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $690f0550d25c36bf$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $690f0550d25c36bf$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $690f0550d25c36bf$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $690f0550d25c36bf$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $690f0550d25c36bf$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $690f0550d25c36bf$export$f5708dca728d7177(!$690f0550d25c36bf$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($690f0550d25c36bf$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $690f0550d25c36bf$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $690f0550d25c36bf$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $690f0550d25c36bf$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $690f0550d25c36bf$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $690f0550d25c36bf$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $690f0550d25c36bf$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($690f0550d25c36bf$var$isErrorResult(result)) {
            let boundaryMatch = $690f0550d25c36bf$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($690f0550d25c36bf$var$isRedirectResult(result)) $690f0550d25c36bf$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $690f0550d25c36bf$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $690f0550d25c36bf$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $690f0550d25c36bf$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $690f0550d25c36bf$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $690f0550d25c36bf$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $690f0550d25c36bf$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $690f0550d25c36bf$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $690f0550d25c36bf$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $690f0550d25c36bf$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $690f0550d25c36bf$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($690f0550d25c36bf$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $690f0550d25c36bf$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $690f0550d25c36bf$export$8ccf933b0513f8d0(path) : path;
    return $690f0550d25c36bf$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $690f0550d25c36bf$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $690f0550d25c36bf$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $690f0550d25c36bf$var$dataWithResponseInitToErrorResponse(data2) {
    return new $690f0550d25c36bf$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $690f0550d25c36bf$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $690f0550d25c36bf$var$isDataStrategyResult(value));
}
function $690f0550d25c36bf$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $690f0550d25c36bf$var$isRedirectDataStrategyResult(result) {
    return $690f0550d25c36bf$export$3f1eb41d9a6a6a27(result.result) && $690f0550d25c36bf$var$redirectStatusCodes.has(result.result.status);
}
function $690f0550d25c36bf$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $690f0550d25c36bf$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $690f0550d25c36bf$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $690f0550d25c36bf$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $690f0550d25c36bf$export$794b2760043cf8cd(statusCode) {
    return $690f0550d25c36bf$var$redirectStatusCodes.has(statusCode);
}
function $690f0550d25c36bf$export$6e80290866a84dd4(result) {
    return $690f0550d25c36bf$export$3f1eb41d9a6a6a27(result) && $690f0550d25c36bf$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $690f0550d25c36bf$var$isValidMethod(method) {
    return $690f0550d25c36bf$var$validRequestMethods.has(method.toUpperCase());
}
function $690f0550d25c36bf$export$cbae47800eb95bc3(method) {
    return $690f0550d25c36bf$var$validMutationMethods.has(method.toUpperCase());
}
function $690f0550d25c36bf$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $690f0550d25c36bf$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $690f0550d25c36bf$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $690f0550d25c36bf$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $690f0550d25c36bf$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $690f0550d25c36bf$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $690f0550d25c36bf$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $690f0550d25c36bf$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $690f0550d25c36bf$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $690f0550d25c36bf$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $690f0550d25c36bf$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $690f0550d25c36bf$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($690f0550d25c36bf$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $690f0550d25c36bf$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($690f0550d25c36bf$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $690f0550d25c36bf$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $690f0550d25c36bf$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $690f0550d25c36bf$export$2eeee58951ff3c1c = $7pfQ9.createContext(null);
$690f0550d25c36bf$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $690f0550d25c36bf$export$315e3ffb01f217 = $7pfQ9.createContext(null);
$690f0550d25c36bf$export$315e3ffb01f217.displayName = "DataRouterState";
var $690f0550d25c36bf$export$717f757c655223f1 = $7pfQ9.createContext(false);
function $690f0550d25c36bf$var$useIsRSCRouterContext() {
    return $7pfQ9.useContext($690f0550d25c36bf$export$717f757c655223f1);
}
var $690f0550d25c36bf$export$3681f408decb40d1 = $7pfQ9.createContext({
    isTransitioning: false
});
$690f0550d25c36bf$export$3681f408decb40d1.displayName = "ViewTransition";
var $690f0550d25c36bf$export$cb3f1df1bef00a39 = $7pfQ9.createContext(/* @__PURE__ */ new Map());
$690f0550d25c36bf$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $690f0550d25c36bf$var$AwaitContext = $7pfQ9.createContext(null);
$690f0550d25c36bf$var$AwaitContext.displayName = "Await";
var $690f0550d25c36bf$export$2666c20e15407622 = (props)=>$7pfQ9.createElement($690f0550d25c36bf$var$AwaitContext.Provider, props);
var $690f0550d25c36bf$export$3044ab7fdabeaee6 = $7pfQ9.createContext(null);
$690f0550d25c36bf$export$3044ab7fdabeaee6.displayName = "Navigation";
var $690f0550d25c36bf$export$e6a44b110a0c44d3 = $7pfQ9.createContext(null);
$690f0550d25c36bf$export$e6a44b110a0c44d3.displayName = "Location";
var $690f0550d25c36bf$export$aac280ed165a4397 = $7pfQ9.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$690f0550d25c36bf$export$aac280ed165a4397.displayName = "Route";
var $690f0550d25c36bf$var$RouteErrorContext = $7pfQ9.createContext(null);
$690f0550d25c36bf$var$RouteErrorContext.displayName = "RouteError";
var $690f0550d25c36bf$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $690f0550d25c36bf$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $690f0550d25c36bf$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $690f0550d25c36bf$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $690f0550d25c36bf$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$690f0550d25c36bf$var$ERROR_DIGEST_BASE}:${$690f0550d25c36bf$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $690f0550d25c36bf$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$690f0550d25c36bf$var$ERROR_DIGEST_BASE}:${$690f0550d25c36bf$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $690f0550d25c36bf$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $690f0550d25c36bf$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $690f0550d25c36bf$export$f5708dca728d7177($690f0550d25c36bf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $690f0550d25c36bf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $690f0550d25c36bf$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $690f0550d25c36bf$export$9c954a9d03d32f4a() {
    return $7pfQ9.useContext($690f0550d25c36bf$export$e6a44b110a0c44d3) != null;
}
function $690f0550d25c36bf$export$45d76561a5302f2b() {
    $690f0550d25c36bf$export$f5708dca728d7177($690f0550d25c36bf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $7pfQ9.useContext($690f0550d25c36bf$export$e6a44b110a0c44d3).location;
}
function $690f0550d25c36bf$export$1b3f31771c5d07c() {
    return $7pfQ9.useContext($690f0550d25c36bf$export$e6a44b110a0c44d3).navigationType;
}
function $690f0550d25c36bf$export$6c330e8992e8a295(pattern) {
    $690f0550d25c36bf$export$f5708dca728d7177($690f0550d25c36bf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $690f0550d25c36bf$export$45d76561a5302f2b();
    return $7pfQ9.useMemo(()=>$690f0550d25c36bf$export$81336c211d5ff295(pattern, $690f0550d25c36bf$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $690f0550d25c36bf$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $690f0550d25c36bf$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6).static;
    if (!isStatic) $7pfQ9.useLayoutEffect(cb);
}
function $690f0550d25c36bf$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397);
    return isDataRoute ? $690f0550d25c36bf$var$useNavigateStable() : $690f0550d25c36bf$var$useNavigateUnstable();
}
function $690f0550d25c36bf$var$useNavigateUnstable() {
    $690f0550d25c36bf$export$f5708dca728d7177($690f0550d25c36bf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $7pfQ9.useContext($690f0550d25c36bf$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let { matches: matches } = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397);
    let { pathname: locationPathname } = $690f0550d25c36bf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($690f0550d25c36bf$var$getResolveToMatches(matches));
    let activeRef = $7pfQ9.useRef(false);
    $690f0550d25c36bf$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7pfQ9.useCallback((to, options = {})=>{
        $690f0550d25c36bf$var$warning(activeRef.current, $690f0550d25c36bf$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $690f0550d25c36bf$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $690f0550d25c36bf$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $690f0550d25c36bf$var$OutletContext = $7pfQ9.createContext(null);
function $690f0550d25c36bf$export$4138103a3ae699cc() {
    return $7pfQ9.useContext($690f0550d25c36bf$var$OutletContext);
}
function $690f0550d25c36bf$export$a3be3530d8e40d0b(context) {
    let outlet = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397).outlet;
    return $7pfQ9.useMemo(()=>outlet && /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $690f0550d25c36bf$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $690f0550d25c36bf$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397);
    let { pathname: locationPathname } = $690f0550d25c36bf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($690f0550d25c36bf$var$getResolveToMatches(matches));
    return $7pfQ9.useMemo(()=>$690f0550d25c36bf$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $690f0550d25c36bf$export$5d3fca4a98652595(routes, locationArg) {
    return $690f0550d25c36bf$var$useRoutesImpl(routes, locationArg);
}
function $690f0550d25c36bf$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $690f0550d25c36bf$export$f5708dca728d7177($690f0550d25c36bf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($690f0550d25c36bf$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $690f0550d25c36bf$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $690f0550d25c36bf$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $690f0550d25c36bf$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $690f0550d25c36bf$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $690f0550d25c36bf$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($690f0550d25c36bf$export$945fecf35a8ef089) {
        $690f0550d25c36bf$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $690f0550d25c36bf$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $690f0550d25c36bf$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $690f0550d25c36bf$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $690f0550d25c36bf$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $690f0550d25c36bf$var$DefaultErrorComponent() {
    let error = $690f0550d25c36bf$export$ed527bf60f6e05f2();
    let message = $690f0550d25c36bf$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($690f0550d25c36bf$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $7pfQ9.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $7pfQ9.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $7pfQ9.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $7pfQ9.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $7pfQ9.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $690f0550d25c36bf$var$defaultErrorElement = /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$DefaultErrorComponent, null);
var $690f0550d25c36bf$var$RenderErrorBoundary = class extends $7pfQ9.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $690f0550d25c36bf$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$690f0550d25c36bf$var$RenderErrorBoundary.contextType = $690f0550d25c36bf$export$717f757c655223f1;
var $690f0550d25c36bf$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $690f0550d25c36bf$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $690f0550d25c36bf$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $690f0550d25c36bf$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $690f0550d25c36bf$var$parseToInfo(redirect2.location, basename);
            if ($690f0550d25c36bf$var$isBrowser && !$690f0550d25c36bf$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $690f0550d25c36bf$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $7pfQ9.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $690f0550d25c36bf$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $7pfQ9.useContext($690f0550d25c36bf$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $690f0550d25c36bf$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $690f0550d25c36bf$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $690f0550d25c36bf$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $690f0550d25c36bf$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $690f0550d25c36bf$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $7pfQ9.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $690f0550d25c36bf$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $690f0550d25c36bf$var$useDataRouterContext(hookName) {
    let ctx = $7pfQ9.useContext($690f0550d25c36bf$export$2eeee58951ff3c1c);
    $690f0550d25c36bf$export$f5708dca728d7177(ctx, $690f0550d25c36bf$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $690f0550d25c36bf$var$useDataRouterState(hookName) {
    let state = $7pfQ9.useContext($690f0550d25c36bf$export$315e3ffb01f217);
    $690f0550d25c36bf$export$f5708dca728d7177(state, $690f0550d25c36bf$var$getDataRouterConsoleError(hookName));
    return state;
}
function $690f0550d25c36bf$var$useRouteContext(hookName) {
    let route = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397);
    $690f0550d25c36bf$export$f5708dca728d7177(route, $690f0550d25c36bf$var$getDataRouterConsoleError(hookName));
    return route;
}
function $690f0550d25c36bf$var$useCurrentRouteId(hookName) {
    let route = $690f0550d25c36bf$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $690f0550d25c36bf$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $690f0550d25c36bf$var$useRouteId() {
    return $690f0550d25c36bf$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $690f0550d25c36bf$export$d0fd4b7106de2769() {
    let state = $690f0550d25c36bf$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $7pfQ9.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $690f0550d25c36bf$export$600dc272ed516c15() {
    let dataRouterContext = $690f0550d25c36bf$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $690f0550d25c36bf$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $7pfQ9.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $7pfQ9.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $690f0550d25c36bf$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $690f0550d25c36bf$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $7pfQ9.useMemo(()=>matches.map((m)=>$690f0550d25c36bf$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $690f0550d25c36bf$export$1448a5050d252c4d() {
    let state = $690f0550d25c36bf$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $690f0550d25c36bf$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $690f0550d25c36bf$export$fd5d37484eab868d(routeId) {
    let state = $690f0550d25c36bf$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $690f0550d25c36bf$export$fdc00f3f26066d5e() {
    let state = $690f0550d25c36bf$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $690f0550d25c36bf$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $690f0550d25c36bf$export$ed527bf60f6e05f2() {
    let error = $7pfQ9.useContext($690f0550d25c36bf$var$RouteErrorContext);
    let state = $690f0550d25c36bf$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $690f0550d25c36bf$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $690f0550d25c36bf$export$78a72ddb39bdd145() {
    let value = $7pfQ9.useContext($690f0550d25c36bf$var$AwaitContext);
    return value?._data;
}
function $690f0550d25c36bf$export$17f53340677d5831() {
    let value = $7pfQ9.useContext($690f0550d25c36bf$var$AwaitContext);
    return value?._error;
}
var $690f0550d25c36bf$var$blockerId = 0;
function $690f0550d25c36bf$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $690f0550d25c36bf$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $690f0550d25c36bf$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $7pfQ9.useState("");
    let blockerFunction = $7pfQ9.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $690f0550d25c36bf$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $690f0550d25c36bf$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $7pfQ9.useEffect(()=>{
        let key = String(++$690f0550d25c36bf$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $7pfQ9.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $690f0550d25c36bf$export$386d57f03f0b2883;
}
function $690f0550d25c36bf$var$useNavigateStable() {
    let { router: router } = $690f0550d25c36bf$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $690f0550d25c36bf$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $7pfQ9.useRef(false);
    $690f0550d25c36bf$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7pfQ9.useCallback(async (to, options = {})=>{
        $690f0550d25c36bf$var$warning(activeRef.current, $690f0550d25c36bf$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $690f0550d25c36bf$var$alreadyWarned = {};
function $690f0550d25c36bf$var$warningOnce(key, cond, message) {
    if (!cond && !$690f0550d25c36bf$var$alreadyWarned[key]) {
        $690f0550d25c36bf$var$alreadyWarned[key] = true;
        $690f0550d25c36bf$var$warning(false, message);
    }
}
function $690f0550d25c36bf$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $690f0550d25c36bf$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $690f0550d25c36bf$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $690f0550d25c36bf$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $690f0550d25c36bf$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $690f0550d25c36bf$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $7pfQ9.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$690f0550d25c36bf$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $7pfQ9.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$690f0550d25c36bf$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $7pfQ9.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $690f0550d25c36bf$var$alreadyWarned2 = {};
function $690f0550d25c36bf$export$5b28268982f175ba(condition, message) {
    if (!condition && !$690f0550d25c36bf$var$alreadyWarned2[message]) {
        $690f0550d25c36bf$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $690f0550d25c36bf$var$USE_OPTIMISTIC = "useOptimistic";
var $690f0550d25c36bf$var$useOptimisticImpl = $7pfQ9[$690f0550d25c36bf$var$USE_OPTIMISTIC];
var $690f0550d25c36bf$var$stableUseOptimisticSetter = ()=>void 0;
function $690f0550d25c36bf$var$useOptimisticSafe(val) {
    if ($690f0550d25c36bf$var$useOptimisticImpl) return $690f0550d25c36bf$var$useOptimisticImpl(val);
    else return [
        val,
        $690f0550d25c36bf$var$stableUseOptimisticSetter
    ];
}
function $690f0550d25c36bf$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($690f0550d25c36bf$export$945fecf35a8ef089) {
            if (route.element) $690f0550d25c36bf$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $7pfQ9.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($690f0550d25c36bf$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $690f0550d25c36bf$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $7pfQ9.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($690f0550d25c36bf$export$945fecf35a8ef089) {
            if (route.errorElement) $690f0550d25c36bf$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $7pfQ9.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $690f0550d25c36bf$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $690f0550d25c36bf$export$f30f7e456d254e83(routes, opts) {
    return $690f0550d25c36bf$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $690f0550d25c36bf$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $690f0550d25c36bf$export$e2fd2c03906469db,
        mapRouteProperties: $690f0550d25c36bf$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $690f0550d25c36bf$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $690f0550d25c36bf$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $690f0550d25c36bf$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $7pfQ9.useState(router.state);
    let [state, setOptimisticState] = $690f0550d25c36bf$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $7pfQ9.useState();
    let [vtContext, setVtContext] = $7pfQ9.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7pfQ9.useState();
    let [transition, setTransition] = $7pfQ9.useState();
    let [interruption, setInterruption] = $7pfQ9.useState();
    let fetcherData = $7pfQ9.useRef(/* @__PURE__ */ new Map());
    let setState = $7pfQ9.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $690f0550d25c36bf$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $690f0550d25c36bf$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $690f0550d25c36bf$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $7pfQ9.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$690f0550d25c36bf$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $7pfQ9.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7pfQ9.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $690f0550d25c36bf$var$Deferred());
    }, [
        vtContext
    ]);
    $7pfQ9.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $7pfQ9.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$690f0550d25c36bf$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $7pfQ9.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $7pfQ9.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7pfQ9.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7pfQ9.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $690f0550d25c36bf$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $690f0550d25c36bf$var$MemoizedDataRoutes = $7pfQ9.memo($690f0550d25c36bf$var$DataRoutes2);
function $690f0550d25c36bf$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $690f0550d25c36bf$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $690f0550d25c36bf$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $7pfQ9.useRef();
    if (historyRef.current == null) historyRef.current = $690f0550d25c36bf$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7pfQ9.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7pfQ9.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7pfQ9.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7pfQ9.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $690f0550d25c36bf$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $690f0550d25c36bf$export$f5708dca728d7177($690f0550d25c36bf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    $690f0550d25c36bf$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397);
    let { pathname: locationPathname } = $690f0550d25c36bf$export$45d76561a5302f2b();
    let navigate = $690f0550d25c36bf$export$9770f232ac06a008();
    let path = $690f0550d25c36bf$var$resolveTo(to, $690f0550d25c36bf$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7pfQ9.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $690f0550d25c36bf$export$910ae8079b2c2852(props) {
    return $690f0550d25c36bf$export$a3be3530d8e40d0b(props.context);
}
function $690f0550d25c36bf$export$e7b0ac011bb776c6(props) {
    $690f0550d25c36bf$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $690f0550d25c36bf$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $690f0550d25c36bf$export$f5708dca728d7177(!$690f0550d25c36bf$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7pfQ9.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $690f0550d25c36bf$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $7pfQ9.useMemo(()=>{
        let trailingPathname = $690f0550d25c36bf$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $690f0550d25c36bf$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $690f0550d25c36bf$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $690f0550d25c36bf$export$5d3fca4a98652595($690f0550d25c36bf$export$16da398f5434bdec(children), location);
}
function $690f0550d25c36bf$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $7pfQ9.useContext($690f0550d25c36bf$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $7pfQ9.useContext($690f0550d25c36bf$export$315e3ffb01f217);
    let onError = $7pfQ9.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $690f0550d25c36bf$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$ResolveAwait, null, children));
}
var $690f0550d25c36bf$var$AwaitErrorBoundary = class extends $7pfQ9.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $690f0550d25c36bf$var$ResolveAwait({ children: children }) {
    let data2 = $690f0550d25c36bf$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, toRender);
}
function $690f0550d25c36bf$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $7pfQ9.Children.forEach(children, (element, index)=>{
        if (!$7pfQ9.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7pfQ9.Fragment) {
            routes.push.apply(routes, $690f0550d25c36bf$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $690f0550d25c36bf$export$f5708dca728d7177(element.type === $690f0550d25c36bf$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $690f0550d25c36bf$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $690f0550d25c36bf$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $690f0550d25c36bf$export$9b5b6d122dea0c88 = $690f0550d25c36bf$export$16da398f5434bdec;
function $690f0550d25c36bf$export$daf73786167a7f72(matches) {
    return $690f0550d25c36bf$var$_renderMatches(matches);
}
function $690f0550d25c36bf$var$useRouteComponentProps() {
    return {
        params: $690f0550d25c36bf$export$99eaa27ddbbb95ef(),
        loaderData: $690f0550d25c36bf$export$1448a5050d252c4d(),
        actionData: $690f0550d25c36bf$export$fdc00f3f26066d5e(),
        matches: $690f0550d25c36bf$export$2378eb7f5ff86053()
    };
}
function $690f0550d25c36bf$export$6c4f3826290c37af({ children: children }) {
    const props = $690f0550d25c36bf$var$useRouteComponentProps();
    return $7pfQ9.cloneElement(children, props);
}
function $690f0550d25c36bf$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $690f0550d25c36bf$var$useRouteComponentProps();
        return $7pfQ9.createElement(Component4, props);
    };
}
function $690f0550d25c36bf$var$useHydrateFallbackProps() {
    return {
        params: $690f0550d25c36bf$export$99eaa27ddbbb95ef(),
        loaderData: $690f0550d25c36bf$export$1448a5050d252c4d(),
        actionData: $690f0550d25c36bf$export$fdc00f3f26066d5e()
    };
}
function $690f0550d25c36bf$export$f8cff34f39c1932a({ children: children }) {
    const props = $690f0550d25c36bf$var$useHydrateFallbackProps();
    return $7pfQ9.cloneElement(children, props);
}
function $690f0550d25c36bf$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $690f0550d25c36bf$var$useHydrateFallbackProps();
        return $7pfQ9.createElement(HydrateFallback, props);
    };
}
function $690f0550d25c36bf$var$useErrorBoundaryProps() {
    return {
        params: $690f0550d25c36bf$export$99eaa27ddbbb95ef(),
        loaderData: $690f0550d25c36bf$export$1448a5050d252c4d(),
        actionData: $690f0550d25c36bf$export$fdc00f3f26066d5e(),
        error: $690f0550d25c36bf$export$ed527bf60f6e05f2()
    };
}
function $690f0550d25c36bf$export$e5afde5c4b6d747b({ children: children }) {
    const props = $690f0550d25c36bf$var$useErrorBoundaryProps();
    return $7pfQ9.cloneElement(children, props);
}
function $690f0550d25c36bf$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $690f0550d25c36bf$var$useErrorBoundaryProps();
        return $7pfQ9.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $690f0550d25c36bf$var$defaultMethod = "get";
var $690f0550d25c36bf$var$defaultEncType = "application/x-www-form-urlencoded";
function $690f0550d25c36bf$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $690f0550d25c36bf$var$isButtonElement(object) {
    return $690f0550d25c36bf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $690f0550d25c36bf$var$isFormElement(object) {
    return $690f0550d25c36bf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $690f0550d25c36bf$var$isInputElement(object) {
    return $690f0550d25c36bf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $690f0550d25c36bf$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $690f0550d25c36bf$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$690f0550d25c36bf$var$isModifiedEvent(event);
}
function $690f0550d25c36bf$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $690f0550d25c36bf$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $690f0550d25c36bf$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $690f0550d25c36bf$var$_formDataSupportsSubmitter = null;
function $690f0550d25c36bf$var$isFormDataSubmitterSupported() {
    if ($690f0550d25c36bf$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $690f0550d25c36bf$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $690f0550d25c36bf$var$_formDataSupportsSubmitter = true;
    }
    return $690f0550d25c36bf$var$_formDataSupportsSubmitter;
}
var $690f0550d25c36bf$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $690f0550d25c36bf$var$getFormEncType(encType) {
    if (encType != null && !$690f0550d25c36bf$var$supportedFormEncTypes.has(encType)) {
        $690f0550d25c36bf$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$690f0550d25c36bf$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $690f0550d25c36bf$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($690f0550d25c36bf$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $690f0550d25c36bf$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $690f0550d25c36bf$var$defaultMethod;
        encType = $690f0550d25c36bf$var$getFormEncType(target.getAttribute("enctype")) || $690f0550d25c36bf$var$defaultEncType;
        formData = new FormData(target);
    } else if ($690f0550d25c36bf$var$isButtonElement(target) || $690f0550d25c36bf$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $690f0550d25c36bf$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $690f0550d25c36bf$var$defaultMethod;
        encType = $690f0550d25c36bf$var$getFormEncType(target.getAttribute("formenctype")) || $690f0550d25c36bf$var$getFormEncType(form.getAttribute("enctype")) || $690f0550d25c36bf$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$690f0550d25c36bf$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($690f0550d25c36bf$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $690f0550d25c36bf$var$defaultMethod;
        action = null;
        encType = $690f0550d25c36bf$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $690f0550d25c36bf$var$HOLE = -1;
var $690f0550d25c36bf$var$NAN = -2;
var $690f0550d25c36bf$var$NEGATIVE_INFINITY = -3;
var $690f0550d25c36bf$var$NEGATIVE_ZERO = -4;
var $690f0550d25c36bf$var$NULL = -5;
var $690f0550d25c36bf$var$POSITIVE_INFINITY = -6;
var $690f0550d25c36bf$var$UNDEFINED = -7;
var $690f0550d25c36bf$var$TYPE_BIGINT = "B";
var $690f0550d25c36bf$var$TYPE_DATE = "D";
var $690f0550d25c36bf$var$TYPE_ERROR = "E";
var $690f0550d25c36bf$var$TYPE_MAP = "M";
var $690f0550d25c36bf$var$TYPE_NULL_OBJECT = "N";
var $690f0550d25c36bf$var$TYPE_PROMISE = "P";
var $690f0550d25c36bf$var$TYPE_REGEXP = "R";
var $690f0550d25c36bf$var$TYPE_SET = "S";
var $690f0550d25c36bf$var$TYPE_SYMBOL = "Y";
var $690f0550d25c36bf$var$TYPE_URL = "U";
var $690f0550d25c36bf$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $690f0550d25c36bf$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $690f0550d25c36bf$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $690f0550d25c36bf$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $690f0550d25c36bf$var$TIME_LIMIT_MS = 1;
var $690f0550d25c36bf$var$getNow = ()=>Date.now();
var $690f0550d25c36bf$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $690f0550d25c36bf$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $690f0550d25c36bf$var$UNDEFINED;
    if (input === null) return $690f0550d25c36bf$var$NULL;
    if (Number.isNaN(input)) return $690f0550d25c36bf$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $690f0550d25c36bf$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $690f0550d25c36bf$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $690f0550d25c36bf$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $690f0550d25c36bf$var$stringify.call(this, stack);
    return index;
}
async function $690f0550d25c36bf$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $690f0550d25c36bf$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $690f0550d25c36bf$var$UNDEFINED;
        if (value === null) return $690f0550d25c36bf$var$NULL;
        if (Number.isNaN(value)) return $690f0550d25c36bf$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $690f0550d25c36bf$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $690f0550d25c36bf$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $690f0550d25c36bf$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $690f0550d25c36bf$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $690f0550d25c36bf$var$TIME_LIMIT_MS) {
            await $690f0550d25c36bf$var$yieldToMain();
            lastYieldTime = $690f0550d25c36bf$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$690f0550d25c36bf$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$690f0550d25c36bf$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$690f0550d25c36bf$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $690f0550d25c36bf$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$690f0550d25c36bf$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$690f0550d25c36bf$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$690f0550d25c36bf$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$690f0550d25c36bf$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$690f0550d25c36bf$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$690f0550d25c36bf$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$690f0550d25c36bf$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$690f0550d25c36bf$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$690f0550d25c36bf$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$690f0550d25c36bf$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($690f0550d25c36bf$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $690f0550d25c36bf$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $690f0550d25c36bf$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $690f0550d25c36bf$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $690f0550d25c36bf$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $690f0550d25c36bf$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $690f0550d25c36bf$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $690f0550d25c36bf$var$hydrate.call(this, startIndex);
}
function $690f0550d25c36bf$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $690f0550d25c36bf$var$UNDEFINED:
                set(void 0);
                continue;
            case $690f0550d25c36bf$var$NULL:
                set(null);
                continue;
            case $690f0550d25c36bf$var$NAN:
                set(NaN);
                continue;
            case $690f0550d25c36bf$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $690f0550d25c36bf$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $690f0550d25c36bf$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $690f0550d25c36bf$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $690f0550d25c36bf$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $690f0550d25c36bf$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $690f0550d25c36bf$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $690f0550d25c36bf$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $690f0550d25c36bf$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $690f0550d25c36bf$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $690f0550d25c36bf$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $690f0550d25c36bf$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $690f0550d25c36bf$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $690f0550d25c36bf$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $690f0550d25c36bf$var$globalObj && $690f0550d25c36bf$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $690f0550d25c36bf$var$globalObj && typeof $690f0550d25c36bf$var$globalObj[errorType] === "function" ? new $690f0550d25c36bf$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $690f0550d25c36bf$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $690f0550d25c36bf$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $690f0550d25c36bf$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $690f0550d25c36bf$var$Deferred2();
    const reader = readable.pipeThrough($690f0550d25c36bf$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $690f0550d25c36bf$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $690f0550d25c36bf$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $690f0550d25c36bf$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $690f0550d25c36bf$var$unflatten.call(this, line)
    };
}
async function $690f0550d25c36bf$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $690f0550d25c36bf$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $690f0550d25c36bf$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $690f0550d25c36bf$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $690f0550d25c36bf$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $690f0550d25c36bf$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $690f0550d25c36bf$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $690f0550d25c36bf$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$690f0550d25c36bf$var$TYPE_PROMISE}${deferredId}:[["${$690f0550d25c36bf$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$690f0550d25c36bf$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$690f0550d25c36bf$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $690f0550d25c36bf$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$690f0550d25c36bf$var$TYPE_ERROR}${deferredId}:[["${$690f0550d25c36bf$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$690f0550d25c36bf$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$690f0550d25c36bf$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $690f0550d25c36bf$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $690f0550d25c36bf$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $690f0550d25c36bf$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $690f0550d25c36bf$export$4cf11838cdc2a8a8(html) {
    return html.replace($690f0550d25c36bf$var$ESCAPE_REGEX, (match)=>$690f0550d25c36bf$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $690f0550d25c36bf$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $690f0550d25c36bf$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $690f0550d25c36bf$var$SingleFetchNoResultError = class extends Error {
};
var $690f0550d25c36bf$export$ae9272e641ead836 = 202;
var $690f0550d25c36bf$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $690f0550d25c36bf$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $7pfQ9.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$690f0550d25c36bf$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, scriptTag, /* @__PURE__ */ $7pfQ9.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, scriptTag, /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Suspense, null, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $690f0550d25c36bf$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $690f0550d25c36bf$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $690f0550d25c36bf$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $690f0550d25c36bf$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $690f0550d25c36bf$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $690f0550d25c36bf$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $690f0550d25c36bf$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $690f0550d25c36bf$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $690f0550d25c36bf$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $690f0550d25c36bf$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $690f0550d25c36bf$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $690f0550d25c36bf$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($690f0550d25c36bf$export$3f1eb41d9a6a6a27(result.result) || $690f0550d25c36bf$export$972111febbeef05b(result.result) || $690f0550d25c36bf$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $690f0550d25c36bf$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $690f0550d25c36bf$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $690f0550d25c36bf$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $690f0550d25c36bf$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$690f0550d25c36bf$var$createDeferred2());
    let singleFetchDfd = $690f0550d25c36bf$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $690f0550d25c36bf$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $690f0550d25c36bf$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $690f0550d25c36bf$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $690f0550d25c36bf$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $690f0550d25c36bf$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $690f0550d25c36bf$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $690f0550d25c36bf$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $690f0550d25c36bf$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $690f0550d25c36bf$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $690f0550d25c36bf$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $690f0550d25c36bf$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$690f0550d25c36bf$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$690f0550d25c36bf$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $690f0550d25c36bf$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $690f0550d25c36bf$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $690f0550d25c36bf$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $690f0550d25c36bf$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $690f0550d25c36bf$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $690f0550d25c36bf$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($690f0550d25c36bf$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $690f0550d25c36bf$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $690f0550d25c36bf$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($690f0550d25c36bf$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$690f0550d25c36bf$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $690f0550d25c36bf$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $690f0550d25c36bf$export$4023ad4ecd4126a2(body, global) {
    return $690f0550d25c36bf$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $690f0550d25c36bf$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $690f0550d25c36bf$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$690f0550d25c36bf$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $690f0550d25c36bf$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $690f0550d25c36bf$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $690f0550d25c36bf$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $690f0550d25c36bf$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $690f0550d25c36bf$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $690f0550d25c36bf$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $690f0550d25c36bf$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $690f0550d25c36bf$var$getModuleLinkHrefs(matches, manifest);
    return $690f0550d25c36bf$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $690f0550d25c36bf$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $690f0550d25c36bf$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $690f0550d25c36bf$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($690f0550d25c36bf$var$prefetchStyleLink));
}
async function $690f0550d25c36bf$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$690f0550d25c36bf$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$690f0550d25c36bf$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$690f0550d25c36bf$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($690f0550d25c36bf$var$prefetchStyleLink));
}
async function $690f0550d25c36bf$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $690f0550d25c36bf$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $690f0550d25c36bf$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $690f0550d25c36bf$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $690f0550d25c36bf$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $690f0550d25c36bf$var$dedupeLinkDescriptors(links.flat(1).filter($690f0550d25c36bf$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $690f0550d25c36bf$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $690f0550d25c36bf$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $690f0550d25c36bf$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $690f0550d25c36bf$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $690f0550d25c36bf$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $690f0550d25c36bf$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$690f0550d25c36bf$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($690f0550d25c36bf$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $690f0550d25c36bf$var$_isPreloadSupported;
function $690f0550d25c36bf$var$isPreloadSupported() {
    if ($690f0550d25c36bf$var$_isPreloadSupported !== void 0) return $690f0550d25c36bf$var$_isPreloadSupported;
    let el = document.createElement("link");
    $690f0550d25c36bf$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $690f0550d25c36bf$var$_isPreloadSupported;
}
function $690f0550d25c36bf$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $690f0550d25c36bf$export$945fecf35a8ef089 ? /* @__PURE__ */ $7pfQ9.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $690f0550d25c36bf$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $690f0550d25c36bf$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $690f0550d25c36bf$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $690f0550d25c36bf$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$RemixRootDefaultErrorBoundary, {
            error: $690f0550d25c36bf$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $7pfQ9.createElement(routeModule.Layout, null, /* @__PURE__ */ $7pfQ9.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $7pfQ9.createElement(routeModule.Layout, null, /* @__PURE__ */ $7pfQ9.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $7pfQ9.createElement(routeModule.Layout, null, /* @__PURE__ */ $7pfQ9.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $690f0550d25c36bf$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $690f0550d25c36bf$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $690f0550d25c36bf$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$690f0550d25c36bf$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $690f0550d25c36bf$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $690f0550d25c36bf$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $690f0550d25c36bf$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $690f0550d25c36bf$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $690f0550d25c36bf$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $690f0550d25c36bf$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $690f0550d25c36bf$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $690f0550d25c36bf$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $690f0550d25c36bf$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $690f0550d25c36bf$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $690f0550d25c36bf$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $690f0550d25c36bf$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $690f0550d25c36bf$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$690f0550d25c36bf$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $690f0550d25c36bf$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $690f0550d25c36bf$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $690f0550d25c36bf$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $690f0550d25c36bf$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $690f0550d25c36bf$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $690f0550d25c36bf$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $690f0550d25c36bf$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $690f0550d25c36bf$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $690f0550d25c36bf$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $690f0550d25c36bf$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $690f0550d25c36bf$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $690f0550d25c36bf$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $690f0550d25c36bf$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $690f0550d25c36bf$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $690f0550d25c36bf$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $690f0550d25c36bf$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $690f0550d25c36bf$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $690f0550d25c36bf$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $690f0550d25c36bf$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $690f0550d25c36bf$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $690f0550d25c36bf$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $690f0550d25c36bf$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $690f0550d25c36bf$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $690f0550d25c36bf$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $690f0550d25c36bf$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $690f0550d25c36bf$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $690f0550d25c36bf$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $690f0550d25c36bf$var$nextPaths = /* @__PURE__ */ new Set();
var $690f0550d25c36bf$var$discoveredPathsMaxSize = 1e3;
var $690f0550d25c36bf$var$discoveredPaths = /* @__PURE__ */ new Set();
var $690f0550d25c36bf$export$b5915cf27fa06b9f = 7680;
function $690f0550d25c36bf$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $690f0550d25c36bf$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $690f0550d25c36bf$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $690f0550d25c36bf$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$690f0550d25c36bf$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($690f0550d25c36bf$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $690f0550d25c36bf$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $690f0550d25c36bf$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $690f0550d25c36bf$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $7pfQ9.useEffect(()=>{
        if (!$690f0550d25c36bf$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$690f0550d25c36bf$var$discoveredPaths.has(pathname)) $690f0550d25c36bf$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($690f0550d25c36bf$var$nextPaths.keys()).filter((path)=>{
                if ($690f0550d25c36bf$var$discoveredPaths.has(path)) {
                    $690f0550d25c36bf$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $690f0550d25c36bf$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $690f0550d25c36bf$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $690f0550d25c36bf$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $690f0550d25c36bf$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $690f0550d25c36bf$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $690f0550d25c36bf$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($690f0550d25c36bf$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $690f0550d25c36bf$export$b5915cf27fa06b9f) {
        $690f0550d25c36bf$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($690f0550d25c36bf$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($690f0550d25c36bf$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($690f0550d25c36bf$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$690f0550d25c36bf$var$addToFifoQueue(p, $690f0550d25c36bf$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $690f0550d25c36bf$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $690f0550d25c36bf$var$addToFifoQueue(path, queue) {
    if (queue.size >= $690f0550d25c36bf$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $690f0550d25c36bf$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $690f0550d25c36bf$var$useDataRouterContext2() {
    let context = $7pfQ9.useContext($690f0550d25c36bf$export$2eeee58951ff3c1c);
    $690f0550d25c36bf$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $690f0550d25c36bf$var$useDataRouterStateContext() {
    let context = $7pfQ9.useContext($690f0550d25c36bf$export$315e3ffb01f217);
    $690f0550d25c36bf$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $690f0550d25c36bf$export$208d6a3bc3aa62bd = $7pfQ9.createContext(void 0);
$690f0550d25c36bf$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $690f0550d25c36bf$var$useFrameworkContext() {
    let context = $7pfQ9.useContext($690f0550d25c36bf$export$208d6a3bc3aa62bd);
    $690f0550d25c36bf$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $690f0550d25c36bf$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $7pfQ9.useContext($690f0550d25c36bf$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $7pfQ9.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $7pfQ9.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $7pfQ9.useRef(null);
    $7pfQ9.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $7pfQ9.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $690f0550d25c36bf$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $690f0550d25c36bf$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $690f0550d25c36bf$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $690f0550d25c36bf$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $690f0550d25c36bf$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $690f0550d25c36bf$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $690f0550d25c36bf$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$690f0550d25c36bf$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $690f0550d25c36bf$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $690f0550d25c36bf$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $690f0550d25c36bf$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $690f0550d25c36bf$var$useDataRouterStateContext();
    let matches = $690f0550d25c36bf$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $7pfQ9.useMemo(()=>$690f0550d25c36bf$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $7pfQ9.createElement("style", {
        [$690f0550d25c36bf$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $7pfQ9.createElement("link", {
        [$690f0550d25c36bf$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$690f0550d25c36bf$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $7pfQ9.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $690f0550d25c36bf$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $690f0550d25c36bf$var$useIsRSCRouterContext();
    let { router: router } = $690f0550d25c36bf$var$useDataRouterContext2();
    let matches = $7pfQ9.useMemo(()=>$690f0550d25c36bf$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (rsc) return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $690f0550d25c36bf$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $690f0550d25c36bf$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $7pfQ9.useState([]);
    $7pfQ9.useEffect(()=>{
        let interrupted = false;
        $690f0550d25c36bf$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $690f0550d25c36bf$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    let { future: future } = $690f0550d25c36bf$var$useFrameworkContext();
    let { basename: basename } = $690f0550d25c36bf$var$useDataRouterContext2();
    let dataHrefs = $7pfQ9.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $690f0550d25c36bf$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7pfQ9.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $690f0550d25c36bf$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $690f0550d25c36bf$var$useFrameworkContext();
    let { basename: basename } = $690f0550d25c36bf$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $690f0550d25c36bf$var$useDataRouterStateContext();
    let newMatchesForData = $7pfQ9.useMemo(()=>$690f0550d25c36bf$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $7pfQ9.useMemo(()=>$690f0550d25c36bf$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $7pfQ9.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $690f0550d25c36bf$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $7pfQ9.useMemo(()=>$690f0550d25c36bf$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $690f0550d25c36bf$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7pfQ9.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $7pfQ9.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $7pfQ9.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $690f0550d25c36bf$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $690f0550d25c36bf$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $690f0550d25c36bf$var$useDataRouterStateContext();
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    let _matches = $690f0550d25c36bf$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$690f0550d25c36bf$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $7pfQ9.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $7pfQ9.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $7pfQ9.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $7pfQ9.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $690f0550d25c36bf$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $7pfQ9.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $690f0550d25c36bf$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $690f0550d25c36bf$var$isHydrated = false;
function $690f0550d25c36bf$export$3be068dde909e563() {
    $690f0550d25c36bf$var$isHydrated = true;
}
function $690f0550d25c36bf$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $690f0550d25c36bf$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $690f0550d25c36bf$var$useDataRouterContext2();
    let { matches: routerMatches } = $690f0550d25c36bf$var$useDataRouterStateContext();
    let isRSCRouterContext = $690f0550d25c36bf$var$useIsRSCRouterContext();
    let enableFogOfWar = $690f0550d25c36bf$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $690f0550d25c36bf$var$getActiveMatches(routerMatches, null, isSpaMode);
    $7pfQ9.useEffect(()=>{
        $690f0550d25c36bf$export$3be068dde909e563();
    }, []);
    let initialScripts = $7pfQ9.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $690f0550d25c36bf$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($690f0550d25c36bf$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $7pfQ9.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $690f0550d25c36bf$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($690f0550d25c36bf$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $690f0550d25c36bf$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $690f0550d25c36bf$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $7pfQ9.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $7pfQ9.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $7pfQ9.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $7pfQ9.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $690f0550d25c36bf$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $690f0550d25c36bf$export$32e57f52df4b6e34 = class extends $7pfQ9.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $690f0550d25c36bf$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $7pfQ9.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($690f0550d25c36bf$export$972111febbeef05b(error)) return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $7pfQ9.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $690f0550d25c36bf$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $7pfQ9.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $7pfQ9.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $690f0550d25c36bf$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $690f0550d25c36bf$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $7pfQ9.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $7pfQ9.createElement("head", null, /* @__PURE__ */ $7pfQ9.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $7pfQ9.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $7pfQ9.createElement("title", null, title)), /* @__PURE__ */ $7pfQ9.createElement("body", null, /* @__PURE__ */ $7pfQ9.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$ff0bf87698939488, null) : null)));
}
var $690f0550d25c36bf$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($690f0550d25c36bf$var$isBrowser2) window.__reactRouterVersion = "7.15.1";
} catch (e) {}
function $690f0550d25c36bf$export$1f3f55432a00e06d(routes, opts) {
    return $690f0550d25c36bf$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $690f0550d25c36bf$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $690f0550d25c36bf$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $690f0550d25c36bf$export$9269a41d8c4635e,
        hydrationRouteProperties: $690f0550d25c36bf$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $690f0550d25c36bf$export$1ba7ed8a3a7b3765(routes, opts) {
    return $690f0550d25c36bf$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $690f0550d25c36bf$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $690f0550d25c36bf$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $690f0550d25c36bf$export$9269a41d8c4635e,
        hydrationRouteProperties: $690f0550d25c36bf$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $690f0550d25c36bf$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $690f0550d25c36bf$var$deserializeErrors(state.errors)
    };
    return state;
}
function $690f0550d25c36bf$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $690f0550d25c36bf$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $690f0550d25c36bf$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7pfQ9.useRef();
    if (historyRef.current == null) historyRef.current = $690f0550d25c36bf$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7pfQ9.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7pfQ9.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7pfQ9.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7pfQ9.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $690f0550d25c36bf$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7pfQ9.useRef();
    if (historyRef.current == null) historyRef.current = $690f0550d25c36bf$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7pfQ9.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7pfQ9.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7pfQ9.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7pfQ9.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $690f0550d25c36bf$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $7pfQ9.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7pfQ9.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7pfQ9.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7pfQ9.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$690f0550d25c36bf$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $690f0550d25c36bf$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $690f0550d25c36bf$export$a6c7ac8248d6e38a = $7pfQ9.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $690f0550d25c36bf$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $690f0550d25c36bf$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $690f0550d25c36bf$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $690f0550d25c36bf$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $690f0550d25c36bf$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $690f0550d25c36bf$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $690f0550d25c36bf$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $7pfQ9.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $690f0550d25c36bf$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, link, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$690f0550d25c36bf$export$a6c7ac8248d6e38a.displayName = "Link";
var $690f0550d25c36bf$export$b0d92dbee9b5b60d = $7pfQ9.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $690f0550d25c36bf$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    let routerState = $7pfQ9.useContext($690f0550d25c36bf$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $690f0550d25c36bf$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $690f0550d25c36bf$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$690f0550d25c36bf$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $690f0550d25c36bf$export$a7fed597f4b8afd8 = $7pfQ9.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $690f0550d25c36bf$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let submit = $690f0550d25c36bf$export$47c85c6e3a081d3();
    let formAction = $690f0550d25c36bf$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $690f0550d25c36bf$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $7pfQ9.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $7pfQ9.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$690f0550d25c36bf$export$a7fed597f4b8afd8.displayName = "Form";
function $690f0550d25c36bf$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $7pfQ9.useContext($690f0550d25c36bf$export$208d6a3bc3aa62bd);
    let { basename: basename } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    let matches = $690f0550d25c36bf$export$2378eb7f5ff86053();
    $690f0550d25c36bf$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $7pfQ9.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $690f0550d25c36bf$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $7pfQ9.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$690f0550d25c36bf$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $690f0550d25c36bf$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$690f0550d25c36bf$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$690f0550d25c36bf$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $690f0550d25c36bf$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $690f0550d25c36bf$var$useDataRouterContext3(hookName) {
    let ctx = $7pfQ9.useContext($690f0550d25c36bf$export$2eeee58951ff3c1c);
    $690f0550d25c36bf$export$f5708dca728d7177(ctx, $690f0550d25c36bf$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $690f0550d25c36bf$var$useDataRouterState2(hookName) {
    let state = $7pfQ9.useContext($690f0550d25c36bf$export$315e3ffb01f217);
    $690f0550d25c36bf$export$f5708dca728d7177(state, $690f0550d25c36bf$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $690f0550d25c36bf$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $690f0550d25c36bf$export$9770f232ac06a008();
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    let path = $690f0550d25c36bf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $7pfQ9.useCallback((event)=>{
        if ($690f0550d25c36bf$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $690f0550d25c36bf$export$fe53371bee54353d(location) === $690f0550d25c36bf$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $7pfQ9.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $690f0550d25c36bf$export$f1a78c17382fe22a(defaultInit) {
    $690f0550d25c36bf$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $7pfQ9.useRef($690f0550d25c36bf$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7pfQ9.useRef(false);
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    let searchParams = $7pfQ9.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $690f0550d25c36bf$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $690f0550d25c36bf$export$9770f232ac06a008();
    let setSearchParams = $7pfQ9.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $690f0550d25c36bf$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $690f0550d25c36bf$var$fetcherId = 0;
var $690f0550d25c36bf$var$getUniqueFetcherId = ()=>`__${String(++$690f0550d25c36bf$var$fetcherId)}__`;
function $690f0550d25c36bf$export$47c85c6e3a081d3() {
    let { router: router } = $690f0550d25c36bf$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let currentRouteId = $690f0550d25c36bf$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $7pfQ9.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $690f0550d25c36bf$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $690f0550d25c36bf$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $690f0550d25c36bf$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let routeContext = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397);
    $690f0550d25c36bf$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$690f0550d25c36bf$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $690f0550d25c36bf$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $690f0550d25c36bf$export$fe53371bee54353d(path);
}
function $690f0550d25c36bf$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $690f0550d25c36bf$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $690f0550d25c36bf$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $7pfQ9.useContext($690f0550d25c36bf$export$cb3f1df1bef00a39);
    let route = $7pfQ9.useContext($690f0550d25c36bf$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $690f0550d25c36bf$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $690f0550d25c36bf$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $690f0550d25c36bf$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $7pfQ9.useId();
    let [fetcherKey, setFetcherKey] = $7pfQ9.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $7pfQ9.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $7pfQ9.useCallback(async (href, opts)=>{
        $690f0550d25c36bf$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $690f0550d25c36bf$export$47c85c6e3a081d3();
    let submit = $7pfQ9.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $7pfQ9.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $7pfQ9.useMemo(()=>{
        let FetcherForm2 = $7pfQ9.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $690f0550d25c36bf$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7pfQ9.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $690f0550d25c36bf$export$fa996778a3a31087() {
    let state = $690f0550d25c36bf$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $7pfQ9.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $690f0550d25c36bf$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $690f0550d25c36bf$var$savedScrollPositions = {};
function $690f0550d25c36bf$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $690f0550d25c36bf$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $690f0550d25c36bf$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $690f0550d25c36bf$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $690f0550d25c36bf$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $7pfQ9.useContext($690f0550d25c36bf$export$3044ab7fdabeaee6);
    let location = $690f0550d25c36bf$export$45d76561a5302f2b();
    let matches = $690f0550d25c36bf$export$2378eb7f5ff86053();
    let navigation = $690f0550d25c36bf$export$d0fd4b7106de2769();
    $7pfQ9.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $690f0550d25c36bf$var$usePageHide($7pfQ9.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $690f0550d25c36bf$var$getScrollRestorationKey(location, matches, basename, getKey);
            $690f0550d25c36bf$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $690f0550d25c36bf$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($690f0550d25c36bf$var$savedScrollPositions));
        } catch (error) {
            $690f0550d25c36bf$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $7pfQ9.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $690f0550d25c36bf$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $690f0550d25c36bf$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $7pfQ9.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($690f0550d25c36bf$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$690f0550d25c36bf$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $7pfQ9.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $690f0550d25c36bf$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $690f0550d25c36bf$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7pfQ9.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $690f0550d25c36bf$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7pfQ9.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $690f0550d25c36bf$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $690f0550d25c36bf$export$b273b3273281a049(when);
    $7pfQ9.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7pfQ9.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $690f0550d25c36bf$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $7pfQ9.useContext($690f0550d25c36bf$export$3681f408decb40d1);
    $690f0550d25c36bf$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $690f0550d25c36bf$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $690f0550d25c36bf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $690f0550d25c36bf$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $690f0550d25c36bf$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $690f0550d25c36bf$export$81336c211d5ff295(path.pathname, nextPath) != null || $690f0550d25c36bf$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $690f0550d25c36bf$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $690f0550d25c36bf$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $690f0550d25c36bf$var$getStatelessNavigator();
    return /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $690f0550d25c36bf$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $690f0550d25c36bf$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $690f0550d25c36bf$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $690f0550d25c36bf$var$serializeErrors(context.errors)
        };
        let json = $690f0550d25c36bf$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $7pfQ9.createElement($690f0550d25c36bf$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $7pfQ9.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $690f0550d25c36bf$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($690f0550d25c36bf$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $690f0550d25c36bf$var$getStatelessNavigator() {
    return {
        createHref: $690f0550d25c36bf$var$createHref,
        encodeLocation: $690f0550d25c36bf$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $690f0550d25c36bf$export$69163f0b72ec60d9(routes, opts) {
    return $690f0550d25c36bf$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $690f0550d25c36bf$export$9269a41d8c4635e
    });
}
function $690f0550d25c36bf$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $690f0550d25c36bf$export$87cb1a9238dc3fba(routes, $690f0550d25c36bf$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $690f0550d25c36bf$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $690f0550d25c36bf$var$createHref,
        encodeLocation: $690f0550d25c36bf$var$encodeLocation,
        getFetcher () {
            return $690f0550d25c36bf$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $690f0550d25c36bf$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $690f0550d25c36bf$var$createHref(to) {
    return typeof to === "string" ? to : $690f0550d25c36bf$export$fe53371bee54353d(to);
}
function $690f0550d25c36bf$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $690f0550d25c36bf$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $690f0550d25c36bf$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $690f0550d25c36bf$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;




var $7pfQ9 = parcelRequire("7pfQ9");


const $8f4d515c511e3ad2$var$isChristmas = false;
const $8f4d515c511e3ad2$var$TopGlow = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
        className: "spin-slow",
        css: {
            zIndex: -1,
            position: "fixed",
            left: "15%",
            /* keep translate here so rotation happens around the element center */ transform: "translate(-50%, 0px)",
            transformOrigin: "55% 50%",
            top: -135,
            background: "conic-gradient(from 242deg at 50% 50%, #66ffd1 24.239592254161835deg, #00c853 270.7325005531311deg, #00f584 360deg)",
            ...$8f4d515c511e3ad2$var$isChristmas && {
                background: "conic-gradient(from 242deg at 50% 50%, #99ffe0 24.239592254161835deg, #00e676 270.7325005531311deg, #00f584 360deg)"
            },
            //
            filter: "blur(80px) brightness(1.1)",
            width: 320,
            height: 270
        }
    });
var $8f4d515c511e3ad2$export$2e2bcd8739ae039 = $8f4d515c511e3ad2$var$TopGlow;


// import WavesBg from "./WavesBg"
const $d357f58ff1306473$var$Layout = ({ children: children })=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
        css: {
            fontWeight: 400,
            color: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            maxWidth: 480,
            width: "100%",
            height: "100%",
            minHeight: 0,
            overflow: "hidden",
            alignItems: "center",
            margin: "0 auto",
            boxSizing: "border-box"
        },
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $8f4d515c511e3ad2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
                css: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    gap: 24,
                    flex: 1,
                    minHeight: 0,
                    width: "100%",
                    padding: "16px 24px 24px 24px"
                },
                children: children
            })
        ]
    });
var $d357f58ff1306473$export$2e2bcd8739ae039 = $d357f58ff1306473$var$Layout;




// https://css-loaders.com/spinner/

const $5c19c940e9865a1c$var$Spinner = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
        css: {
            width: 40,
            aspectRatio: 1,
            borderRadius: "50%",
            background: "radial-gradient(farthest-side,#a4faff 94%,#0000) top/8px 8px no-repeat,\n    conic-gradient(#0000 30%,#a4faff)",
            mask: "radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0)",
            animation: "l13 1s infinite linear",
            "@keyframes l13": {
                "100%": {
                    transform: "rotate(1turn)"
                }
            }
        }
    });
var $5c19c940e9865a1c$export$2e2bcd8739ae039 = $5c19c940e9865a1c$var$Spinner;


const $f0774b9dfd5fb980$var$Loading = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $d357f58ff1306473$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
            css: {
                borderRadius: 8,
                background: "rgba(0, 0, 0, 0.20)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                color: "gray",
                fontSize: 16,
                borderRadius: 8,
                width: 320,
                height: 600,
                gap: 24
            },
            children: [
                /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $5c19c940e9865a1c$export$2e2bcd8739ae039), {}),
                "Loading..."
            ]
        })
    });
var $f0774b9dfd5fb980$export$2e2bcd8739ae039 = $f0774b9dfd5fb980$var$Loading;




var $7pfQ9 = parcelRequire("7pfQ9");
// import ProcessingAnimation from "../Processing/ProcessingAnimation"
const $7d324f2ffc1020f7$var$Preview = ({ videoUrl: videoUrl, onPreviewReadyChange: onPreviewReadyChange })=>{
    const previewSrc = videoUrl;
    (0, $7pfQ9.useEffect)(()=>{
        onPreviewReadyChange?.(false);
    }, [
        previewSrc,
        onPreviewReadyChange
    ]);
    const handlePreviewReady = ()=>{
        onPreviewReadyChange?.(true);
    };
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
        css: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            flex: "1 1 auto",
            minHeight: 0
        },
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
            css: {
                position: "relative",
                borderRadius: 8,
                background: "rgba(0, 0, 0, 0.20)",
                backdropFilter: "blur(10px)",
                boxShadow: "0px 0px 16px 0px #000",
                height: "100%",
                width: "100%",
                color: "gray",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                minHeight: 0
            },
            children: !previewSrc ? // <ProcessingAnimation />
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
                children: "Processing..."
            }) : /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("video", {
                width: "100%",
                controls: true,
                autoPlay: false,
                playsInline: true,
                preload: "metadata",
                src: previewSrc,
                onLoadedMetadata: handlePreviewReady,
                onCanPlay: handlePreviewReady,
                onLoadedData: handlePreviewReady,
                onError: ()=>onPreviewReadyChange?.(false),
                css: {
                    borderRadius: 8,
                    objectFit: "contain",
                    height: "100%",
                    maxHeight: "100%"
                },
                children: "Your browser does not support the video tag."
            }, previewSrc)
        })
    });
};
var $7d324f2ffc1020f7$export$2e2bcd8739ae039 = $7d324f2ffc1020f7$var$Preview;





const $c6f3eebe3403b5cb$var$Icon_download = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("svg", {
        width: 22,
        height: 24,
        viewBox: "0 0 22 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 5H4C1.79086 5 0 6.79086 0 9V20C0 22.2091 1.79086 24 4 24H18C20.2091 24 22 22.2091 22 20V9C22 6.79086 20.2091 5 18 5H14V7H18C19.1046 7 20 7.89543 20 9V20C20 21.1046 19.1046 22 18 22H4C2.89543 22 2 21.1046 2 20V9C2 7.89543 2.89543 7 4 7H8V5Z",
                fill: "currentColor",
                fillOpacity: 0.6
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                d: "M7 13L11 17M11 17V1M11 17L15 13",
                stroke: "currentColor",
                // strokeOpacity={0.85}
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $c6f3eebe3403b5cb$export$2e2bcd8739ae039 = $c6f3eebe3403b5cb$var$Icon_download;



const $4fb2a739aaca8fcf$var$PRIMARY_COLOR = "#3004C7";
const $4fb2a739aaca8fcf$var$FOCUS_RING_COLOR = "rgba(48, 4, 199, 0.45)";
const $4fb2a739aaca8fcf$var$FOCUS_RING_VISIBLE_COLOR = "rgba(48, 4, 199, 0.65)";
const $4fb2a739aaca8fcf$var$ActionButton = ({ label: label, onClick: onClick, isCaching: isCaching, disabled: disabled })=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("button", {
        onClick: ()=>{
            if (!disabled) onClick();
        },
        tabIndex: 0,
        disabled: disabled,
        css: {
            userSelect: "none",
            display: "flex",
            minHeight: 48,
            width: "100%",
            alignItems: "center",
            gap: 8,
            justifyContent: "center",
            cursor: disabled ? "not-allowed" : "pointer",
            borderRadius: 32,
            border: 0,
            outline: "none",
            transition: "transform 150ms ease, box-shadow 150ms ease, filter 150ms ease, opacity 150ms ease, background 150ms ease",
            backgroundColor: $4fb2a739aaca8fcf$var$PRIMARY_COLOR,
            opacity: disabled ? 0.6 : 1,
            "&:focus": {
                outline: "2px solid rgba(255, 255, 255, 0.72)",
                outlineOffset: 3,
                boxShadow: `0 0 0 5px ${$4fb2a739aaca8fcf$var$FOCUS_RING_COLOR}`
            },
            // keyboard focus visible
            "&:focus-visible": {
                outline: "3px solid rgba(255, 255, 255, 0.92)",
                outlineOffset: 3,
                boxShadow: `0 0 0 7px ${$4fb2a739aaca8fcf$var$FOCUS_RING_VISIBLE_COLOR}`
            },
            // Added hover state
            "&:hover": disabled ? {} : {
                filter: "brightness(1.08)"
            },
            // pointer active (pressed) visual
            "&:active": disabled ? {} : {
                transform: "translateY(1px) scale(0.99)",
                boxShadow: "0px -1px 0px 0px rgba(0, 0, 0, 0.20) inset",
                filter: "brightness(0.95)",
                opacity: 0.9
            },
            color: "#fff",
            textAlign: "center",
            textShadow: "0px 4px 4px rgba(0, 0, 0, 0.16)",
            fontSize: 18,
            fontWeight: 600
        },
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $c6f3eebe3403b5cb$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
                css: {
                    alignSelf: "stretch",
                    margin: "auto 0"
                },
                children: label
            }),
            isCaching && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $5c19c940e9865a1c$export$2e2bcd8739ae039), {})
        ]
    });
var $4fb2a739aaca8fcf$export$2e2bcd8739ae039 = $4fb2a739aaca8fcf$var$ActionButton;


// import TypingEffect from "./pages/VideoShare/TypingEffect"

const $ad547a3e175225db$var$Title = ({ title: title })=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("h1", {
        css: {
            color: "white",
            width: "100%",
            fontSize: 30,
            minHeight: 29,
            fontWeight: 700,
            textAlign: "center",
            alignSelf: "start",
            margin: 0,
            whiteSpace: `pre-line`
        },
        children: title
    });
var $ad547a3e175225db$export$2e2bcd8739ae039 = $ad547a3e175225db$var$Title;


const $7b52c13f12b5f4d4$var$VideoShare = ({ shareVideo: shareVideo, isCaching: isCaching, isDownloadDisabled: isDownloadDisabled })=>{
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
        css: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $ad547a3e175225db$export$2e2bcd8739ae039), {
                title: "Your Video is Ready"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
                css: {
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: 24
                },
                children: [
                    /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
                        css: {
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            gap: 12
                        },
                        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("span", {
                            css: {
                                margin: 0,
                                textAlign: "center",
                                fontSize: 16,
                                fontWeight: 500,
                                lineHeight: 1.4,
                                fontFamily: "Arial",
                                color: "#d3dded"
                            },
                            children: "Share your #Hologram"
                        })
                    }),
                    /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $4fb2a739aaca8fcf$export$2e2bcd8739ae039), {
                        label: "Download Video",
                        onClick: shareVideo,
                        isCaching: isCaching,
                        disabled: isDownloadDisabled
                    })
                ]
            })
        ]
    });
};
var $7b52c13f12b5f4d4$export$2e2bcd8739ae039 = $7b52c13f12b5f4d4$var$VideoShare;




// import DesertAnimation from "./DesertAnimation"
const $12877f5c77f60f70$var$Empty = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
        css: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 16,
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $ad547a3e175225db$export$2e2bcd8739ae039), {
                title: "Nothing to download"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("p", {
                css: {
                    margin: 0,
                    color: "#F2F3F5",
                    fontSize: 17,
                    textAlign: "center"
                },
                children: "Scan a QR code to get the link."
            })
        ]
    });
var $12877f5c77f60f70$export$2e2bcd8739ae039 = $12877f5c77f60f70$var$Empty;





const $34713ed227684cb4$var$Processing = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
        css: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $5c19c940e9865a1c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $ad547a3e175225db$export$2e2bcd8739ae039), {
                title: "Processing video..."
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("p", {
                css: {
                    margin: 0,
                    color: "#F2F3F5",
                    fontSize: 17,
                    textAlign: "center"
                },
                children: "We promise it\u2019s worth the wait!"
            })
        ]
    });
var $34713ed227684cb4$export$2e2bcd8739ae039 = $34713ed227684cb4$var$Processing;


const $f3ed699629d9b0ca$export$f9107b66120eb036 = ()=>{
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `HYPERVSN_HOLOBOOTH_${hours}-${minutes}.mp4`;
};


const $3acbb378139a800f$export$a26c6e4ae30395cf = async (cachedBlob, videoUrl)=>{
    try {
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.download = (0, $f3ed699629d9b0ca$export$f9107b66120eb036)();
        let objectUrl = null;
        if (cachedBlob) {
            objectUrl = window.URL.createObjectURL(cachedBlob);
            anchor.href = objectUrl;
        } else if (videoUrl) anchor.href = videoUrl;
        else throw new Error("No video source available for download");
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
        console.error("Error downloading video:", error);
    }
};



async function $67e77fe9cca1ad68$export$6436779be3fc19da(urlHash, cachedBlob = null) {
    const videoUrl = `https://holobooth.hypervsn.com/video/${urlHash}.mp4`;
    try {
        const isAndroid = /Android/.test(navigator.userAgent);
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        // If navigator.share not available -> fallback to download
        if (!navigator.share) {
            console.log("\u26A0\uFE0F Share not supported - downloading instead");
            await (0, $3acbb378139a800f$export$a26c6e4ae30395cf)(cachedBlob, videoUrl);
            return;
        }
        // If Android: download first, then continue to share
        if (isAndroid) {
            console.log("Android device detected - downloading before share");
            await (0, $3acbb378139a800f$export$a26c6e4ae30395cf)(cachedBlob, videoUrl);
        // continue to attempt navigator.share after download
        } else if (!isIOS) {
            // Non-iOS and non-Android devices fallback to download
            console.log("Not an iOS/Android device - downloading instead");
            await (0, $3acbb378139a800f$export$a26c6e4ae30395cf)(cachedBlob, videoUrl);
            return;
        }
        let blob;
        if (cachedBlob) blob = cachedBlob;
        else {
            const response = await fetch(videoUrl);
            blob = await response.blob();
        }
        const file = new File([
            blob
        ], (0, $f3ed699629d9b0ca$export$f9107b66120eb036)(), {
            type: "video/mp4"
        });
        console.log("Open Share Window");
        await navigator.share({
            title: "My HYPERVSN Experience",
            text: "Check out my HYPERVSN holographic experience!",
            files: [
                file
            ]
        });
    } catch (error) {
        if (error?.name === "AbortError" || (error?.message || "").includes("canceled")) {
            console.log("\uD83D\uDFE1 Share canceled");
            return;
        }
        console.error("Error sharing:", error);
        await (0, $3acbb378139a800f$export$a26c6e4ae30395cf)(cachedBlob, videoUrl);
    }
}



var $7pfQ9 = parcelRequire("7pfQ9");

const $81c075d4e387c3b2$var$VIDEO_STATE = {
    MISSING_HASH: "missing_hash",
    CHECKING: "checking",
    PROCESSING: "processing",
    READY: "ready"
};
const $81c075d4e387c3b2$var$initialState = {
    status: $81c075d4e387c3b2$var$VIDEO_STATE.CHECKING,
    cachedVideoBlob: null,
    isCaching: false
};
function $81c075d4e387c3b2$var$videoReducer(state, action) {
    switch(action.type){
        case "HASH_MISSING":
            return {
                status: $81c075d4e387c3b2$var$VIDEO_STATE.MISSING_HASH,
                cachedVideoBlob: null,
                isCaching: false
            };
        case "HASH_CHANGED":
            return {
                status: $81c075d4e387c3b2$var$VIDEO_STATE.CHECKING,
                cachedVideoBlob: null,
                isCaching: false
            };
        case "VIDEO_READY":
            return {
                ...state,
                status: $81c075d4e387c3b2$var$VIDEO_STATE.READY,
                cachedVideoBlob: action.blob,
                isCaching: false
            };
        case "VIDEO_PENDING":
            return {
                ...state,
                status: $81c075d4e387c3b2$var$VIDEO_STATE.PROCESSING
            };
        case "CACHE_STARTED":
            return {
                ...state,
                cachedVideoBlob: null,
                isCaching: true
            };
        default:
            return state;
    }
}
async function $81c075d4e387c3b2$var$fetchVideoBlob(videoUrl, { signal: signal } = {}) {
    const response = await fetch(videoUrl, {
        signal: signal
    });
    if (!response.ok) throw new Error(`Failed to cache video: ${response.status}`);
    return response.blob();
}
function $81c075d4e387c3b2$export$231fb4f38ce67ae9() {
    const [state, dispatch] = (0, $7pfQ9.useReducer)($81c075d4e387c3b2$var$videoReducer, $81c075d4e387c3b2$var$initialState);
    const [cachedVideoUrl, setCachedVideoUrl] = (0, $7pfQ9.useState)(null);
    const [searchParams] = (0, $690f0550d25c36bf$export$f1a78c17382fe22a)();
    const urlHash = searchParams.get("h");
    const videoPreviewUrl = urlHash ? `https://holobooth.hypervsn.com/video/${urlHash}.mp4` : null;
    (0, $7pfQ9.useEffect)(()=>{
        if (videoPreviewUrl) {
            dispatch({
                type: "HASH_CHANGED"
            });
            return;
        }
        dispatch({
            type: "HASH_MISSING"
        });
    }, [
        videoPreviewUrl
    ]);
    (0, $7pfQ9.useEffect)(()=>{
        if (!state.cachedVideoBlob) {
            setCachedVideoUrl(null);
            return;
        }
        const objectUrl = window.URL.createObjectURL(state.cachedVideoBlob);
        setCachedVideoUrl(objectUrl);
        return ()=>{
            window.URL.revokeObjectURL(objectUrl);
        };
    }, [
        state.cachedVideoBlob
    ]);
    (0, $7pfQ9.useEffect)(()=>{
        if (!videoPreviewUrl) return;
        const controller = new AbortController();
        let retryTimeoutId = null;
        const loadVideo = ()=>{
            dispatch({
                type: "CACHE_STARTED"
            });
            $81c075d4e387c3b2$var$fetchVideoBlob(videoPreviewUrl, {
                signal: controller.signal
            }).then((blob)=>{
                if (controller.signal.aborted) return;
                dispatch({
                    type: "VIDEO_READY",
                    blob: blob
                });
            }).catch((error)=>{
                if (controller.signal.aborted) return;
                console.error("Error loading video:", error);
                dispatch({
                    type: "VIDEO_PENDING"
                });
                retryTimeoutId = setTimeout(loadVideo, 10000);
            });
        };
        loadVideo();
        return ()=>{
            controller.abort();
            if (retryTimeoutId) clearTimeout(retryTimeoutId);
        };
    }, [
        videoPreviewUrl
    ]);
    const page = state.status === $81c075d4e387c3b2$var$VIDEO_STATE.MISSING_HASH ? "empty" : state.status === $81c075d4e387c3b2$var$VIDEO_STATE.PROCESSING ? "processing" : "default";
    return {
        cachedVideoBlob: state.cachedVideoBlob,
        cachedVideoUrl: cachedVideoUrl,
        isCaching: state.isCaching,
        isLoading: state.status === $81c075d4e387c3b2$var$VIDEO_STATE.CHECKING,
        page: page,
        urlHash: urlHash,
        videoPreviewUrl: videoPreviewUrl
    };
}


function $f056666ea3ba6e49$export$86fbec116b87613f() {
    const [isPreviewReady, setPreviewReady] = (0, $7pfQ9.useState)(false);
    const { cachedVideoBlob: cachedVideoBlob, cachedVideoUrl: cachedVideoUrl, isCaching: isCaching, isLoading: isLoading, page: page, urlHash: urlHash, videoPreviewUrl: videoPreviewUrl } = (0, $81c075d4e387c3b2$export$231fb4f38ce67ae9)();
    const handleShareVideo = async ()=>{
        return (0, $67e77fe9cca1ad68$export$6436779be3fc19da)(urlHash, cachedVideoBlob);
    };
    if (isLoading) return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $f0774b9dfd5fb980$export$2e2bcd8739ae039), {});
    const isDownloadDisabled = page !== "default" || !isPreviewReady || isCaching;
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $ee37356223c3448b$export$ffb0004e005737fa), {
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)((0, $d357f58ff1306473$export$2e2bcd8739ae039), {
            children: [
                !(page === "empty") && page === "default" && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $7d324f2ffc1020f7$export$2e2bcd8739ae039), {
                    page: page,
                    videoUrl: videoPreviewUrl || cachedVideoUrl,
                    onPreviewReadyChange: setPreviewReady
                }),
                page === "default" && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $7b52c13f12b5f4d4$export$2e2bcd8739ae039), {
                    shareVideo: handleShareVideo,
                    isCaching: isCaching,
                    isDownloadDisabled: isDownloadDisabled
                }),
                page === "processing" && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $34713ed227684cb4$export$2e2bcd8739ae039), {}),
                page === "empty" && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $12877f5c77f60f70$export$2e2bcd8739ae039), {})
            ]
        })
    });
}


var $d0f2c3d3121bd26b$exports = {};
$d0f2c3d3121bd26b$exports = JSON.parse("{\"name\":\"demo\",\"version\":\"0.12.5\",\"scripts\":{\"test\":\"echo \\\"Error: no test specified\\\" && exit 1\",\"d\":\"parcel src/index.html --https --host 0.0.0.0\",\"build\":\"parcel build src/index.js --dist-dir build\",\"b\":\"yarn remove-zip & yarn build && yarn zip\",\"remove-zip\":\"rm *.zip\",\"zip\":\"zip -r build.zip build && rm -r build\",\"build:prod\":\"parcel build src/index.html --dist-dir ./build\"},\"browserslist\":[\"last 2 ChromeAndroid versions\",\"last 2 iOS major versions\"],\"keywords\":[],\"author\":\"HYPERVSN\",\"license\":\"ISC\",\"description\":\"\",\"packageManager\":\"yarn@4.9.2\",\"dependencies\":{\"@emotion/react\":\"^11.14.0\",\"@rive-app/react-canvas\":\"^4.28.4\",\"motion\":\"^12.38.0\",\"react\":\"^19.2.6\",\"react-dom\":\"^19.2.6\",\"react-router\":\"^7.15.0\",\"react-router-dom\":\"^7.15.0\"},\"devDependencies\":{\"@babel/core\":\"^7.29.0\",\"@emotion/babel-plugin\":\"^11.13.5\",\"@parcel/reporter-bundle-analyzer\":\"^2.16.4\",\"@parcel/transformer-svg-jsx\":\"^2.16.4\",\"parcel\":\"^2.16.4\"},\"alias\":{\"process\":false}}");


const $151a08da3f096b3b$var$getVersionWithEmoji = (version)=>{
    const fruits = [
        "\uD83C\uDF4E",
        "\uD83C\uDF4C",
        "\uD83C\uDF52",
        "\uD83C\uDF47",
        "\uD83C\uDF49",
        "\uD83C\uDF4A",
        "\uD83C\uDF4B",
        "\uD83C\uDF53",
        "\uD83E\uDD5D",
        "\uD83C\uDF4D"
    ];
    const lastDigit = parseInt(version.split(".").pop(), 10);
    const emoji = fruits[lastDigit % 10];
    return `${emoji}  ${version}`;
};
const $151a08da3f096b3b$var$version = (0, (/*@__PURE__*/$parcel$interopDefault($d0f2c3d3121bd26b$exports))).version;
console.log($151a08da3f096b3b$var$getVersionWithEmoji($151a08da3f096b3b$var$version));
const $151a08da3f096b3b$var$container = document.getElementById("app");
const $151a08da3f096b3b$var$root = (0, $f8a33d11906b9b49$exports.createRoot)($151a08da3f096b3b$var$container);
$151a08da3f096b3b$var$root.render(/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $690f0550d25c36bf$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $f056666ea3ba6e49$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=build.72f255cd.js.map
